import React, { useContext, useEffect, useState } from "react";
import { LuUpload } from "react-icons/lu";
import { MdAddBox } from "react-icons/md";
import { IoLanguage } from "react-icons/io5";
import { FaUserTie } from "react-icons/fa";
import { PiBagFill } from "react-icons/pi";
import { HiLightBulb } from "react-icons/hi";
import { MdAppRegistration } from "react-icons/md";
import { IoShareSocialSharp } from "react-icons/io5";
import { RiMedal2Line, RiNotificationBadgeFill } from "react-icons/ri";
import { MdModeEditOutline } from "react-icons/md";
import { MdDelete } from "react-icons/md";
import { MdSave } from "react-icons/md";
import { MdAddAPhoto } from "react-icons/md";
import { FiEdit } from "react-icons/fi";
import { LuTrash } from "react-icons/lu";
import ProfileInfoEditCard from "../components/Cards/ProfileInfoEditCard";
import ProfileInfoAddCard from "../components/Cards/ProfileInfoAddCard";
import toast from "react-hot-toast";
import { BsFiletypePdf } from "react-icons/bs";
import { IoIosInformationCircleOutline } from "react-icons/io";
import { RiVideoFill } from "react-icons/ri";
import { MdAddToPhotos } from "react-icons/md";
import { FaGraduationCap } from "react-icons/fa6";
import CommonContext from "../hooks/CommonContext";
import VideoPlayer from "../components/VideoJS/VideoPlayer";
import Autocomplete from "react-google-autocomplete";
import axiosInstance from "../services/api/axiosInstance";
import PhoneInput from "react-phone-input-2";
import Joyride, { STATUS } from 'react-joyride';
import { FaAngleDoubleUp } from "react-icons/fa";
import CreatableSelect from 'react-select/creatable';
import Cookie from "js-cookie"
import { TfiMedallAlt } from "react-icons/tfi";
import { BiMedal } from "react-icons/bi";
import Select from "react-dropdown-select";
import JsonData from "utils/JsonData";


const Profile = () => {
  const {
    profilePicture,
    setProfilePicture,
    setDisableProfilePictureDelete,
    setIsProfilePictureUploaded
  } = useContext(CommonContext);
  const { jsonOnly } = JsonData();

  // JOYRIDE
  const steps = [
    {
      target: 'body',
      content: <div className="text-center">
        <h4 className='fw-bold mb-4'>Welcome to your profile section</h4>
        <p>Manage your information, preferences, and showcase your skills to enhance your job search experience.</p>
      </div>,
      placement: "center"
    },
    {
      target: '.new-upload-resume-card',
      content: 'Upload your resume to automatically fill in your profile information, saving you time and effort.',
      placement: "bottom"
    },
    {
      target: '#preferenceCard',
      content: "Add your preferences so we can match you with jobs that align perfectly with what you're looking for!",
      placement: "bottom"
    },
  ];
  const [run, setRun] = useState(false);

  useEffect(() => {
    setRun(true);
  }, []);

  const handleJoyrideCallback = (data) => {
    const { status } = data;

    if ([STATUS.SKIPPED, STATUS.FINISHED].includes(status)) {
      // Remove a specific cookie
      Cookie.remove("isFirstVisitProfile");

    }
  };

  // Safari Browser 

  function isSafari() {
    const ua = navigator.userAgent.toLowerCase();
    return ua.includes('safari') && !ua.includes('chrome') && !ua.includes('android');
  }

  const [isSafariBrowser, setIsSafariBrowser] = useState(false);

  useEffect(() => {
    setIsSafariBrowser(isSafari());
  }, []);

  const [mobileScreen, setMobileScreen] = useState(window.innerWidth)
  const [mode_of_communication, set_mode_of_communication] = useState(jsonOnly?.mode_of_communication)
  const [profilePageAllContent, setProfilePageAllContent] = useState(false);
  const [aboutContent, setAboutContent] = useState("");
  const [aboutEditIcon, setAboutEditIcon] = useState(false);
  const [additionalInformationData, setAdditionalInformationData] = useState(
    []
  );
  const [additionalInformationInputs, setAdditionalInformationInputs] = useState({
    additionalInfoTitle: "",
    additionalInfoDescription: "",
  });
  const [maxMonth, setMaxMonth] = useState("");
  const [uploadedVideoFile, setUploadedVideoFile] = useState("");
  const [isVideoUploaded, setIsVideoUploaded] = useState(false)
  const [videoUploading, setVideoUploading] = useState(false)
  const [videoDeletingLoading, setVideoDeletingLoading] = useState(false)
  const [videoUploadedPlaceholder, setVideoUploadedPlaceholder] = useState(true)
  const [videoFullyUploaded, setVideoFullyUploaded] = useState(false)
  const [responseLoading, setResponseLoading] = useState(false);
  const [editAdditionalInformationInputs, setEditAdditionalInformationInputs] =
    useState({
      id: 0,
      additionalInfoTitle: "",
      additionalInfoDescription: "",
    });
  const [expertNotes, setExpertNotes] = useState(
    "If you have a premium account, schedule a call with the 2nd Careers team from your profile. Based on your discussion with experts, you will receive expert capture which can be published to the employers upon your consent"
  );
  const [preferenceContent, setPreferenceContent] = useState("");
  const [preferenceEditIcon, setPreferenceEditIcon] = useState(false);
  const [profilePageRefresh, setProfilePageRefresh] = useState(false);
  const [resumeUploaded, setResumeUploaded] = useState(false);
  const [uploadedResumeFile, setUploadedResumeFile] = useState(null);
  const [resumeName, setResumeName] = useState("");
  const [resumeUploadedDate, setResumeUploadedDate] = useState("");
  const [displayMonth, setDisplayMonth] = useState("");
  const [progressPercentage, setProgressPercentage] = useState(null);
  const [fileUploadLoading, setFileUploadLoading] = useState(false);
  const [deleteResumeLoading, setDeleteResumeLoading] = useState(false)
  const [selectedSkillValue, setSelectedSkillValue] = useState(null);
  const [selectedLanguageValue, setSelectedLanguageValue] = useState(null);
  const [personalDetails, setPersonalDetails] = useState({
    firstName: "",
    lastName: "",
    profilePercentage: "",
    dateOfBirth: "",
    email: "",
    phone: "",
    address: "",
    city: "",

  });
  const [isCurrentlyWorking, setIsCurrentlyWorking] = useState(false)
  const [editIsCurrentlyWorking, setEditIsCurrentlyWorking] = useState(false)
  const [countryCode, setCountryCode] = useState('us')
  const [dialCode, setDialCode] = useState("")
  const [companyLocation, setCompanyLocation] = useState({
    city: "",
    country: "",
  });
  const [editCompanyLocation, setEditCompanyLocation] = useState({
    city: "",
    country: "",
  });
  const [currentPlan, setCurrentPlan] = useState(false)


  // Add experience location
  const [editExperienceLocation, setEditExperienceLocation] = useState({
    city: "",
    country: "",
  });
  const [showingExperienceLocation, setShowingExperienceLocation] = useState("")
  const handleExperienceLocation = (selectedLocation) => {
    if (selectedLocation.length === 5) {
      setEditExperienceLocation({
        city: selectedLocation[0].long_name,
        country: selectedLocation[selectedLocation.length - 2].long_name,
      });
      setShowingExperienceLocation(`${selectedLocation[0].long_name} , ${selectedLocation[selectedLocation.length - 2].long_name}`)
    } else if (selectedLocation) {
      setEditExperienceLocation({
        city: selectedLocation[0].long_name,
        country: selectedLocation[selectedLocation.length - 1].long_name,
      });
      setShowingExperienceLocation(`${selectedLocation[0].long_name} , ${selectedLocation[selectedLocation.length - 1].long_name}`)
    }
  };


  // Add education location
  const [editEducationLocation, setEditEducationLocation] = useState({
    city: "",
    country: "",
  });
  const [showingEducationLocation, setShowingEducationLocation] = useState("")

  const handleEducationLocation = (selectedLocation) => {
    if (selectedLocation.length === 5) {
      setEditEducationLocation({
        city: selectedLocation[0].long_name,
        country: selectedLocation[selectedLocation.length - 2].long_name,
      });
      setShowingEducationLocation(`${selectedLocation[0].long_name} , ${selectedLocation[selectedLocation.length - 2].long_name}`)
    } else if (selectedLocation) {
      setEditEducationLocation({
        city: selectedLocation[0].long_name,
        country: selectedLocation[selectedLocation.length - 1].long_name,
      });
      setShowingEducationLocation(`${selectedLocation[0].long_name} , ${selectedLocation[selectedLocation.length - 1].long_name}`)
    }
  };


  const [showingLocation, setShowingLocation] = useState("")
  const [experienceInputs, setExperienceInputs] = useState({
    jobTitle: "",
    companyName: "",
    location: "",
    startMonthAndYear: "",
    endMonthAndYear: "",
    experienceDescription: "",
  });
  const [educationInputs, setEducationInputs] = useState({
    degree: "",
    fieldOfStudy: "",
    institution: "",
    instituteLocation: "",
    educationStartMonthAndYear: "",
    educationEndMonthAndYear: "",
  });
  const [experienceFieldsFilled, setExperienceFieldsFilled] = useState(false);
  const [educationFieldsFilled, setEducationFieldsFilled] = useState(false);
  const [selectedLanguageId, setSelectedLanguageId] = useState(null);
  const [socialMediaArray, setSocialMediaArray] = useState([]);
  const [skillsKnown, setSkillsKnown] = useState([]);
  const [expertNotesFromResponse, setExpertNotesFromResponse] = useState("");
  const [checkExpertNotes, setCheckExpertNotes] = useState(false);

  const [updatedSkillsObj, setUpdatedSkillsObj] = useState({
    skillName: "",
    skillLevel: "",
  });
  const [languagesObj, setLanguagesObj] = useState({
    languageName: "",
    languageLevel: "",
  });
  const [updatedLanguagesObj, setUpdatedLanguagesObj] = useState({
    languageName: "",
    languageLevel: "",
  });

  const handleAdditionalInformationInputs = (e) => {
    setAdditionalInformationInputs({
      ...additionalInformationInputs,
      [e.target.name]: e.target.value,
    });
  };

  const handleEditAdditionalInformationInputs = (e) => {
    setEditAdditionalInformationInputs({
      ...editAdditionalInformationInputs,
      [e.target.name]: e.target.value,
    });
  };


  // Add Additional Information
  const handleAdditionalInformationAdd = async () => {
    if (
      additionalInformationInputs.additionalInfoTitle === "" ||
      additionalInformationInputs.additionalInfoDescription === ""
    ) {
      toast("Please enter all the fields", {
        icon: (
          <IoIosInformationCircleOutline className="fs-1 brand-color me-1" />
        ),
      });
    } else {


      const additionalInfoParams = {
        title: additionalInformationInputs.additionalInfoTitle,
        description: additionalInformationInputs.additionalInfoDescription,
      };

      try {

        const response = await axiosInstance.post("/update_professional_additional_info", additionalInfoParams)

        if (response.data.error_code === 0) {
          document.getElementById("addAdditionalInformationClose").click();
          setAdditionalInformationInputs({
            additionalInfoTitle: "",
            additionalInfoDescription: "",
          });
          setProfilePageRefresh(!profilePageRefresh);
        }

      } catch (err) {
        console.log(err);
      }
    }
  };

  // Edit Additional Information
  const handleAdditionalInformationEdit = async (e, infoId) => {
    const result = additionalInformationData.filter((value, id) => {
      return value.id === infoId;
    });
    setEditAdditionalInformationInputs({
      id: infoId,
      additionalInfoTitle: result[0].title,
      additionalInfoDescription: result[0].description,
    });
  };

  // Additional Info update
  const handleAdditionalInformationUpdate = async (e, id, saveClick) => {
    if (
      editAdditionalInformationInputs.additionalInfoTitle === "" ||
      editAdditionalInformationInputs.additionalInfoDescription === ""
    ) {
      toast("Please enter all the fields", {
        icon: (
          <IoIosInformationCircleOutline className="fs-1 brand-color me-1" />
        ),
      });
    } else {


      const additionalInfoParams = {
        info_id: id,
        title: editAdditionalInformationInputs.additionalInfoTitle,
        description: editAdditionalInformationInputs.additionalInfoDescription,
      };
      try {
        const response = await axiosInstance.post("/update_professional_additional_info", additionalInfoParams)
        if (response.data.error_code === 0) {
          if (saveClick === "Save") {
            document.getElementById("updateAdditionalInformationClose").click();
          }
          setProfilePageRefresh(!profilePageRefresh);
        }
      } catch (err) {
        console.log(err);
      }
    }
  };

  // Delete Info edit
  const handleAdditionalInformationDelete = async (e, id) => {

    const additionalInfoParams = {
      info_id: id,
    };
    try {
      const response = await axiosInstance.post("/delete_professional_additional_info", additionalInfoParams)
      if (response.data.error_code === 0) {
        setProfilePageRefresh(!profilePageRefresh);
      }
    } catch (err) {
      console.log(err);
    }
  };


  // Handle Updated Skill
  const handleUpdatedSkillName = (skillName) => {
    setUpdatedSkillsObj({ ...updatedSkillsObj, skillName: skillName });
  };

  const handleUpdatedSkillLevel = (skillLevel) => {
    setUpdatedSkillsObj({ ...updatedSkillsObj, skillLevel: skillLevel });
  };


  // Handle Updated Language
  const handleUpdatedLanguageLevel = (languageLevel) => {
    setUpdatedLanguagesObj({
      ...updatedLanguagesObj,
      languageLevel: languageLevel,
    });
  };

  const handleResize = () => {
    const screenWidth = window.innerWidth;
    if (screenWidth < 588) {
      setMobileScreen(screenWidth);
    } else {
      setMobileScreen(null);
    }

  };

  useEffect(() => {
    handleResize()

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    const currentDateFun = () => {
      const objectDate = new Date();
      let day = objectDate.getDate();
      day = day < 10 ? `0${day}` : `${day}`;

      let month = objectDate.getMonth();
      month = month < 10 ? `0${month + 1}` : `${month + 1}`;

      let year = objectDate.getFullYear();

      let format = `${year}-${month}`;

      setMaxMonth(format);
    };

    currentDateFun();

    getProfileDetails();
  }, [profilePageRefresh]);

  const getProfileDetails = async () => {
    try {
      const fd = new FormData()
      fd.append("from_profile_dashboard", Cookie.get("isFirstVisitProfileParsing"))

      const response = await axiosInstance.post("/professional_profile_dashboard", fd)
      if (response.data.error_code === 0) {
        setProfilePageAllContent(true);
        setCompanyLocation({
          city: response.data.data.city,
          country: response.data.data.country,
        });

        let selected_gender = jsonOnly?.gender?.filter((v) => v?.label === response.data.data.gender);
        let selected_location_willing_to_relocate = response.data.data.willing_to_relocate ? [{ value: 1, label: "Yes, I am willing to relocate" }, { value: 2, label: "No, I am not willing to relocate" }]?.filter((v) => v?.label?.includes(response.data.data.willing_to_relocate)) : [];
        let selected_industry = jsonOnly?.industry_sector?.filter((v) => v?.label === response.data.data.industry_sector);
        let selected_job_type = jsonOnly?.register_job_type?.filter((v) => v?.label === response.data.data.job_type);
        let selected_location_preference = jsonOnly?.location_preference?.filter((v) => v?.label === response.data.data.location_preference);
        let selected_sector = jsonOnly?.sectors?.filter((v) => v?.label === response.data.data.sector);
        let selected_functional_specialization = jsonOnly?.functional_specialization?.filter((v) => response.data.data.functional_specification?.split(",")?.includes(v?.label));
        let selected_mode_of_communication = jsonOnly?.mode_of_communication?.filter((v) => response.data.data.mode_of_communication?.split(",")?.includes(v?.label));

        let update_mode_of_communication;
        if (!response.data.data.mode_of_communication) {
          update_mode_of_communication = mode_of_communication
        } else {
          if (!selected_mode_of_communication?.length && response.data.data.mode_of_communication) {
            update_mode_of_communication = mode_of_communication?.map((v) => {
              return v?.label === "Others" ? { ...v, disabled: false } : { ...v, disabled: true }
            })

            selected_mode_of_communication = [{
              value: 5,
              label: "Others",
              disabled: false
            }]
          } else {
            update_mode_of_communication = mode_of_communication?.map((v) => {
              return v?.label !== "Others" ? { ...v, disabled: false } : { ...v, disabled: true }
            })
          }
        }
        set_mode_of_communication(update_mode_of_communication)

        if (!selected_functional_specialization?.length && response.data.data.functional_specification) {
          selected_functional_specialization = [{
            value: 6,
            label: "Others",
            disabled: false
          }]
        }

        setPersonalDetails({
          firstName: response.data.data.first_name,
          lastName: response.data.data.last_name,
          profilePercentage: response.data.data.profile_percentage,
          dateOfBirth: response.data.data.dob,
          email: response.data.data.email_id,
          phone: response.data.data.contact_number,
          address: response.data.data.country,
          city: response.data.data.city,

          gender: selected_gender,
          industry_sector: selected_industry,
          functional_specialization: selected_functional_specialization,
          functional_specialization_others: selected_functional_specialization?.length === 1 ? selected_functional_specialization[0]?.label === "Others" ? response.data.data.functional_specification : '' : '',
          job_type: selected_job_type,
          location_preference: selected_location_preference,
          mode_of_communication: selected_mode_of_communication,
          mode_of_communication_others: selected_mode_of_communication?.length === 1 ? selected_mode_of_communication[0]?.label === "Others" ? response.data.data.mode_of_communication : '' : '',
          sector: selected_sector,
          willing_to_relocate: selected_location_willing_to_relocate,
          years_of_experience: response.data.data.years_of_experience,
        });
        setDialCode(response.data.data.country_code)
        setAboutContent(response.data.data.about);
        setPreferenceContent(response.data.data.preferences);
        setExperienceDataArray(response.data.data.experience);
        setEducationDataArray(response.data.data.education);
        setLanguagesKnown(response.data.data.languages);
        setSkillsKnown(response.data.data.skills);
        setSocialMediaArray(response.data.data.social_link);
        setAdditionalInformationData(response.data.data.additional_info);
        setExperienceFieldsFilled(false);
        setEducationFieldsFilled(false);
        setProfilePicture(`${process.env.REACT_APP_SECOND_CAREERS_CDN}${response.data.data.profile_image}`)
        setUploadedVideoFile(`${process.env.REACT_APP_SECOND_CAREERS_CDN}${response.data.data.video_name}`)
        setCurrentPlan(response.data.data.pricing_category)
        setExpertNotesFromResponse(response.data.data.expert_notes);
        setResumeName(response.data.data.resume_name)
        if ((response.data.data.profile_image).includes("default_profile_picture.png")) {
          setDisableProfilePictureDelete(true)
        } else {
          setDisableProfilePictureDelete(false)
        }

        if (response.data.data.show_to_employer === "Y") {
          setCheckExpertNotes(true)
        } else {
          setCheckExpertNotes(false)
        }

        if (response.data.message === "It looks like the document you uploaded isn't a resume. Please upload a resume so we can create your 2C profile") {
          toast.error("It looks like the document you uploaded isn't a resume. Please upload a resume so we can create your 2C profile")
        }

        if (Cookie.get("isFirstVisitProfileParsing")) {
          Cookie.remove("isFirstVisitProfileParsing")
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  const languagesListArray = [
    { "value": 1, "label": "Abkhazian" },
    { "value": 2, "label": "Afar" },
    { "value": 3, "label": "Afrikaans" },
    { "value": 4, "label": "Akan" },
    { "value": 5, "label": "Albanian" },
    { "value": 6, "label": "Amharic" },
    { "value": 7, "label": "Arabic" },
    { "value": 8, "label": "Aragonese" },
    { "value": 9, "label": "Armenian" },
    { "value": 10, "label": "Assamese" },
    { "value": 11, "label": "Avaric" },
    { "value": 12, "label": "Avestan" },
    { "value": 13, "label": "Aymara" },
    { "value": 14, "label": "Azerbaijani" },
    { "value": 15, "label": "Bambara" },
    { "value": 16, "label": "Bashkir" },
    { "value": 17, "label": "Basque" },
    { "value": 18, "label": "Belarusian" },
    { "value": 19, "label": "Bengali" },
    { "value": 20, "label": "Bihari" },
    { "value": 21, "label": "Bislama" },
    { "value": 22, "label": "Bosnian" },
    { "value": 23, "label": "Breton" },
    { "value": 24, "label": "Bulgarian" },
    { "value": 25, "label": "Burmese" },
    { "value": 26, "label": "Catalan" },
    { "value": 27, "label": "Central Khmer" },
    { "value": 28, "label": "Chamorro" },
    { "value": 29, "label": "Chechen" },
    { "value": 30, "label": "Chichewa" },
    { "value": 31, "label": "Chinese" },
    { "value": 32, "label": "Church Slavic" },
    { "value": 33, "label": "Chuvash" },
    { "value": 34, "label": "Cornish" },
    { "value": 35, "label": "Corsican" },
    { "value": 36, "label": "Cree" },
    { "value": 37, "label": "Croatian" },
    { "value": 38, "label": "Czech" },
    { "value": 39, "label": "Danish" },
    { "value": 40, "label": "Divehi" },
    { "value": 41, "label": "Dutch" },
    { "value": 42, "label": "Dzongkha" },
    { "value": 43, "label": "English" },
    { "value": 44, "label": "Esperanto" },
    { "value": 45, "label": "Estonian" },
    { "value": 46, "label": "Ewe" },
    { "value": 47, "label": "Faroese" },
    { "value": 48, "label": "Fijian" },
    { "value": 49, "label": "Finnish" },
    { "value": 50, "label": "French" },
    { "value": 51, "label": "Fulah" },
    { "value": 52, "label": "Galician" },
    { "value": 53, "label": "Ganda" },
    { "value": 54, "label": "Georgian" },
    { "value": 55, "label": "German" },
    { "value": 56, "label": "Greek" },
    { "value": 57, "label": "Guaraní" },
    { "value": 58, "label": "Gujarati" },
    { "value": 59, "label": "Haitian Creole" },
    { "value": 60, "label": "Hausa" },
    { "value": 61, "label": "Hebrew" },
    { "value": 62, "label": "Herero" },
    { "value": 63, "label": "Hindi" },
    { "value": 64, "label": "Hiri Motu" },
    { "value": 65, "label": "Hungarian" },
    { "value": 66, "label": "Icelandic" },
    { "value": 67, "label": "Ido" },
    { "value": 68, "label": "Igbo" },
    { "value": 69, "label": "Indonesian" },
    { "value": 70, "label": "Interlingua" },
    { "value": 71, "label": "Interlingue" },
    { "value": 72, "label": "Inuktitut" },
    { "value": 73, "label": "Inupiaq" },
    { "value": 74, "label": "Irish" },
    { "value": 75, "label": "Italian" },
    { "value": 76, "label": "Japanese" },
    { "value": 77, "label": "Javanese" },
    { "value": 78, "label": "Kalaallisut" },
    { "value": 79, "label": "Kannada" },
    { "value": 80, "label": "Kanuri" },
    { "value": 81, "label": "Kashmiri" },
    { "value": 82, "label": "Kazakh" },
    { "value": 83, "label": "Kikuyu" },
    { "value": 84, "label": "Kinyarwanda" },
    { "value": 85, "label": "Kirghiz" },
    { "value": 86, "label": "Komi" },
    { "value": 87, "label": "Kongo" },
    { "value": 88, "label": "Korean" },
    { "value": 89, "label": "Kuanyama" },
    { "value": 90, "label": "Kurdish" },
    { "value": 91, "label": "Lao" },
    { "value": 92, "label": "Latin" },
    { "value": 93, "label": "Latvian" },
    { "value": 94, "label": "Limburgish" },
    { "value": 95, "label": "Lingala" },
    { "value": 96, "label": "Lithuanian" },
    { "value": 97, "label": "Luba-Katanga" },
    { "value": 98, "label": "Luxembourgish" },
    { "value": 99, "label": "Macedonian" },
    { "value": 100, "label": "Malagasy" },
    { "value": 101, "label": "Malay" },
    { "value": 102, "label": "Malayalam" },
    { "value": 103, "label": "Maltese" },
    { "value": 104, "label": "Manx" },
    { "value": 105, "label": "Maori" },
    { "value": 106, "label": "Marathi" },
    { "value": 107, "label": "Marshallese" },
    { "value": 108, "label": "Mongolian" },
    { "value": 109, "label": "Nauru" },
    { "value": 110, "label": "Navajo" },
    { "value": 111, "label": "Ndonga" },
    { "value": 112, "label": "Nepali" },
    { "value": 113, "label": "North Ndebele" },
    { "value": 114, "label": "Northern Sami" },
    { "value": 115, "label": "Norwegian" },
    { "value": 116, "label": "Norwegian Bokmål" },
    { "value": 117, "label": "Norwegian Nynorsk" },
    { "value": 118, "label": "Occitan" },
    { "value": 119, "label": "Ojibwe" },
    { "value": 120, "label": "Oriya" },
    { "value": 121, "label": "Oromo" },
    { "value": 122, "label": "Ossetian" },
    { "value": 123, "label": "Pali" },
    { "value": 124, "label": "Panjabi" },
    { "value": 125, "label": "Persian" },
    { "value": 126, "label": "Polish" },
    { "value": 127, "label": "Portuguese" },
    { "value": 128, "label": "Pashto" },
    { "value": 129, "label": "Quechua" },
    { "value": 130, "label": "Romanian" },
    { "value": 131, "label": "Romansh" },
    { "value": 132, "label": "Rundi" },
    { "value": 133, "label": "Russian" },
    { "value": 134, "label": "Samoan" },
    { "value": 135, "label": "Sango" },
    { "value": 136, "label": "Sanskrit" },
    { "value": 137, "label": "Sardinian" },
    { "value": 138, "label": "Scottish Gaelic" },
    { "value": 139, "label": "Serbian" },
    { "value": 140, "label": "Shona" },
    { "value": 141, "label": "Sichuan Yi" },
    { "value": 142, "label": "Sindhi" },
    { "value": 143, "label": "Sinhalese" },
    { "value": 144, "label": "Slovak" },
    { "value": 145, "label": "Slovenian" },
    { "value": 146, "label": "Somali" },
    { "value": 147, "label": "Sotho, Southern" },
    { "value": 148, "label": "South Ndebele" },
    { "value": 149, "label": "Spanish" },
    { "value": 150, "label": "Sundanese" },
    { "value": 151, "label": "Swahili" },
    { "value": 152, "label": "Swati" },
    { "value": 153, "label": "Swedish" },
    { "value": 154, "label": "Tagalog" },
    { "value": 155, "label": "Tahitian" },
    { "value": 156, "label": "Tajik" },
    { "value": 157, "label": "Tamil" },
    { "value": 158, "label": "Tatar" },
    { "value": 159, "label": "Telugu" },
    { "value": 160, "label": "Thai" },
    { "value": 161, "label": "Tibetan" },
    { "value": 162, "label": "Tigrinya" },
    { "value": 163, "label": "Tonga" },
    { "value": 164, "label": "Tsonga" },
    { "value": 165, "label": "Tswana" },
    { "value": 166, "label": "Turkish" },
    { "value": 167, "label": "Turkmen" },
    { "value": 168, "label": "Twi" },
    { "value": 169, "label": "Uighur" },
    { "value": 170, "label": "Ukrainian" },
    { "value": 171, "label": "Urdu" },
    { "value": 172, "label": "Uzbek" },
    { "value": 173, "label": "Venda" },
    { "value": 174, "label": "Vietnamese" },
    { "value": 175, "label": "Volapük" },
    { "value": 176, "label": "Walloon" },
    { "value": 177, "label": "Welsh" },
    { "value": 178, "label": "Western Frisian" },
    { "value": 179, "label": "Wolof" },
    { "value": 180, "label": "Xhosa" },
    { "value": 181, "label": "Yiddish" },
    { "value": 182, "label": "Yoruba" },
    { "value": 183, "label": "Zhuang" },
    { "value": 184, "label": "Zulu" }
  ]

  const [languageLevelData, setLanguageLevelData] = useState([
    {
      id: 1,
      languageLevel: "Elementary Proficiency",
    },
    {
      id: 2,
      languageLevel: "Limited Working Proficiency",
    },
    {
      id: 3,
      languageLevel: "Professional Working Proficiency",
    },
    {
      id: 4,
      languageLevel: "Full Professional Proficiency",
    },
    {
      id: 5,
      languageLevel: "Native / Bilingual Proficiency",
    },
  ]);

  const [languagesKnown, setLanguagesKnown] = useState([]);
  const [editClick, setEditClick] = useState(false);
  const [experienceDataArray, setExperienceDataArray] = useState([]);

  // Edit experience with id
  const [editExperienceData, setEditExperienceData] = useState({
    id: "",
    jobTitle: "",
    companyName: "",
    location: "",
    startMonthAndYear: "",
    endMonthAndYear: "",
    experienceDescription: "",
  });

  const handleEditExperienceInputs = (e) => {
    setEditExperienceData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const handleEditIsCurrentlyWorking = (e) => {
    setEditIsCurrentlyWorking(!editIsCurrentlyWorking)
    if (editIsCurrentlyWorking !== true) {
      setEditExperienceData((prevState) => ({
        ...prevState,
        endMonthAndYear: "Present",
      }));
    } else {
      setEditExperienceData((prevState) => ({
        ...prevState,
        endMonthAndYear: ""
      }));
    }
  }


  // Edit education with id
  const [editEducationData, setEditEducationData] = useState({
    id: "",
    degree: "",
    fieldOfStudy: "",
    institution: "",
    instituteLocation: "",
    educationStartMonthAndYear: "",
    educationEndMonthAndYear: "",
  });

  const handleEditEducationInputs = (e) => {
    setEditEducationData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const [editSocialMediaData, setEditSocialMediaData] = useState({
    id: "",
    socialMediaName: "",
    url: "",
  });

  const handleEditSocialMediaData = (e) => {
    setEditSocialMediaData({
      ...editSocialMediaData,
      [e.target.name]: e.target.value,
    });
  };

  const [educationDataArray, setEducationDataArray] = useState([]);

  const handlePhoneInput = (e, phone, contactno) => {
    setPersonalDetails((prevState) => ({
      ...prevState,
      phone: e.slice(phone.dialCode.length),
      countryCode: phone.dialCode,
    }));

    setCountryCode(phone.dialCode)
    setDialCode(phone.dialCode)

  };

  const skillsData = [
    {
      id: 1,
      skillName: "Agile Methodologies",
    },
    {
      id: 2,
      skillName: "Algorithm Design",
    },
    {
      id: 3,
      skillName: "Analytics",
    },
    {
      id: 4,
      skillName: "Application Programming Interfaces (APIs)",
    },
    {
      id: 5,
      skillName: "Budgeting",
    },
    {
      id: 6,
      skillName: "Business Strategy",
    },
    {
      id: 7,
      skillName: "Change Management",
    },
    {
      id: 8,
      skillName: "Conflict Resolution",
    },
    {
      id: 9,
      skillName: "Contract Management Skills",
    },
    {
      id: 10,
      skillName: "Data Analysis",
    },
    {
      id: 11,
      skillName: "Database Design",
    },
    {
      id: 12,
      skillName: "Debugging",
    },
    {
      id: 13,
      skillName: "Direct Sales",
    },
    {
      id: 14,
      skillName: "Earned Value Management",
    },
    {
      id: 15,
      skillName: "Financial Management",
    },
    {
      id: 16,
      skillName: "Human Resource Management",
    },
    {
      id: 17,
      skillName: "Keyword Research",
    },
    {
      id: 18,
      skillName: "Leadership Skills",
    },
    {
      id: 19,
      skillName: "Market Research",
    },
    {
      id: 20,
      skillName: "Marketing Skills",
    },
    {
      id: 21,
      skillName: "Metrics and KPIs",
    },
    {
      id: 22,
      skillName: "Mobile Application Development",
    },
    {
      id: 23,
      skillName: "Negotiation",
    },
    {
      id: 24,
      skillName: "Operations Management",
    },
    {
      id: 25,
      skillName: "Organizational Development",
    },
    {
      id: 26,
      skillName: "Presentation",
    },
    {
      id: 27,
      skillName: "Process Improvement",
    },
    {
      id: 28,
      skillName: "Product Knowledge",
    },
    {
      id: 29,
      skillName: "Project Management",
    },
    {
      id: 30,
      skillName: "Quality Assurance (QA)",
    },
    {
      id: 31,
      skillName: "Recruiting",
    },
    {
      id: 32,
      skillName: "Revenue Expansion",
    },
    {
      id: 33,
      skillName: "Risk Assessment",
    },
    {
      id: 34,
      skillName: "SaaS Knowledge",
    },
    {
      id: 35,
      skillName: "Sales Strategy and Planning ",
    },
    {
      id: 36,
      skillName: "Sales and Budget Forecasting",
    },
    {
      id: 37,
      skillName: "Salesforce",
    },
    {
      id: 38,
      skillName: "Strategic Planning",
    },
    {
      id: 39,
      skillName: "Supply Chain Management",
    },
    {
      id: 40,
      skillName: "Talent Management",
    },
    {
      id: 41,
      skillName: "Team Leadership",
    },
    {
      id: 42,
      skillName: "Upselling",
    },
  ];

  let skillOptions = [
    {
      "value": 1,
      "label": "Agile Methodologies"
    },
    {
      "value": 2,
      "label": "Algorithm Design"
    },
    {
      "value": 3,
      "label": "Analytics"
    },
    {
      "value": 4,
      "label": "Application Programming Interfaces (APIs)"
    },
    {
      "value": 5,
      "label": "Budgeting"
    },
    {
      "value": 6,
      "label": "Business Strategy"
    },
    {
      "value": 7,
      "label": "Change Management"
    },
    {
      "value": 8,
      "label": "Conflict Resolution"
    },
    {
      "value": 9,
      "label": "Contract Management Skills"
    },
    {
      "value": 10,
      "label": "Data Analysis"
    },
    {
      "value": 11,
      "label": "Database Design"
    },
    {
      "value": 12,
      "label": "Debugging"
    },
    {
      "value": 13,
      "label": "Direct Sales"
    },
    {
      "value": 14,
      "label": "Earned Value Management"
    },
    {
      "value": 15,
      "label": "Financial Management"
    },
    {
      "value": 16,
      "label": "Human Resource Management"
    },
    {
      "value": 17,
      "label": "Keyword Research"
    },
    {
      "value": 18,
      "label": "Leadership Skills"
    },
    {
      "value": 19,
      "label": "Market Research"
    },
    {
      "value": 20,
      "label": "Marketing Skills"
    },
    {
      "value": 21,
      "label": "Metrics and KPIs"
    },
    {
      "value": 22,
      "label": "Mobile Application Development"
    },
    {
      "value": 23,
      "label": "Negotiation"
    },
    {
      "value": 24,
      "label": "Operations Management"
    },
    {
      "value": 25,
      "label": "Organizational Development"
    },
    {
      "value": 26,
      "label": "Presentation"
    },
    {
      "value": 27,
      "label": "Process Improvement"
    },
    {
      "value": 28,
      "label": "Product Knowledge"
    },
    {
      "value": 29,
      "label": "Project Management"
    },
    {
      "value": 30,
      "label": "Quality Assurance (QA)"
    },
    {
      "value": 31,
      "label": "Recruiting"
    },
    {
      "value": 32,
      "label": "Revenue Expansion"
    },
    {
      "value": 33,
      "label": "Risk Assessment"
    },
    {
      "value": 34,
      "label": "SaaS Knowledge"
    },
    {
      "value": 35,
      "label": "Sales and Budget Forecasting"
    },
    {
      "value": 36,
      "label": "Sales Strategy and Planning"
    },
    {
      "value": 37,
      "label": "Salesforce"
    },
    {
      "value": 38,
      "label": "Strategic Planning"
    },
    {
      "value": 39,
      "label": "Supply Chain Management"
    },
    {
      "value": 40,
      "label": "Talent Management"
    },
    {
      "value": 41,
      "label": "Team Leadership"
    },
    {
      "value": 42,
      "label": "Upselling"
    }
  ];

  const [skillsObj, setSkillsObj] = useState({
    skillName: "",
    skillLevel: "",
  });

  const handleUploadResumeClick = () => {
    document.getElementById("input-file").click();
  };

  const handleUploadNewResumeClick = () => {
    document.getElementById("input-file2").click();
  };


  // Resume upload api
  const handleResumeUpload = async (e) => {
    try {
      let file = e.target.files[0];
      if (file.name.includes(".pdf")) {
        setFileUploadLoading(true);
        const formData = new FormData();
        formData.append("file", file);
        formData.append("from_profile_dashboard", false);
        const config = {
          onUploadProgress: function (progressEvent) {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 99) / progressEvent.total
            );
            setProgressPercentage(percentCompleted);
          },
        };
        const response = await axiosInstance.post("/professional_profile_extraction", formData, config)
        if (response.data.error_code === 0) {
          setFileUploadLoading(false);
          setProgressPercentage(0);
          setResumeUploaded(true);
          setResumeName(file.name);
          setUploadedResumeFile(file);
          setResumeUploadedDate(response.data.data.resume_upload_date)
          setProfilePageRefresh(!profilePageRefresh);
          file = "";
          document.getElementById("aiDisclaimer").click()
        } else {
          setFileUploadLoading(false);
        }
      } else {
        toast.error("Unsupported file format. Please upload PDF files only.");
        setFileUploadLoading(false);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleProfilePhotoUpload = async (e) => {

    try {
      const file = e.target.files[0];
      if (
        file.name.includes(".png") ||
        file.name.includes(".jpeg") ||
        file.name.includes(".jpg") ||
        file.name.includes(".PNG") ||
        file.name.includes(".JPEG") ||
        file.name.includes(".JPG") ||
        file.name.includes(".HEIC")
      ) {
        const formData = new FormData();
        formData.append("profile_pic", file);
        setResponseLoading(true);
        const response = await axiosInstance.post("/upload_user_profile_pic", formData)

        if (response.data.error_code === 0) {
          setProfilePicture(`${process.env.REACT_APP_SECOND_CAREERS_CDN}${response.data.data.picture_name}`);
          setResponseLoading(false);
          setIsProfilePictureUploaded(true)
        }
      } else {
        toast.error(
          "Unsupported file format. Please upload .jpeg, .jpg, .png, .JPEG, .JPG, .PNG, .HEIC files only."
        );
        setResponseLoading(false);
        setIsProfilePictureUploaded(false)
      }
    } catch (err) {
      console.log(err);
    }
  };


  // Video upload api
  const handleVideoUpload = async (e) => {
    try {
      setVideoUploadedPlaceholder(false)
      const file = e.target.files[0];
      if (file.name.includes(".mp4")) {
        const formData = new FormData();
        formData.append("intro_video", file);
        setVideoUploading(true)
        const response = await axiosInstance.post("/professional_video_upload", formData)
        if (response.data.error_code === 0) {
          setUploadedVideoFile(`${process.env.REACT_APP_SECOND_CAREERS_CDN}${response.data.data.video_name}`)
          setProfilePageRefresh(!profilePageRefresh)
          setIsVideoUploaded(!isVideoUploaded)
          setVideoUploading(false)
          setVideoFullyUploaded(true)
          setVideoUploadedPlaceholder(false)
        }
      } else {
        setVideoUploading(false)
        setVideoFullyUploaded(false)
        setVideoUploadedPlaceholder(true)
        toast.error("Unsupported file format. Only MP4 video formats are supported.");
      }
    } catch (err) {
      console.log(err);
    }
  };


  // Resume delete api
  const handleResumeDelete = async (e) => {
    try {
      setFileUploadLoading(true);
      setDeleteResumeLoading(true)
      const response = await axiosInstance.get("/delete_user_resume")
      if (response.data.error_code === 0) {
        setFileUploadLoading(false);
        setResumeName("");
        setResumeUploaded(false);
        setDeleteResumeLoading(false)
        setProfilePageRefresh(!profilePageRefresh);
      }
    } catch (err) {
      console.log(err);
    }
  };


  // Personal details edit
  const handlePeronalDetailsEdit = () => {
    setEditClick(!editClick);
    setCountryCode(dialCode)
    setPersonalDetails((prevState) => ({
      ...prevState,
      phone: personalDetails.phone,
    }));
    setEditCompanyLocation({
      city: companyLocation.city,
      country: companyLocation.country,
    });
    setShowingLocation(`${companyLocation.city} , ${companyLocation.country}`)
  };


  // Location change api
  const handleLocation = (selectedLocation) => {
    const countryComponent = selectedLocation.find(component => component.types.includes('country'));
    if (countryComponent) {
      setEditCompanyLocation({
        city: selectedLocation[0].long_name,
        country: countryComponent.long_name,
      });
      setShowingLocation(`${selectedLocation[0].long_name} , ${countryComponent.long_name}`)
    }
  };


  // Personal details save
  const handlePersonalDetailsSave = async () => {
    if (!personalDetails.phone || !showingLocation ||
      !personalDetails?.gender?.length ||
      !personalDetails?.years_of_experience ||
      !personalDetails?.willing_to_relocate?.length ||
      !personalDetails?.functional_specialization?.length ||
      !personalDetails?.sector?.length ||
      !personalDetails?.industry_sector?.length ||
      !personalDetails?.job_type?.length ||
      !personalDetails?.location_preference?.length ||
      !personalDetails?.mode_of_communication?.length
    ) {
      toast("Please fill all the details", {
        icon: (
          <IoIosInformationCircleOutline className="fs-1 brand-color me-1" />
        ),
      })
    }
    else if ((personalDetails?.functional_specialization[0]?.label === "Others" && !personalDetails?.functional_specialization_others) ||
      (personalDetails?.mode_of_communication[0]?.label === "Others" && !personalDetails?.mode_of_communication_others)) {
      toast("Please fill all the details", {
        icon: (
          <IoIosInformationCircleOutline className="fs-1 brand-color me-1" />
        ),
      });
    }
    else {
      const gender = personalDetails?.gender?.length ? personalDetails?.gender[0]?.label : ''
      const willing_to_relocate = personalDetails?.willing_to_relocate[0]?.label
      const functional_specification = personalDetails?.functional_specialization[0]?.label
      const sector = personalDetails?.sector[0]?.label
      const industry_sector = personalDetails?.industry_sector[0]?.label
      const job_type = personalDetails?.job_type[0]?.label
      const work_location_preference = personalDetails?.location_preference[0]?.label
      const mode_of_communi = personalDetails?.mode_of_communication?.map((v) => v?.label)?.join(",")

      const personalDetailsParams = {
        first_name: personalDetails.firstName,
        last_name: personalDetails.lastName,
        country_code: countryCode,
        contact_number: personalDetails.phone,
        country: editCompanyLocation.country,
        city: editCompanyLocation.city,
        gender: gender,
        willing_to_relocate: willing_to_relocate === "Yes, I am willing to relocate" ? "Yes" : "No",
        functional_specification: functional_specification === "Others" ? personalDetails?.functional_specialization_others : functional_specification,
        sector: sector,
        industry_sector: industry_sector,
        job_type: job_type,
        location_preference: work_location_preference,
        mode_of_communication: mode_of_communi === "Others" ? personalDetails?.mode_of_communication_others : mode_of_communi,
        years_of_experience: personalDetails?.years_of_experience
      };

      try {
        const response = await axiosInstance.post("/professional_profile_update", personalDetailsParams)
        if (response.data.error_code === 0) {
          setEditClick(!editClick);
          setProfilePageRefresh(!profilePageRefresh)
        }
      } catch (err) {
        console.log(err);
      }
    }
  };


  // about edit icon
  const handleAboutEditOrSaveIcon = async (e, editOrSave) => {
    if (editOrSave === "Save") {
      if (aboutContent.trim() === "" || aboutContent === "") {
        toast("Please fill the field.", {
          icon: (
            <IoIosInformationCircleOutline className="fs-1 brand-color me-1" />
          ),
        });
        return;
      } else {
        setAboutEditIcon(false);
      }
      const aboutParams = {
        about: aboutContent,
      };
      try {
        const response = await axiosInstance.post("/professional_about_update", aboutParams)
        if (response.data.error_code === 0) {
          setAboutEditIcon(false);
          setProfilePageRefresh(!profilePageRefresh);
        }
      } catch (err) {
        console.log(err);
      }
    } else {
      setAboutEditIcon(true);
    }
  };


  // preference edit icon
  const handlePreferenceEditOrSaveIcon = async (e, editOrSave) => {
    if (editOrSave === "Save") {
      setPreferenceEditIcon(false);
      if (preferenceContent.trim() === "") {
        setPreferenceEditIcon(true);
        toast("Please fill the field.", {
          icon: (
            <IoIosInformationCircleOutline className="fs-1 brand-color me-1" />
          ),
        });
        return;
      } else {
        setPreferenceEditIcon(false);
      }


      const preferenceParams = {
        preferences: preferenceContent,
      };

      try {

        const response = await axiosInstance.post("/professional_preferences_update", preferenceParams)

        if (response.data.error_code === 0) {
          setPreferenceEditIcon(false);
          setProfilePageRefresh(!profilePageRefresh);
        }
      } catch (err) {
        console.log(err);
      }
    }
    else {
      setPreferenceEditIcon(true);
    }
  };


  // Handle experience inputs
  const handleExperienceInputs = (e) => {
    if (e.target.type === "month" || e.target.name === "endMonthAndYear") {
      handleDisplayMonth(e);
      setExperienceInputs((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value,
      }));
    } else {
      setExperienceInputs((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value,
      }));
    }
  };

  const handleIsCurrentlyWorking = (e) => {
    setIsCurrentlyWorking(!isCurrentlyWorking)
    setExperienceInputs((prevState) => ({
      ...prevState,
      endMonthAndYear: "Present",
    }));
  }


  // Handle education inputs
  const handleEducationInputs = (e) => {
    setEducationInputs((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  // Handle Skill
  const handleSkillName = (skillName) => {
    if (skillName) {
      setSelectedSkillValue(skillName)
      setSkillsObj({ ...skillsObj, skillName: skillName.label });
    } else {
      setSkillsObj({ ...skillsObj, skillName: "" });
      setSelectedSkillValue(null)
    }
  };


  const handleEditSkillName = (editSkillName) => {
    if (editSkillName) {
      setEditSelectedSkillValue(editSkillName)
      setUpdatedSkillsObj({ ...skillsObj, skillName: editSkillName.label });
    } else {
      setUpdatedSkillsObj({ ...skillsObj, editSkillName: "" });
      setEditSelectedSkillValue(null)
    }
  }

  const handleSkillLevel = (skillLevel) => {
    setSkillsObj({ ...skillsObj, skillLevel: skillLevel });
  };


  //  handle add skill
  const handleAddSkill = async (skillName, skillLevel) => {
    if (skillsObj.skillName === "" || skillsObj.skillLevel === "") {
      toast("Please select all the fields", {
        icon: (
          <IoIosInformationCircleOutline className="fs-1 brand-color me-1" />
        ),
      });
      return
    } else {

      const result = skillsKnown.map((skill) => {
        return skill.skill_name.toLowerCase()
      })


      if (result.includes(skillsObj.skillName.toLowerCase())) {
        toast("The skill has already been added. Please select the new skill", {
          icon: (
            <IoIosInformationCircleOutline className="fs-1 brand-color me-1" />
          ),
        });
        return
      }



      const skillParams = {
        skill_name: skillName.toLowerCase(),
        skill_level: skillLevel,
      };

      try {



        const response = await axiosInstance.post("/professional_skills_update", skillParams)

        if (response.data.error_code === 0) {
          setSkillsObj({
            skillName: "",
            skillLevel: "",
          });
          setSelectedSkillValue(null);
          setProfilePageRefresh(!profilePageRefresh);
        }

      } catch (err) {
        console.log(err);
      }
    }
  };


  const [editSkillClick, setEditSkillClick] = useState(false);
  const [editLanguageClick, setEditLanguageClick] = useState(false);
  const [editSkillInputs, setEditSkillInputs] = useState({
    skill_id: 0,
    skill_name: "",
    skill_level: "",
  });
  const [editLanguageInputs, setEditLanguageInputs] = useState({
    language_id: 0,
    language_known: "",
    language_level: "",
  });

  const [editUpdateBtn, seteditUpdateBtn] = useState(false);
  const [selectedSkillId, setSelectedSkillId] = useState(0);

  // handle delete profile picture
  const handleDeleteProfilePicture = async () => {
    try {
      const response = await axiosInstance.post("/delete_user_profile_pic")

      if (response.data.error_code === 0) {
        document.getElementById("deleteProfilePhotoModalConfirmationModal").click();
        setProfilePageRefresh(!profilePageRefresh)
        setProfilePicture(`${process.env.REACT_APP_SECOND_CAREERS_CDN}professional/profile-pic/default_profile_picture.png`)
        setIsProfilePictureUploaded(false)
      }
    } catch (err) {
      console.log(err);
    }
  };

  // handle delete video
  const handleDeleteVideo = async () => {
    try {
      setVideoDeletingLoading(true)
      const response = await axiosInstance.post("/delete_professional_intro_video")

      if (response.data.error_code === 0) {
        setProfilePageRefresh(!profilePageRefresh)
        setUploadedVideoFile("")
        document.getElementById("deleteVideoModalConfirmationModal").click();
        setVideoDeletingLoading(false)
        setVideoUploadedPlaceholder(true)
        setVideoFullyUploaded(false)
      }
    } catch (err) {
      console.log(err);
    }
  };

  const [editSelectedSkillValue, setEditSelectedSkillValue] = useState(null)
  const [editSelectedLangaugeValue, setEditSelectedLangaugeValue] = useState(null)

  //  handle edit skill
  const handleEditSkill = async (e, id) => {
    setSelectedSkillId(id);
    setEditSkillClick(true);
    const result = skillsKnown.filter((val, i) => {
      return val.id === id;
    });
    setEditSkillInputs({
      skill_id: id,
      skill_name: result[0].skill_name,
      skill_level: result[0].skill_level,
    });
    setUpdatedSkillsObj({
      ...updatedSkillsObj,
      skillName: result[0].skill_name,
      skillLevel: result[0].skill_level,
    });

    setEditSelectedSkillValue({
      value: id,
      label: result[0].skill_name
    })




    if (result[0].skill_name !== "" && result[0].skill_level !== "") {
      seteditUpdateBtn(true);
    }
  };


  //  handle edit language
  const handleEditLanguage = async (e, id) => {
    setSelectedLanguageId(id);
    setEditLanguageClick(true);
    const result = languagesKnown.filter((val, i) => {
      return val.id === id;
    });
    setEditLanguageInputs({
      language_id: 0,
      language_known: result[0].language_known,
      language_level: result[0].language_level,
    });
    setUpdatedLanguagesObj({
      ...updatedLanguagesObj,
      languageName: result[0].language_known,
      languageLevel: result[0].language_level,
    });

    setEditSelectedLangaugeValue({
      value: id,
      label: result[0].language_known
    })

    if (result[0].language_known !== "" && result[0].language_level !== "") {
      seteditUpdateBtn(true);
    }


  };


  //  handle update skill
  const handleUpdateSkill = async (e, id) => {
    if (editSelectedSkillValue === null || updatedSkillsObj.skillLevel === "") {
      toast("Please select skill level", {
        icon: (
          <IoIosInformationCircleOutline className="fs-1 brand-color me-1" />
        ),
      });
    } else {
      const skillParams = {
        skill_id: id,
        skill_name: updatedSkillsObj.skillName,
        skill_level: updatedSkillsObj.skillLevel,
      };

      try {
        const response = await axiosInstance.post("/professional_skills_update", skillParams)
        if (response.data.error_code === 0) {
          setEditSkillClick(false);
          setProfilePageRefresh(!profilePageRefresh);
          setEditSelectedSkillValue(null)
        }

      } catch (err) {
        console.log(err);
      }
    }


  };

  //  handle update language
  const handleUpdateLanguage = async (e, id) => {
    if (updatedLanguagesObj.languageLevel === "") {
      toast("Please select language level", {
        icon: (
          <IoIosInformationCircleOutline className="fs-1 brand-color me-1" />
        ),
      });
    } else {
      const languageParams = {
        language_id: id,
        language_known: updatedLanguagesObj.languageName,
        language_level: updatedLanguagesObj.languageLevel,
      };
      try {
        const response = await axiosInstance.post("/professional_language_update", languageParams)
        if (response.data.error_code === 0) {
          setEditLanguageClick(false);
          setProfilePageRefresh(!profilePageRefresh);
        }
      } catch (err) {
        console.log(err);
      }
    }
  };


  //  handle delete skill
  const handleDeleteSkill = async (e, id) => {
    const skillParams = {
      skill_id: id,
    };

    try {
      const response = await axiosInstance.post("/professional_skill_delete", skillParams)
      if (response.data.error_code === 0) {
        setProfilePageRefresh(!profilePageRefresh);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleLanguageName = (languageName) => {
    if (languageName) {
      setSelectedLanguageValue(languageName)
      setLanguagesObj({ ...languagesObj, languageName: languageName.label });
    } else {
      setLanguagesObj({ ...languagesObj, languageName: "" });
      setSelectedLanguageValue(null)
    }
  };

  const handleEditLanguageName = (editLanguageName) => {
    if (editLanguageName) {
      setEditSelectedLangaugeValue(editLanguageName)
      setUpdatedLanguagesObj({ ...languagesObj, languageName: editLanguageName.label });
    } else {
      setUpdatedLanguagesObj({ ...languagesObj, editLanguageName: "" });
      setEditSelectedLangaugeValue(null)
    }
  }

  const handleLanguageLevel = (languageLevel) => {
    setLanguagesObj({ ...languagesObj, languageLevel: languageLevel });
  };

  //  Add Language
  const handleAddLanguage = async (languageName, languageLevel) => {
    if (languagesObj.languageName === "" || languagesObj.languageLevel === "") {
      toast("Please select all the fields", {
        icon: (
          <IoIosInformationCircleOutline className="fs-1 brand-color me-1" />
        ),
      });
    } else {
      const result = languagesKnown.map((language) => {
        return language.language_known.toLowerCase()
      })

      if (result.includes(languagesObj.languageName.toLowerCase())) {
        toast("The language has already been added. Please select the new language", {
          icon: (
            <IoIosInformationCircleOutline className="fs-1 brand-color me-1" />
          ),
        });
        return
      }

      const languageParams = {
        language_known: languageName,
        language_level: languageLevel,
      };

      try {
        const response = await axiosInstance.post("/professional_language_update", languageParams)
        if (response.data.error_code === 0) {
          setLanguagesObj({
            languageName: "",
            languageLevel: "",
          });
          setSelectedLanguageValue(null);
          setProfilePageRefresh(!profilePageRefresh);
        }
      } catch (err) {
        console.log(err);
      }
    }
  };


  //  Delete Language

  const handleDeleteLanguage = async (e, id) => {
    const languageParams = {
      language_id: id,
    };

    try {
      const response = await axiosInstance.post("/professional_language_delete", languageParams)


      if (response.data.error_code === 0) {
        setProfilePageRefresh(!profilePageRefresh);
      }
    } catch (err) {
      console.log(err);
    }
  };

  // Add experience api
  const handleAddExperience = async (e, saveClick) => {
    if (
      experienceInputs.jobTitle === "" ||
      experienceInputs.companyName === "" ||
      showingExperienceLocation === "" ||
      experienceInputs.startMonthAndYear === "" ||
      experienceInputs.endMonthAndYear === ""
    ) {
      toast("Please fill all the details", {
        icon: (
          <IoIosInformationCircleOutline className="fs-1 brand-color me-1" />
        ),
      });
      return;
    } else {
      const addExperienceParams = {
        company_name: experienceInputs.companyName,
        job_title: experienceInputs.jobTitle,
        start_date: experienceInputs.startMonthAndYear,
        end_date: experienceInputs.endMonthAndYear,
        job_description: experienceInputs.experienceDescription,
        job_location: showingExperienceLocation,
      };

      try {
        const response = await axiosInstance.post("/professional_experience_update", addExperienceParams)
        if (response.data.error_code === 0) {
          if (saveClick === "Save") {
            document.getElementById("addExperienceClose").click();

            setEditIsCurrentlyWorking(false)
            setIsCurrentlyWorking(false)
            setShowingExperienceLocation("")
            setExperienceInputs({
              jobTitle: "",
              companyName: "",
              startMonthAndYear: "",
              endMonthAndYear: "",
              experienceDescription: "",
            });
            setProfilePageRefresh(!profilePageRefresh);
          } else {

            setEditIsCurrentlyWorking(false)
            setIsCurrentlyWorking(false)
            setShowingExperienceLocation("")
            setExperienceInputs({
              jobTitle: "",
              companyName: "",
              startMonthAndYear: "",
              endMonthAndYear: "",
              experienceDescription: "",
            });
            setProfilePageRefresh(!profilePageRefresh);
          }

        }
      } catch (err) {
        console.log(err);
      }
    }
  };

  // Edit experience api
  const handleEditExperience = async (e, expId, val) => {
    if (val.end_date === "Present") {
      setEditIsCurrentlyWorking(true)
    } else {
      setEditIsCurrentlyWorking(false)
    }
    const result = experienceDataArray.filter((value) => {
      return value.id === expId;
    });

    if (val.start_date === "" && val.end_date === "") {
      setEditExperienceData({
        id: expId,
        jobTitle: result[0].job_title,
        companyName: result[0].company_name,
        startMonthAndYear: "",
        endMonthAndYear: "",
        experienceDescription: result[0].job_description,
      });
      setShowingExperienceLocation(result[0].job_location)
    } else {
      setEditExperienceData({
        id: expId,
        jobTitle: result[0].job_title,
        companyName: result[0].company_name,
        location: result[0].job_location,
        startMonthAndYear: val.start_date,
        endMonthAndYear: val.end_date,
        experienceDescription: result[0].job_description,
      })
      setShowingExperienceLocation(result[0].job_location)
    }
  };

  // Update experience api
  const handleUpdateExperience = async (e, id, saveClick) => {
    if (
      editExperienceData.jobTitle === "" ||
      editExperienceData.companyName === "" ||
      showingExperienceLocation === "" ||
      editExperienceData.startMonthAndYear === "" ||
      editExperienceData.endMonthAndYear === ""
    ) {
      toast("Please fill all the details", {
        icon: (
          <IoIosInformationCircleOutline className="fs-1 brand-color me-1" />
        ),
      });
      return;
    } else {
      const updateExperienceParams = {
        experience_id: id,
        company_name: editExperienceData.companyName,
        job_title: editExperienceData.jobTitle,
        start_date: editExperienceData.startMonthAndYear,
        end_date: editExperienceData.endMonthAndYear,
        job_description: editExperienceData.experienceDescription,
        job_location: showingExperienceLocation,
      };
      try {
        const response = await axiosInstance.post("/professional_experience_update", updateExperienceParams)

        if (response.data.error_code === 0) {
          if (saveClick === "Save") {
            document.getElementById("updateExperienceClose").click();
          }
          setShowingExperienceLocation("")
          setEditIsCurrentlyWorking(false)
          setIsCurrentlyWorking(false)
          setProfilePageRefresh(!profilePageRefresh);
        }
      } catch (err) {
        console.log(err);
      }
    }





  };

  // Delete experience api
  const handleDeleteExperience = async (e, id) => {
    const deleteExperienceParams = {
      experience_id: id,
    };
    try {
      const response = await axiosInstance.post("/professional_experience_delete", deleteExperienceParams)
      if (response.data.error_code === 0) {
        setShowingExperienceLocation("")
        setProfilePageRefresh(!profilePageRefresh);
      }
    } catch (err) {
      console.log(err);
    }
  };

  // Add education api
  const handleAddEducation = async (e, saveClick) => {
    if (
      educationInputs.degree === "" ||
      educationInputs.institution === "" ||
      showingEducationLocation === "" ||
      educationInputs.educationStartMonthAndYear === "" ||
      educationInputs.educationEndMonthAndYear === ""
    ) {
      toast("Please fill all the details", {
        icon: (
          <IoIosInformationCircleOutline className="fs-1 brand-color me-1" />
        ),
      });
      return;
    } else {
      const addEducationParams = {
        degree_level: educationInputs.degree,
        specialisation: educationInputs.fieldOfStudy,
        institute_name: educationInputs.institution,
        institute_location: showingEducationLocation,
        start_date: educationInputs.educationStartMonthAndYear,
        end_date: educationInputs.educationEndMonthAndYear,
      };

      try {
        const response = await axiosInstance.post("/professional_education_update", addEducationParams)
        if (response.data.error_code === 0) {
          if (saveClick === "Save") {
            document.getElementById("addEducationClose").click();
          }
          setProfilePageRefresh(!profilePageRefresh);

          setEducationInputs({
            institution: "",
            degree: "",
            fieldOfStudy: "",
            educationStartMonthAndYear: "",
            educationEndMonthAndYear: "",
            grade: "",
            educationDescription: "",
          });
          setShowingEducationLocation("");
        }
      } catch (err) {
        console.log(err);
      }
    }
  };

  // Edit education api
  const handleEditEducation = async (e, eduId, val) => {
    const result = educationDataArray.filter((value, id) => {
      return value.id === eduId;
    });

    if (val.start_date === "" && val.end_date === "") {
      setEditEducationData({
        id: eduId,
        degree: result[0].degree_level,
        fieldOfStudy: result[0].specialisation,
        institution: result[0].institute_name,
        educationStartMonthAndYear: "",
        educationEndMonthAndYear: "",
      });
      setShowingEducationLocation(result[0].institute_location)
    } else {
      setEditEducationData({
        id: eduId,
        degree: result[0].degree_level,
        fieldOfStudy: result[0].specialisation,
        institution: result[0].institute_name,
        educationStartMonthAndYear: val.start_date,
        educationEndMonthAndYear: val.end_date,
      });
      setShowingEducationLocation(result[0].institute_location)
    }
  };

  // Update education api
  const handleUpdateEducation = async (e, id, saveClick) => {
    if (
      editEducationData.degree === "" ||
      editEducationData.institution === "" ||
      showingEducationLocation === "" ||
      editEducationData.educationStartMonthAndYear === "" ||
      editEducationData.educationEndMonthAndYear === ""
    ) {
      toast("Please fill all the details", {
        icon: (
          <IoIosInformationCircleOutline className="fs-1 brand-color me-1" />
        ),
      });
      return;
    } else {
      const updateEducationParams = {
        education_id: id,
        degree_level: editEducationData.degree,
        specialisation: editEducationData.fieldOfStudy,
        institute_name: editEducationData.institution,
        institute_location: showingEducationLocation,
        start_date: editEducationData.educationStartMonthAndYear,
        end_date: editEducationData.educationEndMonthAndYear,
        is_pursuing: "N",
      };
      try {
        const response = await axiosInstance.post("/professional_education_update", updateEducationParams)

        if (response.data.error_code === 0) {
          if (saveClick === "Save") {
            document.getElementById("updateEducationClose").click();
          }
          setProfilePageRefresh(!profilePageRefresh);
        }
      } catch (err) {
        console.log(err);
      }
    }
  };

  // Delete education api
  const handleDeleteEducation = async (e, id) => {
    const deleteEducationParams = {
      education_id: id,
    };

    try {
      const response = await axiosInstance.post("/professional_education_delete", deleteEducationParams)
      if (response.data.error_code === 0) {
        setProfilePageRefresh(!profilePageRefresh);
        setShowingEducationLocation("")
      }
    } catch (err) {
      console.log(err);
    }
  };

  // About edit section
  const handleAboutChange = (e) => {
    setAboutContent(e.target.value);
  };

  // Preference edit section
  const handlePreferenceChange = (e) => {
    setPreferenceContent(e.target.value);
  };

  const [socialMediaInputs, setSocialMediaInputs] = useState({
    socialMediaName: "",
    url: "",
  });

  const handleSocialMediaInputs = (e) => {
    setSocialMediaInputs({
      ...socialMediaInputs,
      [e.target.name]: e.target.value,
    });
  };

  //  add social media
  const handleAddSocialMedia = async (e, saveClick) => {
    if (
      socialMediaInputs.socialMediaName === "" ||
      socialMediaInputs.url === ""
    ) {
      toast("Please enter all the fields", {
        icon: (
          <IoIosInformationCircleOutline className="fs-1 brand-color me-1" />
        ),
      });
    } else {
      const socialMediaParams = {
        title: socialMediaInputs.socialMediaName,
        url: socialMediaInputs.url,
      };
      try {
        const response = await axiosInstance.post("/professional_socail_link_update", socialMediaParams)

        if (response.data.error_code === 0) {
          setProfilePageRefresh(!profilePageRefresh);
          if (saveClick === "Save") {
            document.getElementById("addSocialLinkMediaClose").click();
          }
          setSocialMediaInputs({
            socialMediaName: "",
            url: "",
          });
        }
      } catch (err) {
        console.log(err);
      }
    }
  };

  // edit social media
  const handleEditSocialMedia = async (e, socialId) => {
    const result = socialMediaArray.filter((value, id) => {
      return value.id === socialId;
    });

    setEditSocialMediaData({
      id: socialId,
      socialMediaName: result[0].title,
      url: result[0].url,
    });
  };

  // update social media
  const handleUpdateSocialMedia = async (e, id, saveClick) => {
    if (
      editSocialMediaData.socialMediaName === "" ||
      editSocialMediaData.url === ""
    ) {
      toast("Please enter all the fields", {
        icon: (
          <IoIosInformationCircleOutline className="fs-1 brand-color me-1" />
        ),
      });
    } else {
      const socialMediaParams = {
        link_id: id,
        title: editSocialMediaData.socialMediaName,
        url: editSocialMediaData.url,
      };
      try {
        const response = await axiosInstance.post("/professional_socail_link_update", socialMediaParams)
        if (response.data.error_code === 0) {
          if (saveClick === "Save") {
            document.getElementById("updateSocialLinkMediaClose").click();
          }
          setProfilePageRefresh(!profilePageRefresh);
        }
      } catch (err) {
        console.log(err);
      }
    }
  };

  // delete social media
  const handleDeleteSocialMedia = async (e, id) => {
    const socialMediaParams = {
      link_id: id,
    };
    try {
      const response = await axiosInstance.post("/professional_social_link_delete", socialMediaParams)
      if (response.data.error_code === 0) {
        setProfilePageRefresh(!profilePageRefresh);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const [experienceStartMonth, setExperienceStartMonth] = useState("");
  const [experienceEndMonth, setExperienceEndMonth] = useState("");

  const handleDisplayMonth = (e) => {
    let monthAndYear = e.target.value;
    let monthSplit = monthAndYear.split("-");
    let monthOnly = monthSplit[1];

    switch (monthOnly) {
      case "01":
        setDisplayMonth("Jan");
        setExperienceStartMonth("Jan");
        setExperienceEndMonth("Jan");
        break;
      case "02":
        setDisplayMonth("Feb");
        setExperienceStartMonth("Feb");
        setExperienceEndMonth("Feb");
        break;
      case "03":
        setDisplayMonth("Mar");
        setExperienceStartMonth("Mar");
        setExperienceEndMonth("Mar");
        break;
      case "04":
        setDisplayMonth("Apr");
        setExperienceStartMonth("Apr");
        setExperienceEndMonth("Apr");
        break;
      case "05":
        setDisplayMonth("May");
        setExperienceStartMonth("May");
        setExperienceEndMonth("May");
        break;
      case "06":
        setDisplayMonth("June");
        setExperienceStartMonth("June");
        setExperienceEndMonth("June");
        break;
      case "07":
        setDisplayMonth("July");
        setExperienceStartMonth("Jan");
        setExperienceEndMonth("Jan");
        break;
      case "08":
        setDisplayMonth("Aug");
        setExperienceStartMonth("Aug");
        setExperienceEndMonth("Aug");
        break;
      case "09":
        setDisplayMonth("Sep");
        setExperienceStartMonth("Sep");
        setExperienceEndMonth("Sep");
        break;
      case "10":
        setDisplayMonth("Oct");
        setExperienceStartMonth("Oct");
        setExperienceEndMonth("Oct");
        break;
      case "11":
        setDisplayMonth("Nov");
        setExperienceStartMonth("Nov");
        setExperienceEndMonth("Nov");
        break;
      case "12":
        setDisplayMonth("Dec");
        setExperienceStartMonth("Dec");
        setExperienceEndMonth("Dec");
        break;

      default:
        break;
    }
  };

  const [experNotesCheckConfirmation, setExperNotesCheckConfirmation] = useState(false)
  const handleApproveExpertNotes = async () => {
    if (experNotesCheckConfirmation) {
      try {
        var obj = {
          view_status: "Y",
        }
        const res = await axiosInstance.post("/update_expert_notes_status", obj);
        if (res.data.error_code === 0) {
          getProfileDetails();
        }
      } catch (err) {
        console.log(err);
      }
    } else {
      toast.error("please confirm and approve")
    }
  }

  const handleEditSkillDropdownClose = () => {
    setEditSkillClick(false)
    const el = document.querySelector('.edit-skill-dropdown-menu');
    el.classList.remove("show")
  }

  return (
    <>
      <section className="profile-bg placeholder-glow professional-profile" >
        {
          Cookie.get("isFirstVisitProfileParsing") ?
            <div className="profile_extraction_parsing">
              <div className="h-100 row justify-content-center align-items-center">
                <div className="col-9 col-md-7 col-lg-6 text-center">
                  <span className="spinner-border spinner-border-xxl brand-color" role="status"></span>
                  <p className=" text-secondary mt-3">Please avoid refreshing or navigating away while your resume is being parsed</p>
                </div>
              </div>
            </div>
            :
            <div className="container-fluid mb-0 h-100">
              <div className="p-2 p-lg-5 pt-0 pb-2">
                <div className="row g-3">
                  <div className="col-lg-3">
                    <div className="card border-0 h-100 rounded-4">
                      <div className="card-body d-flex align-items-center justify-content-center pt-1">
                        <div className="w-100">
                          <div className="row justify-content-center p-0  mt-2">
                            <div className="pic-holder mb-0 ">
                              {profilePageAllContent ? (
                                responseLoading ? (
                                  <div className="d-flex justify-content-center">
                                    <div
                                      className="spinner-border brand-color"
                                      role="status"
                                    >
                                      <span className="visually-hidden ">
                                        Loading...
                                      </span>
                                    </div>
                                  </div>
                                ) : (
                                  <img
                                    id="profilePic"
                                    name="profile_pic"
                                    src={profilePicture}
                                    width={150}
                                    height={150}
                                    className="rounded-circle"
                                  />
                                )
                              ) : (
                                <div className="placeholder rounded-2 ">
                                  <img
                                    id="profilePic"
                                    src=""
                                    width={150}
                                    height={150}
                                    className="rounded-circle"
                                  />
                                </div>
                              )}

                              <label
                                htmlFor="newProfilePhoto"
                                className={
                                  profilePageAllContent
                                    ? `upload-file-block ${responseLoading ? `pe-none` : ""} `
                                    : "upload-file-block pe-none"
                                }
                                data-bs-toggle="modal"
                                data-bs-target="#profilePhotoModal"
                              >
                                <div className="text-center">
                                  <MdAddAPhoto className="fs-5 mb-3" />
                                  <div className="" id="updateProfilePhoto">
                                    Update <br /> Profile Photo
                                  </div>
                                </div>
                              </label>
                            </div>
                          </div>

                          <div className="text-center pt-4">
                            <h5 className="text-dark font-size-20 placeholder-glow ">
                              <span
                                className={
                                  profilePageAllContent
                                    ? ""
                                    : "placeholder py-3 w-25 rounded-1 me-2"
                                }
                              >
                                {personalDetails.firstName}{" "}
                              </span>
                              <span
                                className={
                                  profilePageAllContent
                                    ? ""
                                    : "placeholder py-3 w-25 rounded-1"
                                }
                              >
                                {personalDetails.lastName}
                              </span>
                            </h5>
                          </div>

                          <div className="p-3 pb-0">
                            <div
                              className={
                                profilePageAllContent
                                  ? "progress "
                                  : "placeholder rounded-2 w-100"
                              }
                              style={{ height: "1.4rem" }}
                            >
                              <div
                                className={
                                  profilePageAllContent
                                    ? "progress-bar progress-bar-color"
                                    : "progress-bar "
                                }
                                role="progressbar"
                                style={{
                                  width: `${personalDetails.profilePercentage}%`,
                                }}
                                aria-valuemin="0"
                                aria-valuemax="100"
                              >
                                {personalDetails.profilePercentage}%
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{ backgroundColor: '#dfdddd8d' }}
                        className={
                          profilePageAllContent
                            ? "premium-account-feauture-container position-absolute top-0 end-0 d-flex align-items-center p-2  rounded-2"
                            : "premium-account-feauture-container position-absolute top-0 end-0 d-flex align-items-center p-2  placeholder rounded-2"
                        }
                      >
                        <div className='m-0 px-2'>{currentPlan === "Basic" || currentPlan === null ? <span><TfiMedallAlt className='fs-5' /> Basic</span> : null ||
                          currentPlan === "Premium" ? <span><BiMedal className='fs-5' /> {currentPlan}</span> : null ||
                            currentPlan === "Platinum" ? <span><RiMedal2Line className='fs-5' /> {currentPlan}</span> : null
                        }</div>
                        <span
                          className={
                            profilePageAllContent ? "brand-color fs-6" : "placeholder"
                          }
                        >
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-lg-9">
                    <div className="card border-0 h-100 rounded-4 " id="personalDetailsCard">
                      <div className="card-header border-0 bg-transparent">
                        <div className="d-flex justify-content-between  ms-1 my-3">
                          <label className="profile-side-headers d-flex align-items-center placeholder-glow">
                            <PiBagFill
                              className={
                                profilePageAllContent
                                  ? "me-3 brand-color fs-3"
                                  : "me-4 fs-1 placeholder rounded-2"
                              }
                            />
                            <span
                              className={
                                profilePageAllContent
                                  ? ""
                                  : "placeholder px-3 w-100 py-1  rounded-1"
                              }
                            >
                              Personal Details
                            </span>
                          </label>

                          {editClick === false ?
                            <button
                              id="personalDetailsEditButton"
                              type="button"
                              className={
                                profilePageAllContent
                                  ? "btn btn-outline-brand-color px-3 d-flex align-items-center gap-2"
                                  : "btn px-3 d-flex align-items-center gap-2 placeholder rounded-2"
                              }
                              title="Edit Personal details"
                              onClick={handlePeronalDetailsEdit}
                            >
                              {
                                mobileScreen ?
                                  <MdModeEditOutline />
                                  :
                                  <>
                                    <MdModeEditOutline /> Edit
                                  </>
                              }
                            </button>
                            :
                            <button
                              className={
                                profilePageAllContent
                                  ? "btn btn-brand-color px-2 d-flex align-items-center gap-2 py-1"
                                  : "btn px-3 d-flex align-items-center gap-2 placeholder rounded-2"
                              }
                              id="personalDetailsaveButton"

                              title="Save Personal details"
                              onClick={handlePersonalDetailsSave}
                            >
                              {
                                mobileScreen ?
                                  <MdSave
                                    className={
                                      profilePageAllContent
                                        ? "icon fs-5"
                                        : "icon fs-5 placeholder rounded-2"
                                    }
                                  />
                                  :
                                  <>
                                    <MdSave
                                      className={
                                        profilePageAllContent
                                          ? "icon fs-5"
                                          : "icon fs-5 placeholder rounded-2"
                                      }
                                    />
                                    Save
                                  </>
                              }
                            </button>
                          }
                        </div>
                      </div>

                      <div className="card-body pt-0">
                        <div className="placeholder-glow d-flex flex-wrap align-items-start">
                          <div className="p-2 border-0 d-flex flex-wrap align-items-center col-12 col-md-6 col-xl-4">
                            {
                              profilePageAllContent ?
                                <span className="pe-2">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                    <path d="M12.75 15.375H5.25C3 15.375 1.5 14.25 1.5 11.625V6.375C1.5 3.75 3 2.625 5.25 2.625H12.75C15 2.625 16.5 3.75 16.5 6.375V11.625C16.5 14.25 15 15.375 12.75 15.375Z" stroke="#595959" strokeWidth="1.5" stroke-miterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M12.75 6.75L10.4025 8.625C9.63 9.24 8.3625 9.24 7.59 8.625L5.25 6.75" stroke="#595959" strokeWidth="1.5" stroke-miterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                                  </svg>
                                </span>
                                :
                                null
                            }

                            <span className={profilePageAllContent ? "col" : "placeholder p-3 col-12 rounded-1"}>
                              {personalDetails.email}
                            </span>
                          </div>

                          <div className="p-2 border-0 d-flex flex-wrap align-items-center col-12 col-md-6 col-xl-4">
                            {
                              profilePageAllContent ?
                                <span className="pe-2">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                    <g clipPath="url(#clip0_1078_4557)">
                                      <path d="M16.4999 0H13.4999C13.301 0 13.1102 0.0790176 12.9696 0.21967C12.8289 0.360322 12.7499 0.551088 12.7499 0.75C12.7499 0.948912 12.8289 1.13968 12.9696 1.28033C13.1102 1.42098 13.301 1.5 13.4999 1.5H15.4394L13.6394 3.3C12.8185 2.68011 11.8324 2.31731 10.8056 2.25737C9.77867 2.19744 8.75706 2.44307 7.86965 2.96325C7.20082 2.57677 6.45484 2.3429 5.68508 2.27836C4.91532 2.21382 4.1408 2.32021 3.41696 2.58992C2.69311 2.85962 2.03782 3.28598 1.49796 3.83848C0.958114 4.39099 0.54705 5.05598 0.294182 5.78588C0.0413135 6.51578 -0.0471074 7.29255 0.0352453 8.06061C0.117598 8.82867 0.368688 9.56903 0.770552 10.2287C1.17242 10.8884 1.71512 11.4512 2.35983 11.8767C3.00454 12.3021 3.73533 12.5799 4.4999 12.69V14.25H2.9999C2.80099 14.25 2.61023 14.329 2.46957 14.4697C2.32892 14.6103 2.2499 14.8011 2.2499 15C2.2499 15.1989 2.32892 15.3897 2.46957 15.5303C2.61023 15.671 2.80099 15.75 2.9999 15.75H4.4999V17.25C4.4999 17.4489 4.57892 17.6397 4.71957 17.7803C4.86023 17.921 5.05099 18 5.2499 18C5.44882 18 5.63958 17.921 5.78023 17.7803C5.92089 17.6397 5.9999 17.4489 5.9999 17.25V15.75H7.4999C7.69882 15.75 7.88958 15.671 8.03023 15.5303C8.17089 15.3897 8.2499 15.1989 8.2499 15C8.2499 14.8011 8.17089 14.6103 8.03023 14.4697C7.88958 14.329 7.69882 14.25 7.4999 14.25H5.9999V12.6952C6.6592 12.597 7.29346 12.3729 7.86815 12.0353C8.91306 12.6464 10.1373 12.8769 11.333 12.6876C12.5286 12.4982 13.6217 11.9008 14.4267 10.9966C15.2317 10.0926 15.6987 8.93762 15.7485 7.72813C15.7983 6.51864 15.4278 5.32922 14.6999 4.362L16.4999 2.562V4.5C16.4999 4.69891 16.5789 4.88968 16.7196 5.03033C16.8602 5.17098 17.051 5.25 17.2499 5.25C17.4488 5.25 17.6396 5.17098 17.7802 5.03033C17.9209 4.88968 17.9999 4.69891 17.9999 4.5V1.5C17.9999 1.10218 17.8419 0.720644 17.5606 0.43934C17.2793 0.158035 16.8977 0 16.4999 0V0ZM1.4999 7.5C1.49635 6.89089 1.64209 6.29018 1.92438 5.75042C2.20668 5.21066 2.61692 4.74828 3.11924 4.40374C3.62155 4.05919 4.20063 3.84297 4.80584 3.77398C5.41104 3.70499 6.02393 3.78534 6.5909 4.008C5.72761 4.96622 5.24986 6.21025 5.24986 7.5C5.24986 8.78975 5.72761 10.0338 6.5909 10.992C6.02393 11.2147 5.41104 11.295 4.80584 11.226C4.20063 11.157 3.62155 10.9408 3.11924 10.5963C2.61692 10.2517 2.20668 9.78934 1.92438 9.24958C1.64209 8.70982 1.49635 8.10911 1.4999 7.5ZM10.4999 11.25C9.75822 11.25 9.0332 11.0301 8.41651 10.618C7.79983 10.206 7.31918 9.62029 7.03535 8.93506C6.75153 8.24984 6.67726 7.49584 6.82196 6.76841C6.96665 6.04098 7.32381 5.3728 7.84825 4.84835C8.3727 4.3239 9.04089 3.96675 9.76831 3.82206C10.4957 3.67736 11.2497 3.75162 11.935 4.03545C12.6202 4.31928 13.2059 4.79993 13.6179 5.41661C14.03 6.0333 14.2499 6.75832 14.2499 7.5C14.2487 8.4942 13.8532 9.44733 13.1502 10.1503C12.4472 10.8533 11.4941 11.2488 10.4999 11.25Z" fill="#595959" />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_1078_4557">
                                        <rect width="18" height="18" fill="white" />
                                      </clipPath>
                                    </defs>
                                  </svg>
                                </span>
                                :
                                null
                            }

                            {editClick === false ?
                              <span className={profilePageAllContent ? "col" : "placeholder p-2 col-12 rounded-1"} >
                                {personalDetails?.gender?.length ? personalDetails?.gender[0]?.label : "None"}
                              </span>
                              :
                              <div className="col">
                                <span>
                                  <Select
                                    color="#ffa32d"
                                    options={jsonOnly?.gender}
                                    className="rounded-2 custom_react_dropdown react-dropdown-select-single py-2"
                                    values={personalDetails?.gender?.length ? personalDetails?.gender : []}
                                    placeholder="Gender"
                                    onChange={(values) => {
                                      setPersonalDetails({
                                        ...personalDetails,
                                        gender: values,
                                      });
                                    }}
                                    dropdownPosition="auto"
                                  />
                                </span>
                              </div>
                            }
                          </div>

                          <div className="p-2 border-0 d-flex flex-wrap align-items-center col-12 col-md-6 col-xl-4">
                            {
                              profilePageAllContent ?
                                <span className="pe-2">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                    <path d="M16.4775 13.7475C16.4775 14.0175 16.4175 14.295 16.29 14.565C16.1625 14.835 15.9975 15.09 15.78 15.33C15.4125 15.735 15.0075 16.0275 14.55 16.215C14.1 16.4025 13.6125 16.5 13.0875 16.5C12.3225 16.5 11.505 16.32 10.6425 15.9525C9.78 15.585 8.9175 15.09 8.0625 14.4675C7.2 13.8375 6.3825 13.14 5.6025 12.3675C4.83 11.5875 4.1325 10.77 3.51 9.915C2.895 9.06 2.4 8.205 2.04 7.3575C1.68 6.5025 1.5 5.685 1.5 4.905C1.5 4.395 1.59 3.9075 1.77 3.4575C1.95 3 2.235 2.58 2.6325 2.205C3.1125 1.7325 3.6375 1.5 4.1925 1.5C4.4025 1.5 4.6125 1.545 4.8 1.635C4.995 1.725 5.1675 1.86 5.3025 2.055L7.0425 4.5075C7.1775 4.695 7.275 4.8675 7.3425 5.0325C7.41 5.19 7.4475 5.3475 7.4475 5.49C7.4475 5.67 7.395 5.85 7.29 6.0225C7.1925 6.195 7.05 6.375 6.87 6.555L6.3 7.1475C6.2175 7.23 6.18 7.3275 6.18 7.4475C6.18 7.5075 6.1875 7.56 6.2025 7.62C6.225 7.68 6.2475 7.725 6.2625 7.77C6.3975 8.0175 6.63 8.34 6.96 8.73C7.2975 9.12 7.6575 9.5175 8.0475 9.915C8.4525 10.3125 8.8425 10.68 9.24 11.0175C9.63 11.3475 9.9525 11.5725 10.2075 11.7075C10.245 11.7225 10.29 11.745 10.3425 11.7675C10.4025 11.79 10.4625 11.7975 10.53 11.7975C10.6575 11.7975 10.755 11.7525 10.8375 11.67L11.4075 11.1075C11.595 10.92 11.775 10.7775 11.9475 10.6875C12.12 10.5825 12.2925 10.53 12.48 10.53C12.6225 10.53 12.7725 10.56 12.9375 10.6275C13.1025 10.695 13.275 10.7925 13.4625 10.92L15.945 12.6825C16.14 12.8175 16.275 12.975 16.3575 13.1625C16.4325 13.35 16.4775 13.5375 16.4775 13.7475Z" stroke="#595959" strokeWidth="1.5" stroke-miterlimit="10" />
                                  </svg>
                                </span>
                                :
                                null
                            }

                            {editClick === false ?
                              <span className={profilePageAllContent ? "col" : "placeholder p-2 col-12 rounded-1"}>
                                {`+${dialCode} ${personalDetails.phone}`}
                              </span>
                              :
                              <span className={profilePageAllContent ? "col" : "placeholder px-3 py-2 rounded-1"}  >
                                <PhoneInput
                                  id="floatingInput"
                                  specialLabel=""
                                  country={dialCode === "" ? "us" : dialCode}
                                  dataTestid="mobileNumber"
                                  countryCodeEditable={false}
                                  enableSearch
                                  onChange={(e, phone) =>
                                    handlePhoneInput(e, phone, "contactno")
                                  }
                                  value={`${dialCode}${personalDetails.phone}`}
                                  inputProps={{
                                    alt: "mobileNumber",
                                    type: "tel",
                                    placeholder: "Mobile Number",
                                    required: true,
                                    style: { padding: '0px !important' }
                                  }}
                                />

                              </span>
                            }
                          </div>

                          <div className="p-2 border-0 d-flex flex-wrap align-items-center col-12 col-md-6 col-xl-4">
                            {
                              profilePageAllContent ?
                                <span className="pe-2">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                    <g clipPath="url(#clip0_1078_4560)">
                                      <path d="M9 4.5C8.40666 4.5 7.82664 4.67595 7.33329 5.00559C6.83994 5.33524 6.45543 5.80377 6.22836 6.35195C6.0013 6.90013 5.94189 7.50333 6.05765 8.08527C6.1734 8.66721 6.45912 9.20176 6.87868 9.62132C7.29824 10.0409 7.83279 10.3266 8.41473 10.4424C8.99667 10.5581 9.59987 10.4987 10.1481 10.2716C10.6962 10.0446 11.1648 9.66006 11.4944 9.16671C11.8241 8.67336 12 8.09334 12 7.5C12 6.70435 11.6839 5.94129 11.1213 5.37868C10.5587 4.81607 9.79565 4.5 9 4.5ZM9 9C8.70333 9 8.41332 8.91203 8.16665 8.7472C7.91997 8.58238 7.72771 8.34811 7.61418 8.07403C7.50065 7.79994 7.47095 7.49834 7.52882 7.20736C7.5867 6.91639 7.72956 6.64912 7.93934 6.43934C8.14912 6.22956 8.41639 6.0867 8.70737 6.02882C8.99834 5.97094 9.29994 6.00065 9.57403 6.11418C9.84812 6.22771 10.0824 6.41997 10.2472 6.66665C10.412 6.91332 10.5 7.20333 10.5 7.5C10.5 7.89783 10.342 8.27936 10.0607 8.56066C9.77936 8.84196 9.39783 9 9 9Z" fill="#595959" />
                                      <path d="M8.99975 18.0002C8.3682 18.0035 7.74508 17.8553 7.18255 17.5683C6.62001 17.2812 6.13444 16.8635 5.7665 16.3502C2.90825 12.4075 1.4585 9.44347 1.4585 7.53997C1.4585 5.5399 2.25302 3.62176 3.66728 2.2075C5.08154 0.793241 6.99968 -0.00128174 8.99975 -0.00128174C10.9998 -0.00128174 12.918 0.793241 14.3322 2.2075C15.7465 3.62176 16.541 5.5399 16.541 7.53997C16.541 9.44347 15.0912 12.4075 12.233 16.3502C11.8651 16.8635 11.3795 17.2812 10.8169 17.5683C10.2544 17.8553 9.63129 18.0035 8.99975 18.0002ZM8.99975 1.63597C7.43406 1.63775 5.93301 2.26051 4.8259 3.36762C3.71879 4.47473 3.09603 5.97578 3.09425 7.54147C3.09425 9.04897 4.514 11.8367 7.091 15.391C7.30977 15.6923 7.59677 15.9376 7.92853 16.1067C8.26029 16.2758 8.62737 16.3639 8.99975 16.3639C9.37212 16.3639 9.7392 16.2758 10.071 16.1067C10.4027 15.9376 10.6897 15.6923 10.9085 15.391C13.4855 11.8367 14.9052 9.04897 14.9052 7.54147C14.9035 5.97578 14.2807 4.47473 13.1736 3.36762C12.0665 2.26051 10.5654 1.63775 8.99975 1.63597Z" fill="#595959" />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_1078_4560">
                                        <rect width="18" height="18" fill="white" />
                                      </clipPath>
                                    </defs>
                                  </svg>
                                </span>
                                :
                                null
                            }

                            {editClick === false ?
                              <span className={profilePageAllContent ? "col" : "placeholder p-2 col-12 rounded-1"} >
                                <input
                                  className="non-edit-input w-100"
                                  name="text"
                                  disabled
                                  value={`${companyLocation.city} , ${companyLocation.country}`}
                                />
                              </span>
                              :
                              <div className="col">
                                <span>
                                  <Autocomplete
                                    id="personalDetailLocationField"
                                    className="personal-detail-input d-inline-block"
                                    apiKey={process.env.REACT_APP_GOOGLE_PLACES_KEY}
                                    onPlaceSelected={(place) => {
                                      if (place) {
                                        handleLocation(place.address_components);
                                      }
                                    }}
                                    style={{ width: "100%", border: 'none', borderBottom: '2px solid #e381129f' }}
                                    required
                                    value={showingLocation}
                                    onChange={(e) => setShowingLocation(e.target.value)}

                                  />
                                </span>
                              </div>
                            }
                          </div>

                          <div className="p-2 border-0 d-flex flex-wrap align-items-center col-12 col-md-6 col-xl-4">
                            {
                              profilePageAllContent ?
                                <span className="pe-2">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
                                    <path d="M6.0006 17H12.0006C15.0156 17 15.5556 15.7925 15.7131 14.3225L16.2756 8.3225C16.4781 6.4925 15.9531 5 12.7506 5H5.2506C2.0481 5 1.5231 6.4925 1.7256 8.3225L2.2881 14.3225C2.4456 15.7925 2.9856 17 6.0006 17Z" stroke="#595959" strokeWidth="1.5" stroke-miterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M6 5V4.4C6 3.0725 6 2 8.4 2H9.6C12 2 12 3.0725 12 4.4V5" stroke="#595959" strokeWidth="1.5" stroke-miterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M10.5 10.25V11C10.5 11.0075 10.5 11.0075 10.5 11.015C10.5 11.8325 10.4925 12.5 9 12.5C7.515 12.5 7.5 11.84 7.5 11.0225V10.25C7.5 9.5 7.5 9.5 8.25 9.5H9.75C10.5 9.5 10.5 9.5 10.5 10.25Z" stroke="#595959" strokeWidth="1.5" stroke-miterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M16.2375 8.75C14.505 10.01 12.525 10.76 10.5 11.015" stroke="#595959" strokeWidth="1.5" stroke-miterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M1.96289 8.95215C3.65039 10.1071 5.55539 10.8046 7.49789 11.0221" stroke="#595959" strokeWidth="1.5" stroke-miterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                                  </svg>
                                </span>
                                :
                                null
                            }

                            {editClick === false ?
                              <span className={profilePageAllContent ? "col" : "placeholder p-2 col-12 rounded-1"} >
                                {personalDetails?.years_of_experience ? personalDetails?.years_of_experience + ` ${personalDetails?.years_of_experience > 1 ? "years" : "year"} of experience` : "0 year of experience"}
                              </span>
                              :
                              <div className="col">
                                <span>
                                  <input
                                    type="text"
                                    name="years of experience"
                                    className="w-100 form-control py-2"
                                    placeholder="Years of Experience"
                                    value={personalDetails?.years_of_experience || ''}
                                    onChange={(e) => {
                                      if (/^\d+$/.test(e.target.value) && e.target.value !== "" && Number(e.target.value) < 100 && Number(e.target.value) > 0) {
                                        setPersonalDetails({
                                          ...personalDetails,
                                          years_of_experience: e.target.value,
                                        });
                                      } else {
                                        if (e.target.value === "") {
                                          setPersonalDetails({
                                            ...personalDetails,
                                            years_of_experience: '',
                                          });
                                        }
                                      }
                                    }}
                                  />
                                </span>
                              </div>
                            }
                          </div>

                          <div className="p-2 border-0 d-flex flex-wrap align-items-center col-12 col-md-6 col-xl-4">
                            {
                              profilePageAllContent ?
                                <span className="pe-2">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                    <g clipPath="url(#clip0_1078_4560)">
                                      <path d="M9 4.5C8.40666 4.5 7.82664 4.67595 7.33329 5.00559C6.83994 5.33524 6.45543 5.80377 6.22836 6.35195C6.0013 6.90013 5.94189 7.50333 6.05765 8.08527C6.1734 8.66721 6.45912 9.20176 6.87868 9.62132C7.29824 10.0409 7.83279 10.3266 8.41473 10.4424C8.99667 10.5581 9.59987 10.4987 10.1481 10.2716C10.6962 10.0446 11.1648 9.66006 11.4944 9.16671C11.8241 8.67336 12 8.09334 12 7.5C12 6.70435 11.6839 5.94129 11.1213 5.37868C10.5587 4.81607 9.79565 4.5 9 4.5ZM9 9C8.70333 9 8.41332 8.91203 8.16665 8.7472C7.91997 8.58238 7.72771 8.34811 7.61418 8.07403C7.50065 7.79994 7.47095 7.49834 7.52882 7.20736C7.5867 6.91639 7.72956 6.64912 7.93934 6.43934C8.14912 6.22956 8.41639 6.0867 8.70737 6.02882C8.99834 5.97094 9.29994 6.00065 9.57403 6.11418C9.84812 6.22771 10.0824 6.41997 10.2472 6.66665C10.412 6.91332 10.5 7.20333 10.5 7.5C10.5 7.89783 10.342 8.27936 10.0607 8.56066C9.77936 8.84196 9.39783 9 9 9Z" fill="#595959" />
                                      <path d="M8.99975 18.0002C8.3682 18.0035 7.74508 17.8553 7.18255 17.5683C6.62001 17.2812 6.13444 16.8635 5.7665 16.3502C2.90825 12.4075 1.4585 9.44347 1.4585 7.53997C1.4585 5.5399 2.25302 3.62176 3.66728 2.2075C5.08154 0.793241 6.99968 -0.00128174 8.99975 -0.00128174C10.9998 -0.00128174 12.918 0.793241 14.3322 2.2075C15.7465 3.62176 16.541 5.5399 16.541 7.53997C16.541 9.44347 15.0912 12.4075 12.233 16.3502C11.8651 16.8635 11.3795 17.2812 10.8169 17.5683C10.2544 17.8553 9.63129 18.0035 8.99975 18.0002ZM8.99975 1.63597C7.43406 1.63775 5.93301 2.26051 4.8259 3.36762C3.71879 4.47473 3.09603 5.97578 3.09425 7.54147C3.09425 9.04897 4.514 11.8367 7.091 15.391C7.30977 15.6923 7.59677 15.9376 7.92853 16.1067C8.26029 16.2758 8.62737 16.3639 8.99975 16.3639C9.37212 16.3639 9.7392 16.2758 10.071 16.1067C10.4027 15.9376 10.6897 15.6923 10.9085 15.391C13.4855 11.8367 14.9052 9.04897 14.9052 7.54147C14.9035 5.97578 14.2807 4.47473 13.1736 3.36762C12.0665 2.26051 10.5654 1.63775 8.99975 1.63597Z" fill="#595959" />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_1078_4560">
                                        <rect width="18" height="18" fill="white" />
                                      </clipPath>
                                    </defs>
                                  </svg>
                                </span>
                                :
                                null
                            }

                            {editClick === false ?
                              <span className={profilePageAllContent ? "col" : "placeholder p-2 col-12 rounded-1"} >
                                {personalDetails?.willing_to_relocate?.length ? personalDetails?.willing_to_relocate[0]?.label : "None"}
                              </span>
                              :
                              <div className="col">
                                <span>
                                  <Select
                                    color='#ffa32d'
                                    options={[{ value: 1, label: "Yes, I am willing to relocate" }, { value: 2, label: "No, I am not willing to relocate" }]}
                                    className="rounded-2 custom_react_dropdown react-dropdown-select-single py-2"
                                    values={personalDetails?.willing_to_relocate || []}
                                    placeholder="Willing to relocate"
                                    onChange={(values) => {
                                      setPersonalDetails({
                                        ...personalDetails,
                                        willing_to_relocate: values,
                                      })
                                    }}
                                    dropdownPosition="auto"
                                  />
                                </span>
                              </div>
                            }
                          </div>

                          <div className="p-2 border-0 d-flex flex-wrap align-items-center col-12 col-md-6 col-xl-4">
                            {
                              profilePageAllContent ?
                                <span className="pe-2">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                    <path d="M14.9999 5.24988H2.99999C2.17157 5.24988 1.5 5.92144 1.5 6.74986V14.2498C1.5 15.0782 2.17157 15.7498 2.99999 15.7498H14.9999C15.8283 15.7498 16.4999 15.0782 16.4999 14.2498V6.74986C16.4999 5.92144 15.8283 5.24988 14.9999 5.24988Z" stroke="#595959" strokeWidth="1.66678" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M11.9999 15.7496V3.74974C11.9999 3.35192 11.8419 2.97039 11.5606 2.68909C11.2793 2.40779 10.8978 2.24976 10.5 2.24976H7.49999C7.10217 2.24976 6.72064 2.40779 6.43934 2.68909C6.15803 2.97039 6 3.35192 6 3.74974V15.7496" stroke="#595959" strokeWidth="1.66678" strokeLinecap="round" strokeLinejoin="round" />
                                  </svg>
                                </span>
                                :
                                null
                            }

                            {editClick === false ?
                              <span className={profilePageAllContent ? "col" : "placeholder p-2 col-12 rounded-1"} >
                                {personalDetails?.job_type?.length ? personalDetails?.job_type?.map((v) => v?.label)?.join(",") : "None"}
                              </span>
                              :
                              <div className="col">
                                <span>
                                  <Select
                                    color='#ffa32d'
                                    options={jsonOnly?.register_job_type}
                                    className="rounded-2 custom_react_dropdown react-dropdown-select-single py-2"
                                    values={personalDetails?.job_type}
                                    placeholder="Job type"
                                    onChange={(values) => {
                                      setPersonalDetails({
                                        ...personalDetails,
                                        job_type: values,
                                      })
                                    }}
                                    dropdownPosition="auto"
                                  />
                                </span>
                              </div>
                            }
                          </div>

                          <div className="p-2 border-0 d-flex flex-wrap align-items-center col-12 col-md-6 col-xl-4">
                            {
                              profilePageAllContent ?
                                <span className="pe-2">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                                    <path d="M14.2526 11.875H12.6693V13.4583H14.2526M14.2526 8.70833H12.6693V10.2917H14.2526M15.8359 15.0417H9.5026V13.4583H11.0859V11.875H9.5026V10.2917H11.0859V8.70833H9.5026V7.125H15.8359M7.91927 5.54167H6.33594V3.95833H7.91927M7.91927 8.70833H6.33594V7.125H7.91927M7.91927 11.875H6.33594V10.2917H7.91927M7.91927 15.0417H6.33594V13.4583H7.91927M4.7526 5.54167H3.16927V3.95833H4.7526M4.7526 8.70833H3.16927V7.125H4.7526M4.7526 11.875H3.16927V10.2917H4.7526M4.7526 15.0417H3.16927V13.4583H4.7526M9.5026 5.54167V2.375H1.58594V16.625H17.4193V5.54167H9.5026Z" fill="#595959" />
                                  </svg>
                                </span>
                                :
                                null
                            }

                            {editClick === false ?
                              <span className={profilePageAllContent ? "col" : "placeholder p-2 col-12 rounded-1"} >
                                {personalDetails?.sector?.length ? personalDetails?.sector?.map((v) => v?.label)?.join(",") : "None"}
                              </span>
                              :
                              <div className="col">
                                <span>
                                  <Select
                                    color='#ffa32d'
                                    options={jsonOnly?.sectors}
                                    className="rounded-2 custom_react_dropdown react-dropdown-select-single py-2"
                                    values={personalDetails?.sector}
                                    placeholder="Sector"
                                    onChange={(values) => {
                                      setPersonalDetails({
                                        ...personalDetails,
                                        sector: values,
                                      })
                                    }}
                                    dropdownPosition="auto"
                                  />
                                </span>
                              </div>
                            }
                          </div>

                          <div className="p-2 border-0 d-flex flex-wrap align-items-center col-12 col-md-6 col-xl-4">
                            {
                              profilePageAllContent ?
                                <span className="pe-2">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                    <g clipPath="url(#clip0_1078_4563)">
                                      <path d="M5.25 10.5C5.25 10.6989 5.17098 10.8897 5.03033 11.0303C4.88968 11.171 4.69891 11.25 4.5 11.25H3.75C3.55109 11.25 3.36032 11.171 3.21967 11.0303C3.07902 10.8897 3 10.6989 3 10.5C3 10.3011 3.07902 10.1103 3.21967 9.96967C3.36032 9.82902 3.55109 9.75 3.75 9.75H4.5C4.69891 9.75 4.88968 9.82902 5.03033 9.96967C5.17098 10.1103 5.25 10.3011 5.25 10.5ZM8.25 9.75H7.5C7.30109 9.75 7.11032 9.82902 6.96967 9.96967C6.82902 10.1103 6.75 10.3011 6.75 10.5C6.75 10.6989 6.82902 10.8897 6.96967 11.0303C7.11032 11.171 7.30109 11.25 7.5 11.25H8.25C8.44891 11.25 8.63968 11.171 8.78033 11.0303C8.92098 10.8897 9 10.6989 9 10.5C9 10.3011 8.92098 10.1103 8.78033 9.96967C8.63968 9.82902 8.44891 9.75 8.25 9.75ZM4.5 12.75H3.75C3.55109 12.75 3.36032 12.829 3.21967 12.9697C3.07902 13.1103 3 13.3011 3 13.5C3 13.6989 3.07902 13.8897 3.21967 14.0303C3.36032 14.171 3.55109 14.25 3.75 14.25H4.5C4.69891 14.25 4.88968 14.171 5.03033 14.0303C5.17098 13.8897 5.25 13.6989 5.25 13.5C5.25 13.3011 5.17098 13.1103 5.03033 12.9697C4.88968 12.829 4.69891 12.75 4.5 12.75ZM8.25 12.75H7.5C7.30109 12.75 7.11032 12.829 6.96967 12.9697C6.82902 13.1103 6.75 13.3011 6.75 13.5C6.75 13.6989 6.82902 13.8897 6.96967 14.0303C7.11032 14.171 7.30109 14.25 7.5 14.25H8.25C8.44891 14.25 8.63968 14.171 8.78033 14.0303C8.92098 13.8897 9 13.6989 9 13.5C9 13.3011 8.92098 13.1103 8.78033 12.9697C8.63968 12.829 8.44891 12.75 8.25 12.75ZM4.5 3.75H3.75C3.55109 3.75 3.36032 3.82902 3.21967 3.96967C3.07902 4.11032 3 4.30109 3 4.5C3 4.69891 3.07902 4.88968 3.21967 5.03033C3.36032 5.17098 3.55109 5.25 3.75 5.25H4.5C4.69891 5.25 4.88968 5.17098 5.03033 5.03033C5.17098 4.88968 5.25 4.69891 5.25 4.5C5.25 4.30109 5.17098 4.11032 5.03033 3.96967C4.88968 3.82902 4.69891 3.75 4.5 3.75ZM8.25 3.75H7.5C7.30109 3.75 7.11032 3.82902 6.96967 3.96967C6.82902 4.11032 6.75 4.30109 6.75 4.5C6.75 4.69891 6.82902 4.88968 6.96967 5.03033C7.11032 5.17098 7.30109 5.25 7.5 5.25H8.25C8.44891 5.25 8.63968 5.17098 8.78033 5.03033C8.92098 4.88968 9 4.69891 9 4.5C9 4.30109 8.92098 4.11032 8.78033 3.96967C8.63968 3.82902 8.44891 3.75 8.25 3.75ZM4.5 6.75H3.75C3.55109 6.75 3.36032 6.82902 3.21967 6.96967C3.07902 7.11032 3 7.30109 3 7.5C3 7.69891 3.07902 7.88968 3.21967 8.03033C3.36032 8.17098 3.55109 8.25 3.75 8.25H4.5C4.69891 8.25 4.88968 8.17098 5.03033 8.03033C5.17098 7.88968 5.25 7.69891 5.25 7.5C5.25 7.30109 5.17098 7.11032 5.03033 6.96967C4.88968 6.82902 4.69891 6.75 4.5 6.75ZM8.25 6.75H7.5C7.30109 6.75 7.11032 6.82902 6.96967 6.96967C6.82902 7.11032 6.75 7.30109 6.75 7.5C6.75 7.69891 6.82902 7.88968 6.96967 8.03033C7.11032 8.17098 7.30109 8.25 7.5 8.25H8.25C8.44891 8.25 8.63968 8.17098 8.78033 8.03033C8.92098 7.88968 9 7.69891 9 7.5C9 7.30109 8.92098 7.11032 8.78033 6.96967C8.63968 6.82902 8.44891 6.75 8.25 6.75ZM18 7.5V14.25C17.9988 15.2442 17.6033 16.1973 16.9003 16.9003C16.1973 17.6033 15.2442 17.9988 14.25 18H3.75C2.7558 17.9988 1.80267 17.6033 1.09966 16.9003C0.396661 16.1973 0.00119089 15.2442 0 14.25L0 3.75C0.00119089 2.7558 0.396661 1.80267 1.09966 1.09966C1.80267 0.396661 2.7558 0.00119089 3.75 0L8.25 0C9.2442 0.00119089 10.1973 0.396661 10.9003 1.09966C11.6033 1.80267 11.9988 2.7558 12 3.75H14.25C15.2442 3.75119 16.1973 4.14666 16.9003 4.84966C17.6033 5.55267 17.9988 6.5058 18 7.5ZM3.75 16.5H10.5V3.75C10.5 3.15326 10.2629 2.58097 9.84099 2.15901C9.41903 1.73705 8.84674 1.5 8.25 1.5H3.75C3.15326 1.5 2.58097 1.73705 2.15901 2.15901C1.73705 2.58097 1.5 3.15326 1.5 3.75V14.25C1.5 14.8467 1.73705 15.419 2.15901 15.841C2.58097 16.2629 3.15326 16.5 3.75 16.5ZM16.5 7.5C16.5 6.90326 16.2629 6.33097 15.841 5.90901C15.419 5.48705 14.8467 5.25 14.25 5.25H12V16.5H14.25C14.8467 16.5 15.419 16.2629 15.841 15.841C16.2629 15.419 16.5 14.8467 16.5 14.25V7.5ZM14.25 9.75C14.1017 9.75 13.9567 9.79399 13.8333 9.8764C13.71 9.95881 13.6139 10.0759 13.5571 10.213C13.5003 10.35 13.4855 10.5008 13.5144 10.6463C13.5434 10.7918 13.6148 10.9254 13.7197 11.0303C13.8246 11.1352 13.9582 11.2066 14.1037 11.2356C14.2492 11.2645 14.4 11.2497 14.537 11.1929C14.6741 11.1361 14.7912 11.04 14.8736 10.9167C14.956 10.7933 15 10.6483 15 10.5C15 10.3011 14.921 10.1103 14.7803 9.96967C14.6397 9.82902 14.4489 9.75 14.25 9.75ZM14.25 12.75C14.1017 12.75 13.9567 12.794 13.8333 12.8764C13.71 12.9588 13.6139 13.0759 13.5571 13.213C13.5003 13.35 13.4855 13.5008 13.5144 13.6463C13.5434 13.7918 13.6148 13.9254 13.7197 14.0303C13.8246 14.1352 13.9582 14.2066 14.1037 14.2356C14.2492 14.2645 14.4 14.2497 14.537 14.1929C14.6741 14.1361 14.7912 14.04 14.8736 13.9167C14.956 13.7933 15 13.6483 15 13.5C15 13.3011 14.921 13.1103 14.7803 12.9697C14.6397 12.829 14.4489 12.75 14.25 12.75ZM14.25 6.75C14.1017 6.75 13.9567 6.79399 13.8333 6.8764C13.71 6.95881 13.6139 7.07594 13.5571 7.21299C13.5003 7.35003 13.4855 7.50083 13.5144 7.64632C13.5434 7.7918 13.6148 7.92544 13.7197 8.03033C13.8246 8.13522 13.9582 8.20665 14.1037 8.23559C14.2492 8.26453 14.4 8.24968 14.537 8.19291C14.6741 8.13614 14.7912 8.04002 14.8736 7.91668C14.956 7.79334 15 7.64834 15 7.5C15 7.30109 14.921 7.11032 14.7803 6.96967C14.6397 6.82902 14.4489 6.75 14.25 6.75Z" fill="#595959" />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_1078_4563">
                                        <rect width="18" height="18" fill="white" />
                                      </clipPath>
                                    </defs>
                                  </svg>
                                </span>
                                :
                                null
                            }

                            {editClick === false ?
                              <span className={profilePageAllContent ? "col" : "placeholder p-2 col-12 rounded-1"} >
                                {personalDetails?.industry_sector?.length ? personalDetails?.industry_sector?.map((v) => v?.label)?.join(",") : "None"}
                              </span>
                              :
                              <div className="col">
                                <span>
                                  <Select
                                    color='#ffa32d'
                                    options={jsonOnly?.industry_sector}
                                    className="rounded-2 custom_react_dropdown react-dropdown-select-single py-2"
                                    values={personalDetails?.industry_sector}
                                    placeholder="Industry sector"
                                    onChange={(values) => {
                                      setPersonalDetails({
                                        ...personalDetails,
                                        industry_sector: values,
                                      })
                                    }}
                                    dropdownPosition="auto"
                                  />
                                </span>
                              </div>
                            }
                          </div>

                          <div className="p-2 border-0 d-flex flex-wrap align-items-center col-12 col-md-6 col-xl-4">
                            {
                              profilePageAllContent ?
                                <span >
                                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="26" viewBox="0 0 25 26" fill="none">
                                    <path d="M12.859 7.176L4.74253 12.7089C2.81497 14.0208 3.70459 17.0319 6.035 17.0886L8.75102 17.1547C9.50547 17.1731 10.2077 17.5458 10.6457 18.1604L12.2224 20.3729C13.5752 22.2712 16.561 21.3172 16.5741 18.9891L16.6085 9.16625C16.6153 7.23388 14.4557 6.08755 12.859 7.176Z" stroke="#595959" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                  </svg>
                                </span>
                                :
                                null
                            }

                            {editClick === false ?
                              <span className={profilePageAllContent ? "col" : "placeholder p-2 col-12 rounded-1"} >
                                {personalDetails?.location_preference?.length ? personalDetails?.location_preference?.map((v) => v?.label)?.join(",") : "None"}
                              </span>
                              :
                              <div className="col">
                                <span>
                                  <Select
                                    color='#ffa32d'
                                    options={jsonOnly?.location_preference}
                                    className="rounded-2 custom_react_dropdown react-dropdown-select-single py-2"
                                    values={personalDetails?.location_preference}
                                    placeholder="Location preference"
                                    onChange={(values) => {
                                      setPersonalDetails({
                                        ...personalDetails,
                                        location_preference: values,
                                      })
                                    }}
                                    dropdownPosition="auto"
                                  />
                                </span>
                              </div>
                            }
                          </div>

                          <div className="p-2 border-0 d-flex flex-wrap align-items-center col-12 col-md-6 col-xl-4">
                            {
                              profilePageAllContent ?
                                <span className="pe-2">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                    <g clipPath="url(#clip0_1078_4566)">
                                      <path d="M14.25 3H13.425C13.2509 2.15356 12.7904 1.39301 12.1209 0.846539C11.4515 0.300068 10.6142 0.00109089 9.75 0L8.25 0C7.38585 0.00109089 6.54849 0.300068 5.87906 0.846539C5.20964 1.39301 4.74907 2.15356 4.575 3H3.75C2.7558 3.00119 1.80267 3.39666 1.09966 4.09966C0.396661 4.80267 0.00119089 5.7558 0 6.75L0 14.25C0.00119089 15.2442 0.396661 16.1973 1.09966 16.9003C1.80267 17.6033 2.7558 17.9988 3.75 18H14.25C15.2442 17.9988 16.1973 17.6033 16.9003 16.9003C17.6033 16.1973 17.9988 15.2442 18 14.25V6.75C17.9988 5.7558 17.6033 4.80267 16.9003 4.09966C16.1973 3.39666 15.2442 3.00119 14.25 3ZM8.25 1.5H9.75C10.2137 1.50192 10.6655 1.64706 11.0435 1.91557C11.4216 2.18407 11.7074 2.56282 11.862 3H6.138C6.29256 2.56282 6.57842 2.18407 6.95648 1.91557C7.33453 1.64706 7.7863 1.50192 8.25 1.5ZM3.75 4.5H14.25C14.8467 4.5 15.419 4.73705 15.841 5.15901C16.2629 5.58097 16.5 6.15326 16.5 6.75V9H1.5V6.75C1.5 6.15326 1.73705 5.58097 2.15901 5.15901C2.58097 4.73705 3.15326 4.5 3.75 4.5ZM14.25 16.5H3.75C3.15326 16.5 2.58097 16.2629 2.15901 15.841C1.73705 15.419 1.5 14.8467 1.5 14.25V10.5H8.25V11.25C8.25 11.4489 8.32902 11.6397 8.46967 11.7803C8.61032 11.921 8.80109 12 9 12C9.19891 12 9.38968 11.921 9.53033 11.7803C9.67098 11.6397 9.75 11.4489 9.75 11.25V10.5H16.5V14.25C16.5 14.8467 16.2629 15.419 15.841 15.841C15.419 16.2629 14.8467 16.5 14.25 16.5Z" fill="#595959" />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_1078_4566">
                                        <rect width="18" height="18" fill="white" />
                                      </clipPath>
                                    </defs>
                                  </svg>
                                </span>
                                :
                                null
                            }

                            {editClick === false ?
                              <span className={profilePageAllContent ? "col" : "placeholder p-2 col-12 rounded-1"} >
                                {personalDetails?.functional_specialization_others ?
                                  personalDetails?.functional_specialization_others
                                  :
                                  personalDetails?.functional_specialization?.length ?
                                    personalDetails?.functional_specialization?.map((v) => v?.label)?.join(",")
                                    :
                                    'None'
                                }
                              </span>
                              :
                              <div className="col">
                                <span>
                                  <Select
                                    color='#ffa32d'
                                    options={jsonOnly?.functional_specialization}
                                    className="rounded-2 custom_react_dropdown react-dropdown-select-single py-2"
                                    values={personalDetails?.functional_specialization}
                                    placeholder="Functional specialization"
                                    onChange={(values) => {
                                      setPersonalDetails({
                                        ...personalDetails,
                                        functional_specialization: values,
                                      })
                                    }}
                                    dropdownPosition="auto"
                                  />
                                </span>
                              </div>
                            }
                            <div className={personalDetails?.functional_specialization && editClick ? personalDetails?.functional_specialization[0]?.label === "Others" ? "col-12 d-flex flex-wrap justify-content-end" : 'd-none' : 'd-none'}>
                              <div style={{ width: '95%' }}>
                                <p className="mb-0 ps-1 text-secondary fs-14">Functional specialisation</p>
                                <textarea className="form-control" rows={3}
                                  value={personalDetails?.functional_specialization_others}
                                  onChange={(e) => setPersonalDetails({
                                    ...personalDetails,
                                    functional_specialization_others: e.target.value
                                  })}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="p-2 border-0 d-flex flex-wrap align-items-center col-12 col-md-6 col-xl-4">
                            {
                              profilePageAllContent ?
                                <span className="pe-2">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
                                    <path d="M12.75 7.25C12.75 10.1525 10.23 12.5 7.125 12.5L6.42751 13.34L6.015 13.835C5.6625 14.255 4.9875 14.165 4.755 13.6625L3.75 11.45C2.385 10.49 1.5 8.9675 1.5 7.25C1.5 4.3475 4.02 2 7.125 2C9.39 2 11.3475 3.25251 12.225 5.05251C12.5625 5.72001 12.75 6.4625 12.75 7.25Z" stroke="#595959" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M16.5002 10.145C16.5002 11.8625 15.6152 13.385 14.2502 14.345L13.2452 16.5575C13.0127 17.06 12.3377 17.1575 11.9852 16.73L10.8752 15.395C9.06023 15.395 7.44023 14.5925 6.42773 13.34L7.12523 12.5C10.2302 12.5 12.7502 10.1525 12.7502 7.24998C12.7502 6.46248 12.5627 5.71999 12.2252 5.05249C14.6777 5.61499 16.5002 7.68497 16.5002 10.145Z" stroke="#595959" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M5.25 7.25H9" stroke="#595959" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                  </svg>
                                </span>
                                :
                                null
                            }

                            {editClick === false ?
                              <span className={profilePageAllContent ? "col" : "placeholder p-2 col-12 rounded-1"} >
                                {personalDetails?.mode_of_communication_others ?
                                  personalDetails?.mode_of_communication_others
                                  :
                                  personalDetails?.mode_of_communication?.length ?
                                    personalDetails?.mode_of_communication?.map((v) => v?.label)?.join(",")
                                    :
                                    'None'
                                }
                              </span>
                              :
                              <div className="col">
                                <span>
                                  <Select
                                    multi
                                    color='#ffa32d'
                                    options={mode_of_communication}
                                    className="rounded-2 custom_react_dropdown react-dropdown-select-single py-2"
                                    values={personalDetails?.mode_of_communication}
                                    placeholder="Mode of communication"
                                    onChange={(values) => {
                                      let update_mode_of_communication;
                                      if (values?.length) {
                                        if (values[0]?.label === "Others") {
                                          update_mode_of_communication = mode_of_communication?.map((v) => {
                                            return v?.label === "Others" ? v : { ...v, disabled: true }
                                          })
                                        } else {
                                          update_mode_of_communication = mode_of_communication?.map((v) => {
                                            return v?.label !== "Others" ? v : { ...v, disabled: true }
                                          })
                                        }
                                        set_mode_of_communication(update_mode_of_communication)
                                      } else {
                                        update_mode_of_communication = mode_of_communication?.map((v) => {
                                          return { ...v, disabled: false }
                                        })

                                        set_mode_of_communication(update_mode_of_communication)
                                      }

                                      setPersonalDetails({
                                        ...personalDetails,
                                        mode_of_communication: values,
                                      })
                                    }}
                                    dropdownPosition="auto"
                                  />
                                </span>
                              </div>
                            }

                            <div className={personalDetails?.mode_of_communication && editClick ? personalDetails?.mode_of_communication[0]?.label === "Others" ? "col-12 d-flex flex-wrap justify-content-end" : 'd-none' : 'd-none'}>
                              <div style={{ width: '95%' }}>
                                <p className="mb-0 ps-1 text-secondary fs-14">Mode of communication</p>
                                <textarea className="form-control" rows={3}
                                  value={personalDetails?.mode_of_communication_others}
                                  onChange={(e) => setPersonalDetails({
                                    ...personalDetails,
                                    mode_of_communication_others: e.target.value
                                  })}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3">
                    {resumeName.length > 0 ? (
                      // upload new resume
                      <div className="card border-0 h-100 rounded-4 p-5 new-upload-resume-card">
                        <div className={`card-body ${fileUploadLoading ? "" : "border b"}  rounded-3 pt-4`}>
                          {fileUploadLoading ? (
                            <div className="d-flex justify-content-center align-items-center flex-column h-100">
                              <div
                                className="spinner-border brand-color"
                                role="status"
                              >
                                <span className="visually-hidden ">Loading...</span>
                              </div>
                              <br />
                              {
                                deleteResumeLoading ?
                                  <p className="text-center">Please avoid refreshing or navigating away while the resume is being deleted</p>
                                  :
                                  <p className="text-center">Please avoid refreshing or navigating away while the resume is being parsed</p>
                              }
                            </div>
                          ) : (
                            <>
                              <div className="pb-3 ">
                                <div className="p-3 pb-4 uploaded-resume-container  ">
                                  <div>
                                    <BsFiletypePdf className="pdf-icon text-danger me-3 fs-1 mb-2" />
                                  </div>
                                  <div>
                                    <p className="resume-name mb-1">{resumeName}</p>
                                    <p className="fileUploadedOnText pb-0 mb-0">
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <hr />
                              <div className="px-3  gap-3 mt-2 d-flex float-end align-items-center">
                                <LuTrash id="resumeDeleteButton" className="icon edit-icon fs-4 brand-color" title="Delete Resume" data-bs-toggle="modal" data-bs-target="#deleteResumeModal" />
                                <LuUpload
                                  id="resumeUploadButton"
                                  className="upload-icon fs-4 brand-color"
                                  title="Upload New Resume"
                                  data-bs-toggle="modal"
                                  data-bs-target="#newResumeUploadConfirmationModal"
                                />
                              </div>
                            </>
                          )}
                        </div>
                        {fileUploadLoading && !deleteResumeLoading === true ? (
                          <div className="new-uploading-progress progress mx-5 mb-3 mt-4 " style={{ height: '20px' }}>
                            <div
                              className="pt-2 pb-2 progress-bar bg-brand-color progress-bar-striped progress-bar-animated"
                              role="progressbar"
                              aria-valuenow="99"
                              aria-valuemin="0"
                              aria-valuemax="99"
                              style={{ width: `${progressPercentage}%` }}
                            >
                              <span className="resume-uploading-text">Loading {progressPercentage}%</span>
                            </div>
                          </div>
                        ) : null}
                      </div>
                    ) : (
                      // upload resume
                      <div className="card border-0 h-100 rounded-4 p-5 uploadResumeCard1 " id="uploadResumeCard">
                        <div className="card-body d-flex align-items-center justify-content-center ">
                          {fileUploadLoading ? (
                            <div className="d-flex justify-content-center align-items-center flex-column ">
                              <div
                                className="spinner-border brand-color"
                                role="status"
                              >
                                <span className="visually-hidden ">Loading...</span>
                              </div>
                              <br />
                              {
                                deleteResumeLoading ? "" :
                                  <p className="text-center">Please avoid refreshing or navigating away while the resume is being parsed</p>
                              }
                            </div>

                          ) : (
                            <>
                              <div
                                id="uploadNewResumeField"
                                className={
                                  profilePageAllContent
                                    ? "rounded-4 py-5 uploadResumeCard "
                                    : "border rounded-5 py-5 uploadResumeCard placeholder rounded-2"
                                }
                                data-bs-toggle="modal"
                                data-bs-target="#resumeUploadConfirmationModal"
                              >
                                <input
                                  type="file"
                                  className="form-control"
                                  id="input-file"
                                  hidden
                                  accept=".pdf"
                                  onChange={(e) => {
                                    const file = e.target.files[0];

                                    if (file && file.type !== "application/pdf") {
                                      toast.error("Only PDF files are allowed!");
                                      return;
                                    }
                                    handleResumeUpload(e)
                                  }}
                                />
                                <div className="text-center ">
                                  <div className="fs-3">
                                    <LuUpload />
                                  </div>
                                  <p className="px-5 m-0 pt-3 upload-video-text">
                                    Click here to upload resume
                                  </p>
                                  <span className="unsupported-video-format-text text-grey">(Only PDF format is supported)</span>

                                </div>
                              </div>


                            </>
                          )}


                        </div>
                        {
                          !fileUploadLoading ?
                            profilePageAllContent ?
                              <div className="text-center mt-2 mb-0">
                                <p style={{ fontSize: "14px" }}>
                                  Please convert your resume to PDF format using this link<br />&nbsp;&nbsp;
                                  <a href="https://www.ilovepdf.com/word_to_pdf" target="_blank">click here </a>
                                </p>
                              </div>
                              :
                              <div className=" text-center mt-2 mb-0">
                                <p className="placeholder rounded-2 mx-4" style={{ fontSize: "14px" }}>
                                  Please convert your resume to PDF format using this link<br />&nbsp;&nbsp;
                                  <a href="https://www.ilovepdf.com/word_to_pdf" target="_blank">click here </a>
                                </p>
                              </div>
                            :
                            null
                        }

                        {fileUploadLoading ? (
                          <div className="progress mx-5 mb-3 " style={{ height: '20px' }}>
                            <div
                              className=" progress-bar bg-brand-color progress-bar-striped progress-bar-animated "
                              role="progressbar"
                              aria-valuenow="99"
                              aria-valuemin="0"
                              aria-valuemax="99"
                              style={{ width: `${progressPercentage}%` }}
                            >
                              <span className="resume-uploading-text">Loading {progressPercentage}%</span>
                            </div>
                          </div>
                        ) : null}
                      </div>
                    )}
                  </div>

                  <div className="col">
                    <ProfileInfoEditCard
                      placeholder="Provide a brief description about yourself"
                      content={aboutContent}
                      EditIcon={aboutEditIcon}
                      handleTextAreaChange={handleAboutChange}
                      className="card h-100 border-0 shadow-sm rounded-4"
                      cardHeadingIcon={
                        <FaUserTie
                          className={
                            profilePageAllContent
                              ? "me-4 brand-color fs-4"
                              : "me-4 fs-4 placeholder rounded-2"
                          }
                        />
                      }
                      cardHeading="About"
                      profilePageAllContent={profilePageAllContent}
                      cardSaveIcon={
                        <button
                          id="aboutSaveIcon"
                          type="button"
                          title="Save About"
                          className={profilePageAllContent ? "btn btn-brand-color px-3 d-flex align-items-center gap-2" : "btn px-3 d-flex align-items-center gap-2 placeholder rounded-2"}
                          onClick={(e) => handleAboutEditOrSaveIcon(e, "Save")}
                        >
                          {
                            mobileScreen ?
                              <MdSave />
                              :
                              <>
                                <MdSave /> Save
                              </>
                          }
                        </button>
                      }
                      cardEditIcon={
                        <button
                          id="aboutEditIcon"
                          type="button"
                          className={
                            profilePageAllContent
                              ? "btn btn-outline-brand-color px-3 d-flex align-items-center gap-2"
                              : "btn px-3 d-flex align-items-center gap-2 placeholder rounded-2"
                          }
                          title="Edit About"
                          onClick={(e) => handleAboutEditOrSaveIcon(e, "Edit")}
                        >
                          {
                            mobileScreen ?
                              <MdModeEditOutline />
                              :
                              <>
                                <MdModeEditOutline /> Edit
                              </>
                          }
                        </button>


                      }
                    />
                  </div>
                </div>



                <ProfileInfoAddCard
                  cardHeadingIcon={
                    <PiBagFill
                      className={
                        profilePageAllContent
                          ? "me-4 brand-color fs-4"
                          : "me-4  fs-4 placeholder rounded-2"
                      }
                    />
                  }
                  cardHeading="Experience"
                  data={experienceDataArray}
                  handleEditExperience={handleEditExperience}
                  profilePageAllContent={profilePageAllContent}
                  displayMonth={displayMonth}
                  experienceDataArray={experienceDataArray}
                  setExperienceInputs={setExperienceInputs}
                  setShowingExperienceLocation={setShowingExperienceLocation}
                  mobileScreen={mobileScreen}
                />

                <ProfileInfoAddCard
                  cardHeadingIcon={
                    <FaGraduationCap
                      className={
                        profilePageAllContent
                          ? "me-4 brand-color fs-4"
                          : "me-4  fs-4 placeholder rounded-2"
                      }
                    />
                  }
                  cardHeading="Education"
                  data={educationDataArray}
                  handleEditEducation={handleEditEducation}
                  profilePageAllContent={profilePageAllContent}
                  displayMonth={displayMonth}
                  setEducationInputs={setEducationInputs}
                  setShowingEducationLocation={setShowingEducationLocation}
                  mobileScreen={mobileScreen}
                />

                <div className="card  mt-3 border-0 shadow-sm rounded-4">
                  <div className="card-body">
                    <div className="d-flex justify-content-between ms-1">
                      <label className="profile-side-headers d-flex align-items-center placeholder-glow">
                        <HiLightBulb
                          className={
                            profilePageAllContent
                              ? "me-4 brand-color fs-4"
                              : "me-4  fs-3 placeholder rounded-2"
                          }
                        />
                        <span
                          className={
                            profilePageAllContent
                              ? ""
                              : "placeholder px-3 w-100 py-1  rounded-1"
                          }
                        >
                          Skills
                        </span>
                      </label>
                      <div>
                        {skillsKnown.length > 0 ? (
                          <div className="d-flex gap-2">

                            <button
                              id="editSkillButton"
                              type="button"
                              title="Edit Skill"
                              className={
                                profilePageAllContent
                                  ? "btn btn-outline-brand-color px-3 d-flex align-items-center gap-2"
                                  : "btn px-3 d-flex align-items-center gap-2 placeholder rounded-2"
                              }
                              data-bs-toggle="modal"
                              data-bs-target="#editSkillModalBox "
                              onClick={() => {
                                setSkillsObj({
                                  ...skillsObj,
                                  skillName: "",
                                  skillLevel: "",
                                });
                                setEditSelectedSkillValue(null)

                              }}

                            >
                              {
                                mobileScreen ?
                                  <MdModeEditOutline />
                                  :
                                  <>
                                    <MdModeEditOutline /> Edit
                                  </>
                              }
                            </button>
                            <button
                              id="addSkillButton"
                              type="button"
                              title="Add Skill"
                              className={
                                profilePageAllContent
                                  ? "btn btn-brand-color px-3 d-flex align-items-center gap-2"
                                  : "btn px-3 d-flex align-items-center gap-2 placeholder rounded-2"
                              }
                              data-bs-toggle="modal"
                              data-bs-target="#addSkillModal "
                            >
                              {
                                mobileScreen ?
                                  <MdAddBox />
                                  :
                                  <>
                                    <MdAddBox /> Add
                                  </>
                              }
                            </button>
                          </div>
                        ) : (
                          <button
                            id=""
                            type="button"
                            title="Add Skill"
                            className={
                              profilePageAllContent
                                ? "btn btn-brand-color px-3 d-flex align-items-center gap-2"
                                : "btn px-3 d-flex align-items-center gap-2 placeholder rounded-2"
                            }
                            data-bs-toggle="modal"
                            data-bs-target="#addSkillModal "
                          >
                            {
                              mobileScreen ?
                                <MdAddBox />
                                :
                                <>
                                  <MdAddBox /> Add
                                </>
                            }
                          </button>
                        )}
                      </div>
                    </div>

                    <div className="d-flex justify-content-between align-items-center">
                      <div className="row row-cols-auto ms-5 g-3 profile-descriptions mt-3">
                        {skillsKnown.length === 0 ? (
                          <p
                            className={
                              profilePageAllContent
                                ? "mt-0 word-space-content px-0"
                                : "placeholder px-3 py-2 mt-0 rounded-1"
                            }
                          >
                            Your skills will be displayed here
                          </p>
                        ) : (
                          skillsKnown.sort((a, b) => {
                            const nameA = a.skill_name.toLowerCase(); // ignore upper and lowercase
                            const nameB = b.skill_name.toLowerCase(); // ignore upper and lowercase
                            if (nameA < nameB) {
                              return -1;
                            }
                            if (nameA > nameB) {
                              return 1;
                            }

                            // names must be equal
                            return 0;
                          }).
                            map((skill, index) => {
                              return (
                                <React.Fragment key={skill.id}>
                                  <div className="col mt-0 px-0 me-2">
                                    <div className="border rounded-2 p-2 fw-bold mb-3 skill-name">
                                      {skill.skill_name} {skill.skill_level === "" ? null : "-"}{" "}
                                      <span className="fw-normal">
                                        {skill.skill_level}
                                      </span>
                                    </div>
                                  </div>
                                </React.Fragment>
                              );
                            })
                        )}
                      </div>
                    </div>

                    <br />
                  </div>
                </div>

                <ProfileInfoEditCard
                  placeholder="Share with potential employers about your job preferences"
                  content={preferenceContent}
                  EditIcon={preferenceEditIcon}
                  handleTextAreaChange={handlePreferenceChange}
                  cardHeadingIcon={
                    <MdAppRegistration
                      className={
                        profilePageAllContent
                          ? "me-4 brand-color fs-4"
                          : "me-4  fs-4 placeholder rounded-2"
                      }
                    />
                  }
                  cardHeading="Preference"
                  cardSaveIcon={
                    <button
                      id="preferenceSaveIcon"
                      type="button"
                      title="Save Preference"
                      className={profilePageAllContent ? "btn btn-brand-color px-3 d-flex align-items-center gap-2" : "btn px-3 d-flex align-items-center gap-2 placeholder rounded-2"}
                      onClick={(e) => handlePreferenceEditOrSaveIcon(e, "Save")}
                    >
                      {
                        mobileScreen ?
                          <MdSave />
                          :
                          <>
                            <MdSave /> Save
                          </>
                      }
                    </button>
                  }
                  cardEditIcon={

                    <button
                      id="preferenceEditIcon"
                      type="button"
                      className={
                        profilePageAllContent
                          ? "btn btn-outline-brand-color px-3 d-flex align-items-center gap-2"
                          : "btn px-3 d-flex align-items-center gap-2 placeholder rounded-2"
                      }
                      title="Edit Preference"
                      onClick={(e) => handlePreferenceEditOrSaveIcon(e, "Edit")}
                    >
                      {
                        mobileScreen ?
                          <MdModeEditOutline />
                          :
                          <>
                            <MdModeEditOutline /> Edit
                          </>
                      }
                    </button>
                  }
                  profilePageAllContent={profilePageAllContent}
                  mobileScreen={mobileScreen}
                />

                <div className="row mt-2 g-3 placeholder-glow">
                  <div className="col-12 col-md-6 mb-3 mb-sm-0">
                    <div className="card h-100 border-0 shadow-sm rounded-4 ">
                      <div className="card-body">
                        <div className={`d-flex justify-content-between ms-1 ${videoFullyUploaded || uploadedVideoFile.includes('.mp4') ? "mb-2" : ""}`}>
                          <label className="profile-side-headers d-flex align-items-center">
                            <RiVideoFill
                              className={
                                profilePageAllContent
                                  ? "me-4 brand-color fs-3"
                                  : "me-4 fs-1 placeholder rounded-2"
                              }
                            />
                            <span
                              className={
                                profilePageAllContent
                                  ? ""
                                  : "placeholder px-3 w-100 py-1  rounded-1"
                              }
                            >
                              Video
                            </span>
                          </label>
                          <div>
                            {videoFullyUploaded === true || uploadedVideoFile.includes(".mp4") ? (
                              <div className="d-flex gap-3">
                                <button
                                  type="button"
                                  title="Delete video"
                                  className={
                                    profilePageAllContent
                                      ? "btn btn-outline-brand-color px-3 d-flex align-items-center gap-2"
                                      : "btn  px-3 d-flex align-items-center gap-2 placeholder rounded-2"
                                  }
                                  data-bs-toggle="modal"
                                  data-bs-target="#deleteVideoModal"
                                  disabled={videoUploading === true ? "disabled" : ""}
                                >
                                  <MdDelete />
                                </button>
                                <button
                                  type="button"
                                  className={
                                    profilePageAllContent
                                      ? "btn  btn-brand-color px-3 d-flex align-items-center gap-2"
                                      : "btn px-3 d-flex align-items-center gap-2 placeholder rounded-2"
                                  }
                                  data-bs-toggle="modal"
                                  data-bs-target="#videoUploadModal"
                                  disabled={videoUploading === true ? "disabled" : ""}
                                >
                                  {
                                    mobileScreen ?
                                      <MdAddBox />
                                      :
                                      <>
                                        <MdAddBox /> Upload
                                      </>
                                  }
                                </button>


                              </div>
                            ) : (
                              <button
                                id="uploadProfessionalProfileVideo"
                                type="button"
                                className={
                                  profilePageAllContent
                                    ? "btn btn-brand-color px-3 d-flex align-items-center gap-2"
                                    : "btn px-3 d-flex align-items-center gap-2 placeholder rounded-2"
                                }
                                data-bs-toggle="modal"
                                data-bs-target="#videoUploadModal"
                                disabled={videoUploading === true ? "disabled" : ""}
                              >
                                {
                                  mobileScreen ?
                                    <MdAddBox />
                                    :
                                    <>
                                      <MdAddBox /> Upload video
                                    </>
                                }
                              </button>
                            )}
                          </div>
                        </div>

                        {
                          videoUploadedPlaceholder === true && !uploadedVideoFile.includes('.mp4') ?
                            <div
                              className={
                                profilePageAllContent
                                  ? "mt-3 d-flex justify-content-center align-items-center h-75 p-5 pt-3 text-grey"
                                  : "mt-3 d-flex justify-content-center align-items-center h-75 p-5 pt-3 text-grey placeholder mb-5 ms-5 rounded-2"
                              }
                            >
                              Share a video introducing more about yourself, your
                              experiences, and anything else that might not come
                              across as effectively in writing. Please refrain from
                              sharing any content that incites violence or spreads
                              hate against individuals or groups.
                            </div> :

                            videoUploading === true || videoDeletingLoading === true ? <div
                              className={
                                profilePageAllContent
                                  ? "mt-3 d-flex justify-content-center align-items-center h-75 p-5 pt-3 text-grey"
                                  : "mt-3 d-flex justify-content-center align-items-center h-75 p-5 pt-3 text-grey placeholder mb-5 ms-5 rounded-2"
                              }
                            >
                              <div className="d-flex justify-content-center align-items-center h-100">
                                <div
                                  className="spinner-border brand-color"
                                  role="status"
                                >
                                  <span className="visually-hidden ">
                                    Loading...
                                  </span>
                                </div>
                              </div>
                            </div> :
                              <div className="d-flex justify-content-center mb-4">
                                <VideoPlayer
                                  uploadedVideoFile={uploadedVideoFile}
                                  isVideoUploaded={isVideoUploaded}
                                />
                              </div>

                        }
                      </div>
                    </div>
                  </div>
                  <div className="col col-md-6 placeholder-glow">
                    <div className="card h-100 border-0 shadow-sm rounded-4">
                      <div className="card-body">
                        <div className="d-flex justify-content-between ms-1">
                          <label className="profile-side-headers d-flex align-items-center">
                            <IoLanguage
                              className={
                                profilePageAllContent
                                  ? "me-4 brand-color fs-4"
                                  : "me-4 fs-4 placeholder rounded-2"
                              }
                            />
                            <span
                              className={
                                profilePageAllContent
                                  ? ""
                                  : "placeholder px-3 w-100 py-1  rounded-1"
                              }
                            >
                              Languages
                            </span>
                          </label>
                          <div>
                            {languagesKnown.length > 0 ? (
                              <div className="d-flex gap-2">
                                <button
                                  id="editLanguageButton"
                                  type="button"
                                  className={
                                    profilePageAllContent
                                      ? "btn btn-outline-brand-color px-3 d-flex align-items-center gap-2"
                                      : "btn px-3 d-flex align-items-center gap-2 placeholder rounded-2"
                                  }
                                  title="Edit Languages"
                                  data-bs-toggle="modal"
                                  data-bs-target="#editLanguageModalBox"
                                >
                                  {
                                    mobileScreen ?
                                      <MdModeEditOutline />
                                      :
                                      <>
                                        <MdModeEditOutline /> Edit
                                      </>
                                  }
                                </button>
                                <button
                                  id="addLanguageOuterButton"
                                  type="button"
                                  className={
                                    profilePageAllContent
                                      ? "btn btn-brand-color px-3 d-flex align-items-center gap-2"
                                      : "btn px-3 d-flex align-items-center gap-2 placeholder rounded-2"
                                  }
                                  data-bs-toggle="modal"
                                  data-bs-target="#addLanguageModal"
                                >
                                  {
                                    mobileScreen ?
                                      <MdAddBox />
                                      :
                                      <>
                                        <MdAddBox /> Add
                                      </>
                                  }
                                </button>

                              </div>
                            ) : (
                              <button
                                id="addLanguageAnotherButton"
                                type="button"
                                className={
                                  profilePageAllContent
                                    ? "btn btn-brand-color px-3 d-flex align-items-center gap-2"
                                    : "btn px-3 d-flex align-items-center gap-2 placeholder rounded-2"
                                }
                                data-bs-toggle="modal"
                                data-bs-target="#addLanguageModal"
                              >
                                {
                                  mobileScreen ?
                                    <MdAddBox />
                                    :
                                    <>
                                      <MdAddBox /> Add
                                    </>
                                }
                              </button>
                            )}
                          </div>
                        </div>
                        <div className="ms-5 mt-3 ">
                          {languagesKnown.length === 0 ? (
                            <p
                              className={
                                profilePageAllContent
                                  ? "mt-1 profile-descriptions"
                                  : "mt-1 profile-descriptions placeholder rounded-2"
                              }
                            >
                              Looking to make your profile stand out? Don't forget
                              to add your language skills!
                            </p>
                          ) : (
                            languagesKnown.sort((a, b) => {
                              const nameA = a.language_known.toLowerCase(); // ignore upper and lowercase
                              const nameB = b.language_known.toLowerCase(); // ignore upper and lowercase
                              if (nameA < nameB) {
                                return -1;
                              }
                              if (nameA > nameB) {
                                return 1;
                              }

                              // names must be equal
                              return 0;
                            }).map((language) => {
                              return (
                                <React.Fragment key={language.id}>
                                  {
                                    language.language_known === "" && language.language_level === "" ?
                                      <p
                                        className={
                                          profilePageAllContent
                                            ? "mt-1 profile-descriptions"
                                            : "mt-1 profile-descriptions placeholder rounded-2"
                                        }
                                      >
                                        Looking to make your profile stand out? Don't forget
                                        to add your language skills!
                                      </p> :
                                      <>
                                        <div className="d-flex justify-content-between">
                                          <label className="profile-inner-headers">
                                            {language.language_known}
                                          </label>
                                        </div>
                                        <p className="mt-1 profile-descriptions">
                                          {language.language_level}
                                        </p>
                                        <hr />
                                      </>
                                  }

                                </React.Fragment>
                              );
                            })
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card mt-3 border-0 shadow-sm rounded-4 placeholder-glow">
                  <div className="card-body ">
                    <div className="d-flex justify-content-between ms-1">
                      <label className="profile-side-headers d-flex align-items-center">
                        <MdAddToPhotos
                          className={
                            profilePageAllContent
                              ? "me-4 brand-color fs-4"
                              : "me-4 fs-4 placeholder rounded-2"
                          }
                        />
                        <span
                          className={
                            profilePageAllContent
                              ? ""
                              : "placeholder px-3 w-100 py-1  rounded-1"
                          }
                        >
                          Additional Information
                        </span>
                      </label>

                      <button
                        id="addAdditionalInformationButton"
                        type="button"
                        title="Add Additional Information"
                        className={
                          profilePageAllContent
                            ? "btn btn-brand-color px-3 d-flex align-items-center gap-2"
                            : "btn px-3 d-flex align-items-center gap-2 placeholder rounded-2"
                        }
                        data-bs-toggle="modal"
                        data-bs-target="#additionalInformationModal"
                      >
                        {
                          mobileScreen ?
                            <MdAddBox />
                            :
                            <>
                              <MdAddBox /> Add
                            </>
                        }
                      </button>

                      {

                      }

                    </div>

                    <div className="ms-5 mt-3">

                      {additionalInformationData.length === 0 ? (
                        <p
                          className={
                            profilePageAllContent
                              ? "text-grey"
                              : "text-grey placeholder rounded-2"
                          }
                        >
                          Add other information such as board positions,
                          volunteering roles, certifications, awards, etc.
                        </p>
                      ) : (
                        additionalInformationData.map((info, index) => {
                          return (
                            <React.Fragment key={index}>
                              <div className="additional-information">
                                <div className="d-flex justify-content-between ">
                                  <label className="profile-inner-headers ">
                                    {info.title}
                                  </label>

                                  <button
                                    id="editAdditionalInformationButton"
                                    type="button"
                                    className={
                                      profilePageAllContent
                                        ? "btn btn-outline-brand-color px-3 d-flex align-items-center gap-2"
                                        : "btn px-3 d-flex align-items-center gap-2 placeholder rounded-2"
                                    }
                                    title="Edit additional information"
                                    onClick={(e) => handleAdditionalInformationEdit(e, info.id)}
                                    data-bs-toggle="modal"
                                    data-bs-target="#editInformationModal"
                                  >
                                    {
                                      mobileScreen ?
                                        <MdModeEditOutline />
                                        :
                                        <>
                                          <MdModeEditOutline /> Edit
                                        </>
                                    }
                                  </button>
                                </div>
                                <ul className="mt-1 profile-descriptions ps-3">
                                  <li>{info.description}</li>
                                </ul>
                              </div>
                            </React.Fragment>
                          );
                        })
                      )}
                    </div>
                  </div>
                </div>

                <div className="card mt-3 border-0 shadow-sm rounded-4 placeholder-glow">
                  <div className="card-body">
                    <div className="d-flex justify-content-between ms-1">
                      <label className="profile-side-headers d-flex align-items-center">
                        <IoShareSocialSharp
                          className={
                            profilePageAllContent
                              ? "me-4 brand-color fs-4"
                              : "me-4 fs-4 placeholder rounded-2"
                          }
                        />
                        <span
                          className={
                            profilePageAllContent
                              ? ""
                              : "placeholder px-3 w-100 py-1  rounded-1"
                          }
                        >
                          Social Media Links
                        </span>
                      </label>

                      <button
                        id="addSocialMediaOuterButton"
                        type="button"
                        title="Add Media Social Link"
                        className={
                          profilePageAllContent
                            ? "btn btn-brand-color px-3 d-flex align-items-center gap-2"
                            : "btn px-3 d-flex align-items-center gap-2 placeholder rounded-2"
                        }
                        data-bs-toggle="modal"
                        data-bs-target="#addSocialLinkModal"
                      >
                        {
                          mobileScreen ?
                            <MdAddBox />
                            :
                            <>
                              <MdAddBox /> Add
                            </>
                        }
                      </button>

                    </div>
                    <div className="ms-3 mt-3">
                      <ul className="mt-1 profile-descriptions social-media-links">
                        {socialMediaArray.length === 0 ? (
                          <p
                            className={
                              profilePageAllContent ? "" : "placeholder rounded-2"
                            }
                          >
                            Provide links to your social media accounts such as
                            LinkedIn, X, etc. Please refrain from sharing any
                            content that incites violence or spreads hate against
                            individuals or groups.
                          </p>
                        ) : (
                          socialMediaArray.map((socialMedia, index) => {
                            return (
                              <React.Fragment key={index}>
                                <div className="d-flex justify-content-between align-items-start">
                                  <label className="profile-inner-headers d-block">
                                    {socialMedia.title}
                                  </label>
                                  <button
                                    id="editSocialMediaOuterButton"
                                    type="button"
                                    title="Edit Media Social Link"
                                    className={
                                      profilePageAllContent
                                        ? "btn btn-outline-brand-color px-3 d-flex align-items-center gap-2"
                                        : "btn px-3 d-flex align-items-center gap-2 placeholder rounded-2"
                                    }
                                    data-bs-toggle="modal"
                                    data-bs-target="#editSocialLinkModal"
                                    onClick={(e) =>
                                      handleEditSocialMedia(e, socialMedia.id)
                                    }
                                  >
                                    {
                                      mobileScreen ?
                                        <MdModeEditOutline />
                                        :
                                        <>
                                          <MdModeEditOutline /> Edit
                                        </>
                                    }
                                  </button>
                                </div>
                                <p className="mt-1 profile-descriptions d-flex justify-content-between">
                                  <a
                                    className="social-media-url-link d-inline-block w-75"
                                    href={(socialMedia.url).includes("https://") ? socialMedia.url : `https://${socialMedia.url}`}
                                    target="_blank"
                                  >
                                    {socialMedia.url}
                                  </a>

                                </p>
                                <hr />
                              </React.Fragment>
                            );
                          })
                        )}
                      </ul>
                    </div>
                  </div>
                </div>

                {/* <div className="card mt-3 border-0 shadow-sm rounded-4 position-relative ">
                  <div className="card-body ">
                    <div className="d-flex justify-content-between ms-1">
                      <label className={`profile-side-headers d-flex align-items-center ${mobileScreen ? "mt-5" : ""} ${currentPlan === "Basic" ? "opacity-50" : ""}`}>
                        <RiNotificationBadgeFill
                          className={
                            profilePageAllContent
                              ? "me-4 brand-color fs-4"
                              : "me-4 fs-4 placeholder rounded-2"
                          }
                          style={{ color: `${currentPlan === "Basic" ? "grey" : ""}` }}
                        />
                        <span
                          className={
                            profilePageAllContent
                              ? ""
                              : "placeholder px-3 w-100 py-1  rounded-1"
                          }
                        >
                          Notes from 2nd Careers Experts
                        </span>
                      </label>
                    </div>
                    <div
                      className={
                        profilePageAllContent
                          ? `${mobileScreen ? "mt-2" : ""} premium-account-feauture-container position-absolute top-0 end-0 d-flex align-items-center p-2 me-3 rounded-2`
                          : "premium-account-feauture-container position-absolute top-0 end-0 d-flex align-items-center p-2 me-3 placeholder rounded-2"
                      }
                    >
                      <FaAngleDoubleUp
                        className={
                          profilePageAllContent
                            ? "brand-color fs-3 me-1"
                            : "placeholder fs-3 me-1"
                        }
                      />
                      <span
                        className={
                          profilePageAllContent ? "brand-color" : "placeholder"
                        }
                      >
                        {currentPlan !== "Basic" ? currentPlan : "Upgrade"}
                      </span>
                    </div>
                    <p
                      className={
                        profilePageAllContent
                          ? `ms-5 mt-3 ${currentPlan === "Basic" || expertNotesFromResponse === "" ? "profile-descriptions opacity-50" : "text-dark"}`
                          : "ms-5 mt-3 profile-descriptions placeholder rounded-2"
                      }
                    >
                      {
                        expertNotesFromResponse === "" ?
                          expertNotes
                          :
                          expertNotesFromResponse
                      }
                    </p>


                    <div className={`form-check ms-5 mb-3 ${mobileScreen ? "mb-5" : ""}`}>
                      {
                        checkExpertNotes ?
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value=""
                            id="flexCheckDefault"
                            checked={checkExpertNotes}
                          />
                          :

                          <input
                            className="form-check-input"
                            type="checkbox"
                            value=""
                            id="flexCheckDefault"
                            onChange={expertNotesFromResponse === "" ? null : (e) => setExperNotesCheckConfirmation(e.target.checked)}
                            disabled={expertNotesFromResponse === ""}
                          />
                      }

                      <label
                        className={
                          profilePageAllContent
                            ? "form-check-label consent"
                            : "form-check-label placeholder rounded-2"
                        }
                        htmlFor="flexCheckDefault"
                      >
                        I provide consent to 2nd Careers to market the expert notes
                        and my profile to potential employees
                      </label>
                    </div>
                    {
                      checkExpertNotes ?
                        <button
                          id="approveButton"
                          className={
                            profilePageAllContent
                              ? "btn btn-brand-color mt-3 ms-5 pe-none "
                              : "btn mt-3 ms-5 placeholder rounded-2"
                          }
                        >
                          Approved
                        </button>
                        :
                        <button
                          id="approveButton"
                          className={
                            profilePageAllContent
                              ? "btn btn-brand-color mt-3 ms-5"
                              : "btn mt-3 ms-5 placeholder rounded-2"
                          }
                          onClick={expertNotesFromResponse === "" ? null : handleApproveExpertNotes}
                          disabled={expertNotesFromResponse === ""}
                        >
                          Approve
                        </button>
                    }

                  </div>
                </div> */}
              </div>
            </div>
        }

        {/* Profile Photo upload Modal */}
        <div
          className="modal fade"
          id="profilePhotoModal"
          aria-hidden="true"
          aria-labelledby="exampleModalToggleLabel"
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalToggleLabel">
                  Profile Photo Upload
                </h1>
                <button
                  id="profilePhotoCloseButton"
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <div className="card border-0 h-100 rounded-4">
                  <div className="card-body d-flex align-items-center justify-content-center">
                    <div className="w-100">
                      <div className="text-center position-relative">
                        <img
                          src={profilePicture}
                          className="avatar-xxl rounded-circle"
                          alt=""
                          width={150}
                          height={150}
                        />
                      </div>
                      <p className="mt-3 mb-0 text-center unsupported-video-format-text">(Only jpeg, jpg, png, HEIC formats are supported)</p>
                      <div className="text-center pt-4">
                        <button
                          id="uploadProfilePhotoButton"
                          type="button"
                          htmlFor="fileInput"
                          className="btn btn-brand-color mx-3 upload-btn"
                          data-bs-dismiss="modal"
                          onClick={() =>
                            document.getElementById("profile-photo").click()
                          }
                        >



                          <input
                            type="file"
                            name="profile_pic"
                            id="profile-photo"
                            hidden
                            className="form-control"
                            onChange={handleProfilePhotoUpload}
                          />

                          <span>Upload Photo</span>
                        </button>
                        {
                          profilePicture.includes("default_profile_picture.png") !== true ?
                            <button
                              id="deleteProfilePhotoButton"
                              type="button"
                              className={`btn btn-outline-secondary profile-picture-delete-button`}
                              data-bs-toggle="modal"
                              data-bs-target="#deletePhotoModal"
                            >
                              <span>Delete Photo</span>
                            </button> : null
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade"
          id="deletePhotoModal"
          aria-hidden="true"
          aria-labelledby="deletePhotoModal"
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="deletePhotoModal">
                  Delete Profile Photo
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  id="deleteProfilePhotoModalConfirmationModal"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body text-center pb-4">
                Are you sure you want to delete this photo?
                <div className="text-center pt-4">
                  <button
                    id="cancelProfilePhotoDeleteButton"
                    type="button"
                    className="btn btn-outline-secondary"
                    data-bs-dismiss="modal"
                  >

                    <span>Cancel</span>
                  </button>
                  <button
                    id="deleteProfilePhotoConfirmationButton"
                    type="button"
                    className="btn btn-brand-color mx-3 upload-btn"
                  >
                    <label
                      className="custom-file-label upload-btn"
                      onClick={handleDeleteProfilePicture}
                    >
                      Delete
                    </label>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* About Modal */}
        <div
          className="modal fade"
          id="editAbout"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content p-2">
              <div className="modal-header border-bottom-0">
                <h1 className="modal-title fs-5" id="staticBackdropLabel">
                  About
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <div className="container">
                  <div className="row mb-2 mt-3">
                    <div className="col-lg-12 d-flex justify-content-between">
                      <div>Description</div>
                      <div></div>
                    </div>
                  </div>
                  <div className="container">
                    <div className="row">
                      <textarea
                        id="aboutDescription"
                        className="p-3 rounded-3"
                        rows={15}
                        placeholder="Enter your text here"
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <div className="container">
                  <button
                    type="button"
                    className="btn btn-brand-color w-100 my-2"
                  >
                    Save
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-secondary w-100"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Resume upload confirmation Modal */}
        <div
          className="modal fade"
          id="resumeUploadConfirmationModal"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered modal-md">
            <div className="modal-content p-2">
              <div className="modal-header border-bottom-0">
                <h1
                  className="modal-title  fs-5 d-flex align-items-center"
                  id="staticBackdropLabel"
                >
                  <IoIosInformationCircleOutline className="fs-1 brand-color me-3" />
                  Resume Upload Confirmation
                </h1>
                <button
                  id="closeFreshResumeButton"
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body border-bottom-0">
                <div className="container">
                  <div className="card">
                    <div className="card-body p-4 ">
                      <p className="text-justify mb-5">
                        After uploading the resume, the contents of all fields
                        will be replaced with the content from the resume
                      </p>
                      <p>
                        <span className="brand-color">Note :</span> If you have
                        issues uploading your resume, please try with a
                        different browser
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer  border-top-0 me-2">
                <button
                  id="cancelFreshResumeButton"
                  type="button"
                  className="btn btn-outline-secondary mx-2 my-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  id="uploadFreshResumeButton"
                  type="submit"
                  className="btn btn-brand-color px-3"
                  onClick={handleUploadResumeClick}
                >
                  Upload Resume
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* New Resume upload confirmation Modal */}
        <div
          className="modal fade"
          id="newResumeUploadConfirmationModal"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered modal-md">
            <div className="modal-content p-2">
              <div className="modal-header border-bottom-0">
                <h1
                  className="modal-title fs-5 d-flex align-items-center"
                  id="staticBackdropLabel"
                >
                  <IoIosInformationCircleOutline className="fs-1 brand-color me-3" />
                  New Resume Upload Confirmation
                </h1>
                <button
                  id="resumeCloseButton"
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body border-bottom-0">
                <div className="container">
                  <div className="card">
                    <div className="card-body">
                      <p className="mb-5">
                        Upon uploading the new resume, all fields will be
                        replaced with the content extracted from the new resume.
                      </p>
                      <p>
                        <span className="brand-color">Note :</span> If you have
                        issues uploading your resume, please try with a
                        different browser
                      </p>
                      <input
                        type="file"
                        className="form-control"
                        id="input-file2"
                        hidden
                        accept=".pdf"
                        onChange={(e) => {
                          const file = e.target.files[0];

                          if (file && file.type !== "application/pdf") {
                            toast.error("Only PDF files are allowed!");
                            return;
                          }
                          handleResumeUpload(e)
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer  border-top-0 me-2">

                <button
                  id="uploadResumeCancelButton"
                  type="button"
                  className="btn btn-outline-secondary mx-2 my-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  id="uploadNewResumeButton"
                  type="submit"
                  className="btn btn-brand-color px-3"
                  data-bs-dismiss="modal"
                  onClick={handleUploadNewResumeClick}
                >
                  Upload New Resume
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* After resume AI info Modal */}
        <div
          hidden
          id="aiDisclaimer"
          data-bs-toggle="modal"
          data-bs-target="#aiDisclaimerModal"></div>

        <div
          className="modal fade"
          id="aiDisclaimerModal"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered modal-md">
            <div className="modal-content p-2">
              <div className="modal-header border-bottom-0 mx-auto">
                <h1
                  className="modal-title fs-5 text-center pt-5"
                  id="staticBackdropLabel"
                >

                  <p className=""><img src={require('../assets/images/tickmark.png')} width={50} alt="" /></p>
                  <p className="">Successfully extracted</p>
                </h1>

              </div>
              <div className="modal-body border-bottom-0 p-0">
                <div className="container">
                  <div className="card border-0 p-0">
                    <div className="card-body p-0 ">
                      <div className="mb-0 d-flex px-3">
                        <p className="fw-bold">Note&nbsp;: </p>
                        <p className="ms-2">This is an AI-based resume extraction. Please check all the filled fields carefully. Thank you!!</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer  border-top-0 me-2">

                <button
                  style={{ backgroundColor: '#0cbc0c', color: "#fff" }}
                  id="uploadResumeCancelButton"
                  type="button"
                  className="btn btn-outline-secondary mx-2 my-2 w-100 border-0"
                  data-bs-dismiss="modal"
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Resume delete confirmation Modal */}
        <div
          className="modal fade"
          id="deleteResumeModal"
          aria-hidden="true"
          aria-labelledby="deleteResumeModal"
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h1 className="modal-title fs-5" >
                  Delete Resume
                </h1>
                <button
                  id="uploadResumeCloseButton"
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body text-center pb-4">
                Are you sure to delete this resume?
                <div className="text-center pt-4">
                  <button
                    id="uploadResumeDeleteButton"
                    type="button"
                    className="btn btn-brand-color mx-3 upload-btn"
                    data-bs-dismiss="modal"
                  >
                    <label
                      className="custom-file-label upload-btn"
                      onClick={(e) => handleResumeDelete(e)}
                    >
                      Delete
                    </label>
                  </button>
                  <button
                    id="deleteResumeConfirmationCancelButton"
                    type="button"
                    className="btn btn-outline-secondary"
                    data-bs-dismiss="modal"
                  >
                    <span>Cancel</span>
                  </button>

                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Add Experience Modal */}
        <div
          className="modal fade"
          id="addExperienceModal"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content p-2">
              <div className="modal-header border-bottom-0">
                <h1 className="modal-title fs-5" id="staticBackdropLabel">
                  Add Experience
                </h1>
                <button

                  type="button"
                  id="addExperienceClose"
                  className="btn-close"
                  onClick={() => {
                    setExperienceInputs({
                      jobTitle: "",
                      companyName: "",
                      location: "",
                      startMonthAndYear: "",
                      endMonthAndYear: "",
                      experienceDescription: "",
                    });
                    setShowingExperienceLocation("")
                  }
                  }
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body border-bottom-0">
                <div className="container modal-form-container">
                  <form>
                    <div className="mb-3">
                      <label htmlFor="jobTitle" className="form-label">
                        Job Title
                      </label>
                      <input
                        type="text"
                        required
                        className="form-control"
                        name="jobTitle"
                        id="jobTitle"
                        aria-describedby="jobTitle"
                        placeholder="Enter your job"
                        value={experienceInputs.jobTitle}
                        onChange={handleExperienceInputs}
                      />
                    </div>
                    <div className="mb-3">
                      <label htmlFor="companyName" className="form-label">
                        Company Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="companyName"
                        id="companyName"
                        aria-describedby="companyName"
                        placeholder="Enter your company name"
                        value={experienceInputs.companyName}
                        onChange={handleExperienceInputs}
                      />
                    </div>
                    <div className="mb-3">
                      <label htmlFor="location" className="form-label">
                        Location
                      </label>
                      <div>
                        <Autocomplete
                          id="experienceLocationField"
                          className="professional-profile location-input  w-100 bg-transparent py-2"
                          apiKey={process.env.REACT_APP_GOOGLE_PLACES_KEY}
                          onPlaceSelected={(place) => {
                            if (place) {
                              handleExperienceLocation(place.address_components);
                            }
                          }}
                          style={{ width: "100%" }}
                          required
                          value={showingExperienceLocation}
                          onChange={(e) => setShowingExperienceLocation(e.target.value)}

                        />
                      </div>
                    </div>
                    <div className="row justify-content-between mb-3">
                      <div className="col-lg-6">
                        <label
                          htmlFor="startMonthAndYear"
                          className="form-label"
                        >
                          Start Month & Year
                        </label>
                        <input
                          type={isSafariBrowser ? "date" : "month"}
                          className="form-control"
                          name="startMonthAndYear"
                          id="startMonthAndYear"
                          max={maxMonth}
                          aria-describedby="start-month-and-year"
                          value={experienceInputs.startMonthAndYear}
                          onChange={handleExperienceInputs}
                        />
                      </div>
                      <div className={`col-lg-6 mt-3 mt-lg-0`}>
                        <label htmlFor="endMonthAndYear" className="form-label">
                          End Month & Year
                        </label>
                        {
                          isCurrentlyWorking === true ?
                            <input
                              type="text"
                              className="form-control"
                              disabled
                              value="Present"
                            />
                            :
                            <input
                              type={isSafariBrowser ? "date" : "month"}
                              className="form-control"
                              name="endMonthAndYear"
                              id="endMonthAndYear"
                              min={experienceInputs.startMonthAndYear}
                              max={maxMonth}
                              aria-describedby="end-month-and-year"
                              value={experienceInputs.endMonthAndYear}
                              onChange={handleExperienceInputs}
                            />
                        }
                      </div>
                      <div className="mb-3 form-check ms-3 mt-3">
                        <input type="checkbox" className="form-check-input" id="isCurrentlyWorking" checked={isCurrentlyWorking === true ? true : false} onChange={(e) => handleIsCurrentlyWorking(e)} />
                        <label className="form-check-label text-custom" htmlFor="isCurrentlyWorking">I am Currently working in this company</label>
                      </div>
                    </div>
                    <div>
                      <div className="container pe-0 ps-0">
                        <div className="row mb-2 ">
                          <div className="col-lg-12 d-flex justify-content-between  align-items-center">
                            <div>Description (Optional)</div>
                            <div className="max-char">(Max 900 characters)</div>
                          </div>
                        </div>
                        <div className="container">
                          <div className="row">
                            <textarea
                              id="experienceDescription"
                              className="p-3 rounded-3"
                              name="experienceDescription"
                              required
                              maxLength="900"
                              rows={5}
                              placeholder="Enter your text here"
                              value={experienceInputs.experienceDescription}
                              onChange={handleExperienceInputs}
                            ></textarea>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <div className="modal-footer border-top-0">
                <div className="container">
                  <div className="row float-end">
                    <div className="col-lg-12 ">
                      <button
                        id="addExperienceSaveAndAnotherButton"
                        type="submit"
                        className="btn  btn-outline-secondary my-2 me-2 px-3"
                        onClick={(e) =>
                          handleAddExperience(e, "Save & Add another")
                        }
                      >
                        Save & Add another
                      </button>
                      <button
                        id="addExperienceSaveButton"
                        type="button"
                        className="btn btn-brand-color my-2 px-3"
                        onClick={(e) => handleAddExperience(e, "Save")}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Edit Experience Modal */}
        <div
          className="modal fade"
          id="editExperienceModal"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content p-2">
              <div className="modal-header border-bottom-0">
                <h1 className="modal-title fs-5" id="staticBackdropLabel">
                  Edit Experience
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  id="updateExperienceClose"
                  aria-label="Close"
                  onClick={() => setShowingExperienceLocation("")}
                ></button>
              </div>
              <div className="modal-body border-bottom-0">
                <div className="container modal-form-container">
                  <form>
                    <div className="mb-3">
                      <label htmlFor="jobTitle" className="form-label">
                        Job Title
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="jobTitle"
                        id="jobTitle"
                        aria-describedby="jobTitle"
                        placeholder="Enter your job"
                        value={editExperienceData.jobTitle}
                        onChange={(e) => handleEditExperienceInputs(e)}
                      />
                    </div>
                    <div className="mb-3">
                      <label htmlFor="companyName" className="form-label">
                        Company Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="companyName"
                        id="companyName"
                        aria-describedby="companyName"
                        placeholder="Enter your company name"
                        value={editExperienceData.companyName}
                        onChange={(e) => handleEditExperienceInputs(e)}
                      />
                    </div>
                    <div className="mb-3">
                      <label htmlFor="location" className="form-label">
                        Location
                      </label>
                      <div>
                        <Autocomplete
                          id="editExperienceLocation"
                          className="professional-profile location-input  w-100 bg-transparent py-2"
                          apiKey={process.env.REACT_APP_GOOGLE_PLACES_KEY}
                          onPlaceSelected={(place) => {
                            if (place) {
                              handleExperienceLocation(place.address_components);
                            }
                          }}
                          style={{ width: "100%" }}
                          required
                          value={showingExperienceLocation}
                          onChange={(e) => setShowingExperienceLocation(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="row justify-content-between mb-3">
                      <div className="col-lg-6">
                        <label
                          htmlFor="startMonthAndYear"
                          className="form-label"
                        >
                          Start Month & Year
                        </label>
                        <input
                          type={isSafariBrowser ? "date" : "month"}
                          className="form-control "
                          name="startMonthAndYear"
                          id="startMonthAndYear"
                          max={maxMonth}
                          aria-describedby="start-month-and-year"
                          value={editExperienceData.startMonthAndYear}
                          onChange={(e) => handleEditExperienceInputs(e)}
                        />
                      </div>
                      <div className={`col-lg-6 mt-3 mt-lg-0`}>
                        <label htmlFor="endMonthAndYear" className="form-label">
                          End Month & Year
                        </label>
                        {
                          editIsCurrentlyWorking === true ?
                            <input
                              type="text"
                              className="form-control"
                              disabled
                              value="Present"
                            />
                            :
                            < input
                              type={isSafariBrowser ? "date" : "month"}
                              className="form-control "
                              name="endMonthAndYear"
                              id="endMonthAndYear"
                              max={maxMonth}
                              aria-describedby="end-month-and-year"
                              value={editExperienceData.endMonthAndYear}
                              onChange={(e) => handleEditExperienceInputs(e)}
                            />
                        }
                      </div>
                      <div className="mb-3 form-check ms-3 mt-3">
                        <input type="checkbox" className="form-check-input" id="editIsCurrentlyWorking" checked={editIsCurrentlyWorking === true ? true : false} onChange={(e) => handleEditIsCurrentlyWorking(e)} />
                        <label className="form-check-label text-custom" htmlFor="editIsCurrentlyWorking">I am Currently working in this company</label>
                      </div>
                    </div>
                    <div>
                      <div className="container pe-0 ps-0">
                        <div className="row mb-2 ">
                          <div className="col-lg-12 d-flex justify-content-between align-items-center">
                            <div>Description (Optional)</div>
                            <div className="max-char">(Max 900 characters)</div>
                          </div>
                        </div>
                        <div className="container">
                          <div className="row">
                            <textarea
                              id="editExperienceDescription"
                              className="p-3 rounded-3"
                              name="experienceDescription"
                              required
                              maxLength="900"
                              rows={5}
                              placeholder="Enter your text here"
                              value={editExperienceData.experienceDescription}
                              onChange={(e) => handleEditExperienceInputs(e)}
                            ></textarea>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <div className="modal-footer  border-top-0 me-2">
                <button
                  id="editExperienceDeleteButton"
                  type="button"
                  className="btn btn-outline-secondary mx-2 my-2"
                  data-bs-toggle="modal"
                  data-bs-target="#deleteExperienceModal"
                >
                  Delete
                </button>
                <button
                  id="editExperienceSaveButton"
                  type="submit"
                  className="btn btn-brand-color px-3"
                  onClick={(e) =>
                    handleUpdateExperience(e, editExperienceData.id, "Save")
                  }
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade"
          id="deleteExperienceModal"
          aria-hidden="true"
          aria-labelledby="deleteExperienceModal"
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="deleteExperienceModal">
                  Delete Experience
                </h1>
                <button
                  id="deleteExperienceCloseButton"
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body text-center pb-4">
                Are you sure you want to delete this information?
                <div className="text-center pt-4">

                  <button
                    id="deleteExperienceDeleteButton"
                    type="button"
                    className="btn btn-brand-color mx-3 upload-btn"
                    data-bs-dismiss="modal"
                  >
                    <label
                      className="custom-file-label upload-btn"
                      onClick={(e) =>
                        handleDeleteExperience(e, editExperienceData.id)
                      }
                    >
                      Delete
                    </label>
                  </button>
                  <button
                    id="deleteExperienceCancelButton"
                    type="button"
                    className="btn btn-outline-secondary"
                    data-bs-dismiss="modal"
                  >

                    <span>Cancel</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Add Education Modal */}
        <div
          className="modal fade"
          id="addEducationModal"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content p-2">
              <div className="modal-header border-bottom-0">
                <h1 className="modal-title fs-5" id="staticBackdropLabel">
                  Add Education
                </h1>
                <button
                  type="button"
                  id="addEducationClose"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  onClick={() => {
                    setEducationInputs({
                      degree: "",
                      fieldOfStudy: "",
                      institution: "",
                      instituteLocation: "",
                      educationStartMonthAndYear: "",
                      educationEndMonthAndYear: "",
                    });
                    setShowingEducationLocation("")
                  }
                  }
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body border-bottom-0">
                <div className="container  modal-form-container">
                  <form>
                    <div className="mb-3">
                      <label htmlFor="degree" className="form-label">
                        Degree
                      </label>
                      <input
                        type="text"
                        className="form-control "
                        name="degree"
                        id="degree"
                        aria-describedby="degree"
                        placeholder="Enter your degree"
                        value={educationInputs.degree}
                        onChange={handleEducationInputs}
                      />
                    </div>
                    <div className="mb-3">
                      <label htmlFor="fieldOfStudy" className="form-label">
                        Field of Study
                      </label>
                      <input
                        type="text"
                        className="form-control "
                        name="fieldOfStudy"
                        id="fieldOfStudy"
                        aria-describedby="fieldOfStudy"
                        placeholder="Enter your field of study"
                        value={educationInputs.fieldOfStudy}
                        onChange={handleEducationInputs}
                      />
                    </div>
                    <div className="mb-3">
                      <label htmlFor="institution" className="form-label">
                        School
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="institution"
                        id="institution"
                        aria-describedby="institution"
                        placeholder="Enter your school name"
                        value={educationInputs.institution}
                        onChange={handleEducationInputs}
                      />
                    </div>
                    <div className="mb-3">
                      <label htmlFor="instituteLocation" className="form-label">
                        Location
                      </label>
                      <div>
                        <Autocomplete
                          id="addEducationLocation"
                          className="professional-profile location-input  w-100 bg-transparent py-2"
                          apiKey={process.env.REACT_APP_GOOGLE_PLACES_KEY}
                          onPlaceSelected={(place) => {
                            if (place) {
                              handleEducationLocation(place.address_components);
                            }
                          }}
                          style={{ width: "100%" }}
                          required
                          value={showingEducationLocation}
                          onChange={(e) => setShowingEducationLocation(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="row justify-content-between mb-3">
                      <div className="col-lg-6">
                        <label
                          htmlFor="educationStartMonthAndYear"
                          className="form-label"
                        >
                          Start Month & Year
                        </label>
                        <input
                          type={isSafariBrowser ? "date" : "month"}
                          className="form-control "
                          name="educationStartMonthAndYear"
                          id="educationStartMonthAndYear"
                          max={maxMonth}
                          aria-describedby="education-start-month-and-year"
                          value={educationInputs.educationStartMonthAndYear}
                          onChange={handleEducationInputs}
                        />
                      </div>
                      <div className={`col-lg-6 mt-3 mt-lg-0`}>
                        <label
                          htmlFor="educationEndMonthAndYear"
                          className="form-label"
                        >
                          End Month & Year
                        </label>
                        <input
                          type={isSafariBrowser ? "date" : "month"}
                          className="form-control"
                          name="educationEndMonthAndYear"
                          id="educationEndMonthAndYear"
                          min={educationInputs.educationStartMonthAndYear}
                          max={maxMonth}
                          aria-describedby="education-end-month-and-year"
                          value={educationInputs.educationEndMonthAndYear}
                          onChange={handleEducationInputs}
                        />
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <div className="modal-footer border-top-0">
                <div className="container">
                  <div className="row float-end">
                    <div className="col-lg-12 ">
                      <button
                        id="addEducationSaveAndAnotherButton"
                        type="button"
                        className="btn  btn-outline-secondary  my-2 me-2 px-3"
                        onClick={(e) =>
                          handleAddEducation(e, "Save & Add another")
                        }
                      >
                        Save & Add another
                      </button>
                      <button
                        id="addEducationSaveButton"
                        type="button"
                        className="btn btn-brand-color my-2 px-3"
                        onClick={(e) => handleAddEducation(e, "Save")}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Edit Education Modal */}
        <div
          className="modal fade"
          id="editEducationModal"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content p-2">
              <div className="modal-header border-bottom-0">
                <h1 className="modal-title fs-5" id="staticBackdropLabel">
                  Edit Education
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  id="updateEducationClose"
                  aria-label="Close"
                  onClick={() => setShowingEducationLocation("")}
                ></button>
              </div>
              <div className="modal-body border-bottom-0">
                <div className="container  modal-form-container">
                  <form>
                    <div className="mb-3">
                      <label htmlFor="degree" className="form-label">
                        Degree
                      </label>
                      <input
                        type="text"
                        className="form-control "
                        name="degree"
                        id="degree"
                        aria-describedby="degree"
                        placeholder="Enter your degree"
                        value={editEducationData.degree}
                        onChange={(e) => handleEditEducationInputs(e)}
                      />
                    </div>
                    <div className="mb-3">
                      <label htmlFor="fieldOfStudy" className="form-label">
                        Field of Study
                      </label>
                      <input
                        type="text"
                        className="form-control "
                        name="fieldOfStudy"
                        id="fieldOfStudy"
                        aria-describedby="fieldOfStudy"
                        placeholder="Enter your field of study"
                        value={editEducationData.fieldOfStudy}
                        onChange={(e) => handleEditEducationInputs(e)}
                      />
                    </div>
                    <div className="mb-3">
                      <label htmlFor="institution" className="form-label">
                        School
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="institution"
                        id="institution"
                        aria-describedby="institution"
                        placeholder="Enter your school name"
                        value={editEducationData.institution}
                        onChange={(e) => handleEditEducationInputs(e)}
                      />
                    </div>
                    <div className="mb-3">
                      <label htmlFor="instituteLocation" className="form-label">
                        Location
                      </label>
                      <div>
                        <Autocomplete
                          id="editEducationLocation"
                          className="professional-profile location-input  w-100 bg-transparent py-2"
                          apiKey={process.env.REACT_APP_GOOGLE_PLACES_KEY}
                          onPlaceSelected={(place) => {
                            if (place) {
                              handleEducationLocation(place.address_components);
                            }
                          }}
                          style={{ width: "100%" }}
                          required
                          value={showingEducationLocation}
                          onChange={(e) => setShowingEducationLocation(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="row justify-content-between mb-3">
                      <div className="col-lg-6">
                        <label
                          htmlFor="educationStartMonthAndYear"
                          className="form-label"
                        >
                          Start Month & Year
                        </label>
                        <input
                          type={isSafariBrowser ? "date" : "month"}
                          className="form-control "
                          name="educationStartMonthAndYear"
                          id="educationStartMonthAndYear"
                          max={maxMonth}
                          aria-describedby="education-start-month-and-year"
                          value={editEducationData.educationStartMonthAndYear}
                          onChange={handleEditEducationInputs}
                        />
                      </div>
                      <div className={`col-lg-6 mt-3 mt-lg-0`}>
                        <label
                          htmlFor="educationEndMonthAndYear"
                          className="form-label"
                        >
                          End Month & Year
                        </label>
                        <input
                          type={isSafariBrowser ? "date" : "month"}
                          className="form-control"
                          name="educationEndMonthAndYear"
                          id="educationEndMonthAndYear"
                          min={editEducationData.educationStartMonthAndYear}
                          max={maxMonth}
                          aria-describedby="education-end-month-and-year"
                          value={editEducationData.educationEndMonthAndYear}
                          onChange={handleEditEducationInputs}
                        />
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <div className="modal-footer  border-top-0 me-2">
                <button
                  id="editEducationDeleteButton"
                  type="button"
                  className="btn btn-outline-secondary mx-2 my-2"
                  data-bs-toggle="modal"
                  data-bs-target="#deleteEducationModal"
                >
                  Delete
                </button>
                <button
                  id="editEducationSaveButton"
                  type="submit"
                  className="btn btn-brand-color px-3"
                  onClick={(e) =>
                    handleUpdateEducation(e, editEducationData.id, "Save")
                  }
                >
                  Save
                </button>

              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade"
          id="deleteEducationModal"
          aria-hidden="true"
          aria-labelledby="deleteEducationModal"
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="deleteEducationModal">
                  Delete Education
                </h1>
                <button
                  id="deleteEducationCloseButton"
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body text-center pb-4">
                Are you sure you want to delete this information?
                <div className="text-center pt-4">

                  <button
                    id="deleteEducationDeleteButton"
                    type="button"
                    className="btn btn-brand-color mx-3 upload-btn"
                    data-bs-dismiss="modal"
                  >
                    <label
                      className="custom-file-label upload-btn"
                      onClick={(e) =>
                        handleDeleteEducation(e, editEducationData.id)
                      }
                    >
                      Delete
                    </label>
                  </button>
                  <button
                    id="deleteEducationCancelButton"
                    type="button"
                    className="btn btn-outline-secondary"
                    data-bs-dismiss="modal"
                  >

                    <span>Cancel</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Add Skill Modal */}
        <div
          className="modal fade"
          id="addSkillModal"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
            <div className="modal-content p-2">
              <div className="modal-header border-bottom-0">
                <h1 className="modal-title fs-5 fw-bold" id="staticBackdropLabel">
                  Add Skill
                </h1>
                <button
                  type="button"
                  id="addSkillClose"
                  className="btn-close"
                  onClick={() => {
                    setSkillsObj({
                      skillName: "",
                      skillLevel: "",
                    })
                    setSelectedSkillValue(null)
                  }
                  }
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body border-bottom-0">
                <div className="container">
                  <div className="row justify-content-between mb-3 align-items-end ">
                    <div className="col-lg-5">
                      <label className="form-label  fw-bold">Skill</label>
                      <CreatableSelect
                        options={skillOptions}
                        isClearable
                        onChange={(newValue) => handleSkillName(newValue)}
                        menuPlacement="bottom"
                        menuPortalTarget={document.body}
                        value={selectedSkillValue ? selectedSkillValue : null}
                        placeholder="Select skill"
                        className=""
                        styles={{
                          menu: (base) => ({
                            ...base,
                            maxHeight: '220px',
                            overflowY: 'auto',
                          }),
                          menuPortal: base => ({ ...base, zIndex: 9999 }),
                          option: (providedStyles, props) => ({
                            ...providedStyles,
                            backgroundColor: props.data.__isNew__ && '#e38212',
                            cursor: 'pointer',
                            color: 'black',
                            ":hover": {
                              backgroundColor: '#e38212',
                              color: '#fff'
                            },
                          }),
                          input: (provided) => ({
                            ...provided,
                            cursor: 'pointer', // Change cursor to text type for input

                          }),
                          ":focus": {
                            cursor: 'none'
                          },
                          control: (providedStyles, state) => ({
                            ...providedStyles,
                            borderColor: state.isFocused ? ' #ced4da' : ' #ced4da',
                            '&:hover': {
                              borderColor: '#ced4da',
                            },
                            cursor: "pointer",
                            padding: "0px",
                            boxShadow: state.isFocused ? '0 0 0 0.2px #ced4da' : providedStyles.boxShadow,

                          }),

                        }}

                      />
                    </div>
                    <div className="col-lg-5">
                      <div className="dropdown custom-dropdown mt-3 ">
                        <label className="form-label  fw-bold">Skill Level</label>
                        <button
                          id="addModalSelectSkillLevelField"
                          className="btn btn-secondary dropdown-toggle w-100 select-level-dropdown-button"
                          type="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          {skillsObj.skillLevel === ""
                            ? <span style={{ color: 'grey' }}>Select skill level</span>
                            : skillsObj.skillLevel}
                        </button>
                        <ul className="dropdown-menu ">
                          <li onClick={() => handleSkillLevel("Beginner")}>
                            <a className="dropdown-item">Beginner</a>
                          </li>
                          <li
                            onClick={() => handleSkillLevel("Intermediate")}
                          >
                            <a className="dropdown-item">Intermediate</a>
                          </li>
                          <li onClick={() => handleSkillLevel("Advanced")}>
                            <a className="dropdown-item">Advanced</a>
                          </li>
                          <li onClick={() => handleSkillLevel("Expert")}>
                            <a className="dropdown-item">Expert</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="col-lg-2 ">
                      <button
                        id="addModalAddSkillButton"
                        type="button"
                        className={`btn btn-brand-color d-block mt-3`}
                        onClick={() =>
                          handleAddSkill(
                            skillsObj.skillName,
                            skillsObj.skillLevel
                          )
                        }
                      >
                        Add Skill
                      </button>
                    </div>
                  </div>


                  <div className="mb-3 mt-5">
                    <label htmlFor="grade" className="form-label fw-bold">
                      Skills
                    </label>
                    <table className="table">
                      <tbody>
                        {skillsKnown.length === 0 ? (
                          <>
                            <tr className="ms-3 d-block text-grey border p-3 rounded-1 mt-2">
                              <td className="border-0 text-grey">
                                No skills found
                              </td>
                            </tr>
                          </>
                        ) : (
                          skillsKnown.map((skill, index) => {
                            return (
                              <React.Fragment key={skill.id}>
                                <tr className="text-start ms-3">
                                  <td className="skill-name">{`${skill.skill_name}`}</td>
                                  <td>-</td>
                                  <td>{skill.skill_level}</td>
                                </tr>
                              </React.Fragment>
                            );
                          })
                        )}
                      </tbody>
                    </table>
                  </div>
                  {/* </form> */}
                </div>
              </div>
              <div className="modal-footer border-top-0">
                <div className="container">
                  <div className="row float-end">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Edit Skill Modal Box*/}
        <div
          className="modal fade"
          id="editSkillModalBox"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
            <div className="modal-content p-2">
              <div className="modal-header border-bottom-0">
                <h1 className="modal-title fs-5 fw-bold" id="staticBackdropLabel">
                  Edit Skill
                </h1>
                <button
                  type="button"
                  id="addSkillClose"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  onClick={handleEditSkillDropdownClose}
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body border-bottom-0">
                <div className="container">
                  <form>
                    <div className="row justify-content-between mb-3 align-items-end">
                      <div className="col-lg-5">
                        <label className="form-label fw-bold">Skill</label>
                        <div className="dropdown custom-dropdown">

                          <CreatableSelect
                            options={skillOptions}
                            isDisabled={true}
                            isClearable
                            onChange={(newValue) => handleEditSkillName(newValue)}
                            menuPlacement="bottom"
                            menuPortalTarget={document.body}
                            value={editSelectedSkillValue ? editSelectedSkillValue : ""}
                            placeholder="Select skill"
                            className={editSkillClick ? "textTransform" : "pe-none"}
                            styles={{

                              menu: (base) => ({
                                ...base,
                                maxHeight: '220px',
                                overflowY: 'auto',
                              }),
                              menuPortal: base => ({ ...base, zIndex: 9999 }),
                              option: (providedStyles, props) => ({
                                ...providedStyles,
                                backgroundColor: props.data.__isNew__ && '#e38212',
                                cursor: 'pointer',
                                color: 'black',
                                ":hover": {
                                  backgroundColor: '#e38212',
                                  color: '#fff'
                                },


                              }),
                              control: (providedStyles, state) => ({
                                ...providedStyles,

                                borderColor: state.isFocused ? '#ced4da' : ' #ced4da',
                                '&:hover': {
                                  borderColor: '#ced4da',
                                },
                                cursor: "pointer",
                                padding: "0px",
                                boxShadow: state.isFocused ? '0 0 0 0.2px #ced4da' : providedStyles.boxShadow,

                              }),

                            }}

                          />

                          <ul className="dropdown-menu  edit-skill-dropdown-menu ">
                            {skillsData.map((skill) => {
                              return (
                                <React.Fragment key={skill.id}>
                                  <li
                                    onClick={() =>
                                      handleUpdatedSkillName(skill.skillName)
                                    }
                                  >
                                    <a className="dropdown-item text-wrap ">
                                      {skill.skillName}
                                    </a>
                                  </li>
                                </React.Fragment>
                              );
                            })}
                          </ul>
                        </div>


                      </div>
                      <div className="col-lg-5">
                        <div className="dropdown custom-dropdown mt-3 ">
                          <label className="form-label fw-bold">Skill Level</label>
                          <button
                            className="btn btn-secondary dropdown-toggle w-100 edit-select-level-dropdown-button "
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            disabled={
                              editSkillClick === false ? "disabled" : ""
                            }
                          >
                            {updatedSkillsObj.skillLevel === "" ||
                              editSkillClick === false
                              ? <span style={{ color: "#373737" }} >Select skill level</span>
                              : updatedSkillsObj.skillLevel}
                          </button>
                          <ul className={`dropdown-menu ${editSkillClick ? "" : "hide"}`}>
                            <li
                              onClick={() =>
                                handleUpdatedSkillLevel("Beginner")
                              }
                            >
                              <a className="dropdown-item">Beginner</a>
                            </li>
                            <li
                              onClick={() =>
                                handleUpdatedSkillLevel("Intermediate")
                              }
                            >
                              <a className="dropdown-item">Intermediate</a>
                            </li>
                            <li
                              onClick={() =>
                                handleUpdatedSkillLevel("Advanced")
                              }
                            >
                              <a className="dropdown-item">Advanced</a>
                            </li>
                            <li
                              onClick={() => handleUpdatedSkillLevel("Expert")}
                            >
                              <a className="dropdown-item">Expert</a>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="col-lg-2 ">
                        <button
                          id="editSkillUpdateButton"
                          type="button"
                          disabled={editSkillClick === false ? "disabled" : ""}
                          className="btn btn-brand-color d-block  mt-3"
                          onClick={(e) => handleUpdateSkill(e, selectedSkillId)}
                        >
                          Update
                        </button>
                      </div>
                    </div>

                    <div className="mb-3">
                      <label htmlFor="grade" className="form-label fw-bold mt-3">
                        Skills
                      </label>
                      <table className="table">
                        <tbody>
                          {skillsKnown.length === 0 ? (
                            <>
                              <tr className="ms-3 d-block text-grey border p-3 rounded-1 mt-2">
                                <td className="border-0 text-grey">
                                  No skills found
                                </td>
                              </tr>
                            </>
                          ) : (
                            skillsKnown.map((skill, index) => {
                              return (
                                <React.Fragment key={skill.id}>
                                  <tr className="text-start">
                                    <td className="skill-name">{skill.skill_name}</td>
                                    <td>-</td>
                                    <td>{skill.skill_level}</td>
                                    <td className="text-center">
                                      <span className="mx-3">
                                        <FiEdit
                                          id={`editSingleSkill${skill.id}`}
                                          className="fs-4 react-icon fw-lighter"
                                          title="Edit Skill"
                                          onClick={(e) =>
                                            handleEditSkill(e, skill.id)
                                          }
                                        />
                                      </span>
                                      <span>
                                        <LuTrash
                                          id={`deleteSingleSkill${skill.id}`}
                                          className="fs-4 react-icon"
                                          title="Delete Skill"
                                          onClick={(e) =>
                                            handleDeleteSkill(e, skill.id)
                                          }
                                        />
                                      </span>
                                    </td>
                                  </tr>
                                </React.Fragment>
                              );
                            })
                          )}
                        </tbody>
                      </table>
                    </div>
                  </form>
                </div>
              </div>
              <div className="modal-footer border-top-0">
                <div className="container">
                  <div className="row float-end">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Edit Preference Modal */}
        <div
          className="modal fade"
          id="editPreference"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content p-2">
              <div className="modal-header border-bottom-0">
                <h1 className="modal-title fs-5" id="staticBackdropLabel">
                  Preference
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <div className="container">
                  <div className="row mb-2 mt-3">
                    <div className="col-lg-12 d-flex justify-content-between">
                      <div>Description</div>
                      <div></div>
                    </div>
                  </div>
                  <div className="container">
                    <div className="row">
                      <textarea
                        id="preferenceDescription"
                        className="p-3 rounded-3"
                        rows={15}
                        placeholder="Enter your text here"
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <div className="container">
                  <button
                    type="button"
                    className="btn btn-brand-color w-100 my-2"
                  >
                    Save
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-secondary w-100"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Video upload Modal */}
        <div
          className="modal fade"
          id="videoUploadModal"
          aria-hidden="true"
          aria-labelledby="exampleModalToggleLabel"
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalToggleLabel">
                  Video Upload
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  id="closeVideoModel"
                ></button>
              </div>
              <div className="modal-body">
                <div className="card border-0 h-100 rounded-4">
                  <div className="card-body d-flex align-items-center justify-content-center">
                    <div className="w-100">
                      <div className="text-center position-relative">
                        <div className="col-lg-12">
                          <div className="card border-0 h-100 rounded-4">
                            <div className="card-body d-flex align-items-center justify-content-center">
                              <div
                                id="uploadVideoField"
                                className="rounded-4 py-5 cursorPointer"
                                onClick={() =>
                                  document
                                    .getElementById("introduction-video")
                                    .click()
                                }
                              >
                                <input
                                  type="file"
                                  className="form-control"
                                  id="introduction-video"
                                  name="profile_image"
                                  hidden
                                  // accept="video/mp4,video/x-m4v,video/*"
                                  onChange={handleVideoUpload}
                                  onClick={() =>
                                    document
                                      .getElementById("closeVideoModel")
                                      .click()
                                  }
                                />
                                <div className="text-center">
                                  <div className="fs-1">
                                    <LuUpload />
                                  </div>
                                  <p className="px-5 m-0 pt-3 upload-video-text">
                                    Click here to upload video
                                    <br />

                                  </p>
                                  <span className="unsupported-video-format-text text-grey">(Only MP4 video formats are supported)</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Delete video Modal */}
        <div
          className="modal fade"
          id="deleteVideoModal"
          aria-hidden="true"
          aria-labelledby="deleteVideoModal"
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="deleteVideoModal">
                  Delete Video
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  id="deleteVideoModalConfirmationModal"
                ></button>
              </div>
              <div className="modal-body text-center pb-4">
                Are you sure you want to delete this video?
                <div className="text-center pt-4">
                  <button
                    id="deleteVideoDeleteButton"
                    type="button"
                    className="btn btn-brand-color mx-3 upload-btn"
                    data-bs-dismiss="modal"
                  >
                    <label
                      className="custom-file-label upload-btn"
                      // onClick={() => setVideoFile(false)}
                      onClick={handleDeleteVideo}
                    >
                      Delete
                    </label>
                  </button>
                  <button
                    id="deleteVideoCancelButton"
                    type="button"
                    className="btn btn-outline-secondary"
                    data-bs-dismiss="modal"
                  >
                    <span>Cancel</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Add Language Modal */}
        <div
          className="modal fade"
          id="addLanguageModal"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content p-2">
              <div className="modal-header border-bottom-0">
                <h1 className="modal-title fs-5 fw-bold" id="staticBackdropLabel">
                  Add Language
                </h1>
                <button
                  type="button"
                  id="addLanguageClose"
                  className="btn-close"
                  onClick={() =>
                    setLanguagesObj({
                      languageName: "",
                      languageLevel: "",
                    })
                  }
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body border-bottom-0">
                <div className="container">
                  <form>
                    <div className="row justify-content-between mb-3 align-items-end">
                      <div className="col-lg-5">
                        <label className="form-label fw-bold">Language</label>

                        {/* <div className="dropdown custom-dropdown ">
                          <button
                            id="addLanguageFieldButton"
                            className="btn btn-secondary dropdown-toggle w-100 languages-dropdown"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            {languagesObj.languageName === ""
                              ? <span style={{ color: 'grey' }}>Select your Language</span>
                              : languagesObj.languageName}
                          </button>
                          <ul className="dropdown-menu language-name-dropdown-menu" >
                            {languagesList.map((language) => {
                              return (
                                <React.Fragment key={language.id}>
                                  <li
                                    onClick={() =>
                                      handleLanguageName(language.languageName)
                                    }
                                  >
                                    <a className="dropdown-item">
                                      {language.languageName}
                                    </a>
                                  </li>
                                </React.Fragment>
                              );
                            })}
                          </ul>
                        </div> */}

                        <CreatableSelect
                          options={languagesListArray}
                          isValidNewOption={() => false}  // Disable option creation
                          isClearable
                          onChange={(newValue) => handleLanguageName(newValue)}
                          menuPlacement="bottom"
                          menuPortalTarget={document.body}
                          value={selectedLanguageValue ? selectedLanguageValue : null}
                          placeholder="Select your language"
                          className=""
                          styles={{
                            menu: (base) => ({
                              ...base,
                              maxHeight: '220px',
                              overflowY: 'auto',
                            }),
                            menuPortal: base => ({ ...base, zIndex: 9999 }),
                            option: (providedStyles, props) => ({
                              ...providedStyles,
                              backgroundColor: props.data.__isNew__ && '#e38212',
                              cursor: 'pointer',
                              color: 'black',
                              ":hover": {
                                backgroundColor: '#e38212',
                                color: '#fff'
                              },
                            }),
                            input: (provided) => ({
                              ...provided,
                              cursor: 'pointer', // Change cursor to text type for input

                            }),
                            ":focus": {
                              cursor: 'none'
                            },
                            control: (providedStyles, state) => ({
                              ...providedStyles,
                              borderColor: state.isFocused ? ' #ced4da' : ' #ced4da',
                              '&:hover': {
                                borderColor: '#ced4da',
                              },
                              cursor: "pointer",
                              padding: "0px",
                              boxShadow: state.isFocused ? '0 0 0 0.2px #ced4da' : providedStyles.boxShadow,

                            }),

                          }}

                        />

                      </div>
                      <div className="col-lg-5">
                        <div className="dropdown custom-dropdown mt-3 ">
                          <label className="form-label fw-bold">Language Level</label>
                          <button
                            id="addLanguageLevelButton"
                            className="btn btn-secondary dropdown-toggle w-100"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            {languagesObj.languageLevel === ""
                              ? <span style={{ color: 'grey' }}>Select language level</span>
                              : languagesObj.languageLevel}
                          </button>
                          <ul className="dropdown-menu">
                            {languageLevelData.map((languageLevel) => {
                              return (
                                <React.Fragment key={languageLevel.id}>
                                  <li
                                    onClick={() =>
                                      handleLanguageLevel(
                                        languageLevel.languageLevel
                                      )
                                    }
                                  >
                                    <a className="dropdown-item">
                                      {languageLevel.languageLevel}
                                    </a>
                                  </li>
                                </React.Fragment>
                              );
                            })}
                          </ul>
                        </div>
                      </div>
                      <div className="col-lg-2 text-end mt-3">
                        <button
                          id="addLanguageModalAddButton"
                          type="button"
                          className="btn btn-brand-color"
                          onClick={() =>
                            handleAddLanguage(
                              languagesObj.languageName,
                              languagesObj.languageLevel
                            )
                          }
                        >
                          Add
                        </button>
                      </div>
                    </div>

                    <div className="mb-3">
                      <label htmlFor="grade" className="form-label fw-bold mt-3">
                        Languages
                      </label>
                      <table className="table">
                        <tbody>
                          {languagesKnown.length === 0 ? (
                            <>
                              <tr className="ms-3 d-block text-grey border p-3 rounded-1 mt-2">
                                <td className="border-0 text-grey">
                                  No Languages found
                                </td>
                              </tr>
                            </>
                          ) : (
                            languagesKnown.sort((a, b) => {
                              const nameA = a.language_known.toLowerCase(); // ignore upper and lowercase
                              const nameB = b.language_known.toLowerCase(); // ignore upper and lowercase
                              if (nameA < nameB) {
                                return -1;
                              }
                              if (nameA > nameB) {
                                return 1;
                              }

                              // names must be equal
                              return 0;
                            }).map((language) => {
                              return (
                                <tr key={language.id} className="text-start">
                                  <td>{language.language_known}</td>
                                  <td>-</td>
                                  <td>{language.language_level}</td>
                                </tr>
                              );
                            })
                          )}
                        </tbody>
                      </table>
                    </div>
                  </form>
                </div>
              </div>
              <div className="modal-footer border-top-0">
                <div className="container">
                  <div className="">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Edit Language Modal */}
        <div
          className="modal fade"
          id="editLanguageModal"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content p-2">
              <div className="modal-header border-bottom-0">
                <h1 className="modal-title fs-5 " id="staticBackdropLabel">
                  Edit Language
                </h1>
                <button

                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body border-bottom-0">
                <div className="container">
                  <form>
                    <div className="mb-3">
                      <table className="table">
                        <tbody>
                          {languagesKnown.length === 0 ? (
                            <>
                              <tr className="ms-3 d-block text-grey border p-3 rounded-1 mt-2">
                                <td className="border-0 text-grey">
                                  No Languages found
                                </td>
                              </tr>
                            </>
                          ) : (
                            languagesKnown.map((language) => {
                              return (
                                <tr key={language.id} className="text-center">
                                  <td>{language.language_known}</td>
                                  <td>-</td>
                                  <td>{language.language_level}</td>
                                  <td className="text-center">
                                    <span
                                      onClick={(e) =>
                                        handleDeleteLanguage(
                                          e,
                                          selectedLanguageId
                                        )
                                      }
                                    >
                                      <LuTrash className="fs-4 react-icon" />
                                    </span>
                                  </td>
                                </tr>
                              );
                            })
                          )}
                        </tbody>
                      </table>
                    </div>
                  </form>
                </div>
              </div>
              <div className="modal-footer  border-top-0">
                <button
                  type="submit"
                  className="btn btn-brand-color me-4 px-3"
                  data-bs-dismiss="modal"
                  onClick={() =>
                    toast.success("Languages updated successfully")
                  }
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Edit Language Modal Box */}
        <div
          className="modal fade"
          id="editLanguageModalBox"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >

          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content p-2">
              <div className="modal-header border-bottom-0">
                <h1 className="modal-title fs-5 fw-bold" id="staticBackdropLabel">
                  Edit Language
                </h1>
                <button
                  id="editLanguageCloseButton"
                  type="button"
                  className="btn-close"
                  onClick={() => setEditLanguageClick(false)}
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body border-bottom-0">
                <div className="container">
                  <form>
                    <div className="row justify-content-between mb-3 align-items-end">
                      <div className="col-lg-5">
                        <label className="form-label fw-bold">Language Name</label>
                        {/* <div className="dropdown custom-dropdown">
                          <button
                            className="btn btn-secondary dropdown-toggle w-100"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            disabled
                          >
                            {updatedLanguagesObj.languageName === "" ||
                              editLanguageClick === false
                              ? "Select language"
                              : updatedLanguagesObj.languageName}
                          </button>
                          <ul className="dropdown-menu">
                            {languagesList.map((language) => {
                              return (
                                <React.Fragment key={language.id}>
                                  <li
                                    onClick={() =>
                                      handleUpdatedLanguageName(
                                        language.languageName
                                      )
                                    }
                                  >
                                    <a className="dropdown-item">
                                      {language.languageName}
                                    </a>
                                  </li>
                                </React.Fragment>
                              );
                            })}
                          </ul>
                        </div> */}

                        <CreatableSelect
                          options={languagesListArray}
                          isValidNewOption={() => false}  // Disable option creation
                          isDisabled={true}
                          isClearable
                          onChange={(newValue) => handleEditLanguageName(newValue)}
                          menuPlacement="bottom"
                          menuPortalTarget={document.body}
                          value={editSelectedLangaugeValue ? editSelectedLangaugeValue : ""}
                          placeholder="Select language"
                          className={editLanguageClick ? "textTransform" : "pe-none"}
                          styles={{

                            menu: (base) => ({
                              ...base,
                              maxHeight: '220px',
                              overflowY: 'auto',
                            }),
                            menuPortal: base => ({ ...base, zIndex: 9999 }),
                            option: (providedStyles, props) => ({
                              ...providedStyles,
                              backgroundColor: props.data.__isNew__ && '#e38212',
                              cursor: 'pointer',
                              color: 'black',
                              ":hover": {
                                backgroundColor: '#e38212',
                                color: '#fff'
                              },


                            }),
                            control: (providedStyles, state) => ({
                              ...providedStyles,

                              borderColor: state.isFocused ? '#ced4da' : ' #ced4da',
                              '&:hover': {
                                borderColor: '#ced4da',
                              },
                              cursor: "pointer",
                              padding: "0px",
                              boxShadow: state.isFocused ? '0 0 0 0.2px #ced4da' : providedStyles.boxShadow,

                            }),

                          }}

                        />
                      </div>
                      <div className="col-lg-5">
                        <div className="dropdown custom-dropdown mt-3 ">
                          <label className="form-label fw-bold">Language Level</label>
                          <button
                            className="btn btn-secondary dropdown-toggle w-100"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            disabled={
                              editLanguageClick === false ? "disabled" : ""
                            }
                          >
                            {updatedLanguagesObj.languageLevel === "" ||
                              editLanguageClick === false
                              ? "Select language level"
                              : updatedLanguagesObj.languageLevel}
                          </button>
                          <ul className="dropdown-menu">
                            {languageLevelData.map((languageLevel) => {
                              return (
                                <React.Fragment key={languageLevel.id}>
                                  <li
                                    onClick={() =>
                                      handleUpdatedLanguageLevel(
                                        languageLevel.languageLevel
                                      )
                                    }
                                  >
                                    <a className="dropdown-item">
                                      {languageLevel.languageLevel}
                                    </a>
                                  </li>
                                </React.Fragment>
                              );
                            })}
                          </ul>
                        </div>
                      </div>
                      <div className="col-lg-2 ">
                        <button
                          id="updateLanguageButton"
                          type="button"
                          disabled={
                            editLanguageClick === false ? "disabled" : ""
                          }
                          className="btn btn-brand-color d-block  mt-3"
                          onClick={(e) =>
                            handleUpdateLanguage(e, selectedLanguageId)
                          }
                        >
                          Update
                        </button>
                      </div>
                    </div>

                    <div className="mb-3">
                      <label htmlFor="grade" className="form-label fw-bold mt-3">
                        Languages
                      </label>
                      <table className="table">
                        <tbody>
                          {languagesKnown.length === 0 ? (
                            <>
                              <tr className="ms-3 d-block text-grey border p-3 rounded-1 mt-2">
                                <td className="border-0 text-grey">
                                  No Languages found
                                </td>
                              </tr>
                            </>
                          ) : (
                            languagesKnown.map((language, index) => {
                              return (
                                <React.Fragment key={language.id}>
                                  <tr className="text-start">
                                    <td>{language.language_known}</td>
                                    <td>-</td>
                                    <td>{language.language_level}</td>
                                    <td className="text-center">
                                      <span className="mx-3">
                                        <FiEdit
                                          id="editLanguageIcon"
                                          className="fs-4 react-icon fw-lighter"
                                          title="Edit Language"
                                          onClick={(e) =>
                                            handleEditLanguage(e, language.id)
                                          }
                                        />
                                      </span>
                                      <span>
                                        <LuTrash
                                          id="deleteLanguageIcon"

                                          className="fs-4 react-icon"
                                          title="Delete Language"
                                          onClick={(e) =>
                                            handleDeleteLanguage(e, language.id)
                                          }
                                        />
                                      </span>
                                    </td>
                                  </tr>
                                </React.Fragment>
                              );
                            })
                          )}
                        </tbody>
                      </table>
                    </div>
                  </form>
                </div>
              </div>
              <div className="modal-footer border-top-0">
                <div className="container">
                  <div className="row float-end">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Additional Information Modal */}
        <div
          className="modal fade"
          id="additionalInformationModal"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content p-2">
              <div className="modal-header border-bottom-0">
                <h1 className="modal-title fs-5" id="staticBackdropLabel">
                  Additional Information
                </h1>
                <button
                  type="button"
                  id="addAdditionalInformationClose"
                  className="btn-close"
                  onClick={() =>
                    setAdditionalInformationInputs({
                      additionalInfoTitle: "",
                      additionalInfoDescription: "",
                    })
                  }
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body modal-form-container">
                <div className="container mb-3 ">
                  <label htmlFor="additionalInfoTitle" className="form-label">
                    Title
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="additionalInfoTitle"
                    id="addtionalInfoTitle"
                    maxLength="60"
                    aria-describedby="jobTitle"
                    placeholder="Enter your title"
                    value={additionalInformationInputs.additionalInfoTitle}
                    onChange={handleAdditionalInformationInputs}
                  />
                </div>
                <div className="container">
                  <div className="row mb-2 mt-3">
                    <div className="col-lg-12 d-flex justify-content-between align-items-end">
                      <div>Description</div>
                      <div className="max-char">(Max 900 characters)</div>
                    </div>
                  </div>
                  <div className="container">
                    <div className="row">
                      <textarea
                        id="additionalInformationDescription"
                        className="p-3 rounded-3"
                        name="additionalInfoDescription"
                        rows={10}
                        maxLength="900"
                        placeholder="Enter your text here.."
                        value={
                          additionalInformationInputs.additionalInfoDescription
                        }
                        onChange={handleAdditionalInformationInputs}
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer border-top-0">
                <div className="container">
                  <div className="row float-end">
                    <div className="col-lg-12 ">
                      <button
                        id="additionalInformationCancelButton"
                        type="button"
                        className="btn  btn-outline-secondary  my-2 mx-2 px-3"
                        data-bs-dismiss="modal"

                      >
                        Cancel
                      </button>

                      <button
                        id="additionalInformationSaveButton"
                        type="button"
                        className="btn btn-brand-color my-2"
                        onClick={handleAdditionalInformationAdd}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Edit Information Modal */}
        <div
          className="modal fade"
          id="editInformationModal"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content p-2">
              <div className="modal-header border-bottom-0">
                <h1 className="modal-title fs-5" id="staticBackdropLabel">
                  Edit Additional Information
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  id="updateAdditionalInformationClose"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body modal-form-container">
                <div className="container mb-3">
                  <label htmlFor="additionalInfoTitle" className="form-label">
                    Title
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="additionalInfoTitle"
                    id="addtionalInfoTitle"
                    aria-describedby="jobTitle"
                    placeholder="Enter your title"
                    value={editAdditionalInformationInputs.additionalInfoTitle}
                    onChange={handleEditAdditionalInformationInputs}
                  />
                </div>
                <div className="container ">
                  <div className="row mb-2 mt-3">
                    <div className="col-lg-12 d-flex justify-content-between">
                      <div>Description</div>
                      <div></div>
                    </div>
                  </div>
                  <div className="container">
                    <div className="row">
                      <textarea
                        id="EditAdditionalInformationDescription"
                        className="p-3 rounded-3"
                        name="additionalInfoDescription"
                        rows={10}
                        placeholder="Enter your text here"
                        value={
                          editAdditionalInformationInputs.additionalInfoDescription
                        }
                        onChange={handleEditAdditionalInformationInputs}
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer  border-top-0 me-2">
                <button
                  id="editAdditionalInformationDeleteButton"
                  type="button"
                  className="btn btn-outline-secondary mx-2 my-2"
                  data-bs-toggle="modal"
                  data-bs-target="#deleteAdditionalInformationModal"
                >
                  Delete
                </button>
                <button
                  id="editAdditionalInformationSaveButton"
                  type="submit"
                  className="btn btn-brand-color px-3"
                  onClick={(e) =>
                    handleAdditionalInformationUpdate(
                      e,
                      editAdditionalInformationInputs.id,
                      "Save"
                    )
                  }
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade"
          id="deleteAdditionalInformationModal"
          aria-hidden="true"
          aria-labelledby="deleteSocialLinkModal"
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="deleteSocialLinkModal">
                  Delete Additional Information
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body text-center pb-4 ">
                Are you sure you want to delete this information?
                <div className="text-center pt-4">

                  <button
                    id="editAdditionalInformationDeleteButton"
                    type="button"
                    className="btn btn-brand-color mx-3 upload-btn"
                    data-bs-dismiss="modal"
                  >
                    <label
                      className="custom-file-label upload-btn"
                      onClick={(e) =>
                        handleAdditionalInformationDelete(
                          e,
                          editAdditionalInformationInputs.id
                        )
                      }
                    >
                      Delete
                    </label>
                  </button>
                  <button
                    id="editAdditionalInformationCancelButton"
                    type="button"
                    className="btn btn-outline-secondary"
                    data-bs-dismiss="modal"
                  >

                    <span>Cancel</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Add Social Link Modal */}
        <div
          className="modal fade"
          id="addSocialLinkModal"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content p-2">
              <div className="modal-header border-bottom-0">
                <h1 className="modal-title fs-5" id="staticBackdropLabel">
                  Add Social Link
                </h1>
                <button
                  type="button"
                  id="addSocialLinkMediaClose"
                  className="btn-close"
                  onClick={() =>
                    setSocialMediaInputs({
                      socialMediaName: "",
                      url: "",
                    })
                  }
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body border-bottom-0">
                <div className="container modal-form-container">
                  <form>
                    <div className="mb-3">
                      <label htmlFor="socialMediaName" className="form-label">
                        Social Media Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="socialMediaName"
                        id="socialMediaName"
                        aria-describedby="institution"
                        placeholder="Enter Social Media"
                        value={socialMediaInputs.socialMediaName}
                        onChange={handleSocialMediaInputs}
                      />
                    </div>
                    <div className="mb-3">
                      <label htmlFor="url" className="form-label">
                        URL
                      </label>
                      <input
                        type="text"
                        className="form-control pb-4"
                        name="url"
                        id="url"
                        aria-describedby="degree"
                        placeholder="Enter URL"
                        value={socialMediaInputs.url}
                        onChange={handleSocialMediaInputs}
                      />
                    </div>
                  </form>
                </div>
              </div>
              <div className="modal-footer border-top-0">
                <div className="container">
                  <div className="row float-end">
                    <div className="col-lg-12 ">
                      <button
                        id="addSocialMediaSaveAndAnotherButton"
                        type="submit"
                        className="btn btn-outline-secondary my-2 me-2 px-3"
                        onClick={(e) =>
                          handleAddSocialMedia(e, "Save & Add another")
                        }
                      >
                        Save & Add another
                      </button>
                      <button
                        id="editSocialMediaSaveButton"
                        type="button"
                        className="btn btn-brand-color  my-2 px-3"
                        onClick={(e) => handleAddSocialMedia(e, "Save")}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Edit Social Link Modal */}
        <div
          className="modal fade"
          id="editSocialLinkModal"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content p-2">
              <div className="modal-header border-bottom-0">
                <h1 className="modal-title fs-5" id="staticBackdropLabel">
                  Edit Social Link
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  id="updateSocialLinkMediaClose"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body border-bottom-0">
                <div className="container modal-form-container">
                  <form>
                    <div className="mb-3">
                      <label htmlFor="socialMediaName" className="form-label">
                        Social Media
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="socialMediaName"
                        id="institution"
                        aria-describedby="institution"
                        placeholder="Enter social media"
                        value={editSocialMediaData.socialMediaName}
                        onChange={handleEditSocialMediaData}
                      />
                    </div>
                    <div className="mb-3">
                      <label htmlFor="url" className="form-label">
                        URL
                      </label>
                      <input
                        type="text"
                        className="form-control pb-4"
                        name="url"
                        id="url"
                        aria-describedby="degree"
                        placeholder="Enter URL"
                        value={editSocialMediaData.url}
                        onChange={handleEditSocialMediaData}
                      />
                    </div>
                  </form>
                </div>
              </div>
              <div className="modal-footer  border-top-0 me-2">

                <button
                  id="editSocialMediaDeleteModel"
                  type="button"
                  className="btn btn-outline-secondary mx-2 my-2"
                  data-bs-toggle="modal"
                  data-bs-target="#deleteSocialMediaLinkModal"
                >
                  Delete
                </button>
                <button
                  id="editSocialMediaSaveModel"
                  type="submit"
                  className="btn btn-brand-color px-3"
                  onClick={(e) =>
                    handleUpdateSocialMedia(e, editSocialMediaData.id, "Save")
                  }
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade"
          id="deleteSocialMediaLinkModal"
          aria-hidden="true"
          aria-labelledby="deleteSocialMediaLinkModal"
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h1
                  className="modal-title fs-5"
                  id="deleteSocialMediaLinkModal"
                >
                  Delete Social Media
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body text-center pb-4">
                Are you sure you want to delete this information?
                <div className="text-center pt-4">

                  <button
                    type="button"
                    className="btn btn-brand-color mx-3 upload-btn"
                    data-bs-dismiss="modal"
                  >
                    <label
                      className="custom-file-label upload-btn"
                      onClick={(e) =>
                        handleDeleteSocialMedia(e, editSocialMediaData.id)
                      }
                    >
                      Delete
                    </label>
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    data-bs-dismiss="modal"
                  >

                    <span>Cancel</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {
          profilePageAllContent && Cookie.get("isFirstVisitProfile") ?
            <Joyride
              callback={handleJoyrideCallback}
              styles={{
                options: {
                  width: '500px',
                  borderRadius: "60px"
                },
                buttonNext: {
                  background: '#e38212',
                  outline: 'none'
                },
                buttonSkip: {
                  textDecoration: 'underline'
                },
                buttonBack: {
                  color: '#212529',
                  backgroundColor: '#fff',
                  border: " 0px",
                  borderRadius: "4px",
                  color: "#000",
                  cursor: "pointer",
                  fontSize: "16px",
                  lineHeight: "1",
                  padding: "8px",
                  appearance: "none",
                  outline: "1px solid grey",
                }
              }}
              scrollOffset={300}
              continuous
              disableOverlayClose={true}
              hideCloseButton
              showSkipButton
              showProgress
              steps={steps}
              run={true}
            /> : null
        }
      </section >
    </>
  );
};

export default Profile;